
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dJyLC", function(module, exports) {
const $80210b0d46d06b49$var$_isBlankOrEmpty = (str)=>!str || /^\s*$/.test(str);
const $80210b0d46d06b49$var$_sendAnalyticsEvent = (site, contentId, action, reason, createAnalyticsEvent, caller)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'autoformat',
            actionSubjectId: 'undefinedLink autoformat',
            source: 'AutoformattingProvider',
            attributes: {
                site: site,
                contentId: contentId,
                reason: reason,
                caller: caller
            }
        }
    }).fire();
};
const $80210b0d46d06b49$export$79f57d12dd4f5b6b = (spaceKey, contentId, createAnalyticsEvent, caller)=>({
        '\\[(.*?)\\]\\(\\)': (match)=>{
            // If testing locally, you will need to set 'site' to an actual server such as "https://pug.jira-dev.com". Smart cards don't work with "localhost:8080".
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const site = location.origin;
            const title = match[1];
            if ($80210b0d46d06b49$var$_isBlankOrEmpty(title)) {
                $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'failed', 'empty title', createAnalyticsEvent, caller);
                return Promise.resolve({
                    type: ''
                });
            }
            if (!site || !spaceKey || !contentId) {
                $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'failed', 'missing site name, spaceKey or contentId', createAnalyticsEvent, caller);
                return Promise.resolve({
                    type: ''
                });
            }
            const encodedTitle = encodeURIComponent(title);
            const url = `${site}/wiki/pages/createpage.action?spaceKey=${spaceKey}&title=${encodedTitle}&linkCreation=true&fromPageId=${contentId}`;
            $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'success', 'autoformat succeeded', createAnalyticsEvent, caller);
            return Promise.resolve({
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            });
        }
    });
const $80210b0d46d06b49$export$56f76dd14b7b11cc = (spaceKey, contentId, createAnalyticsEvent, caller)=>({
        getRules: ()=>Promise.resolve({
                ...$80210b0d46d06b49$export$79f57d12dd4f5b6b(spaceKey, contentId, createAnalyticsEvent, caller)
            })
    });
module.exports["createConfluenceAutoformattingProvider"] = $80210b0d46d06b49$export$56f76dd14b7b11cc;

});

parcelRegister("7Ryt2", function(module, exports) {

var $DdJXy = parcelRequire("DdJXy");

class $ac5ec249a3491591$export$16bbef74695765fd extends Error {
    constructor(message, status){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        this.status = void 0;
        Object.setPrototypeOf(this, $ac5ec249a3491591$export$16bbef74695765fd.prototype);
        this.status = status;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}


/**
 * Currently the underlying FE service can only retrieve the first page of results, which is limited at 100 results.
 * See ACT-3418 for upcoming fix.
 */ const $284d31c82e7ca85e$var$DEFAULT_ACTIVITY_COUNT = 100;
class $284d31c82e7ca85e$export$2e2bcd8739ae039 {
    async getRecentItems(limit = $284d31c82e7ca85e$var$DEFAULT_ACTIVITY_COUNT) {
        if (!this.recentPromise) this.recentPromise = this.client.fetchActivities([
            50
        ], {
            rootContainerIds: [
                this.cloudId
            ],
            limit: limit
        }, [
            'viewed'
        ]);
        try {
            const response = await this.recentPromise;
            return response.viewed.map((node)=>({
                    objectId: node.object.id,
                    name: node.object.name || '',
                    container: this.getContainerName(node.containers),
                    url: node.object.url,
                    iconUrl: node.object.icon?.type === 'EMOJI' && node.object.icon.fallback ? node.object.icon.fallback : node.object.icon?.value || '',
                    type: node.object.type,
                    viewedTimestamp: node.timestamp
                })).filter((item)=>Boolean(item.name));
        } catch (err) {
            throw new (0, $ac5ec249a3491591$export$16bbef74695765fd)(err.message, err.code);
        }
    }
    async searchRecent(query) {
        const items = await this.getRecentItems();
        return this.filterItems(items, query);
    }
    /**
   * It should return the closet container's name
   */ getContainerName(containers) {
        for(let i = containers.length - 1; i >= 0; --i){
            const containerName = containers[i].name;
            if (containerName) return containerName;
        }
        return '';
    }
    filterItems(items, searchTerm) {
        if (!searchTerm) return [];
        return items.filter((item)=>{
            return item.name?.toLowerCase()?.includes(searchTerm.toLowerCase());
        });
    }
    /**
   *
   * @param url
   * @param cloudId - this will be transformed into an ARI
   * @param options - @deprecated this is no longer used
   */ constructor(url, cloudId, options = {}){
        this.cloudId = void 0;
        this.client = void 0;
        this.recentPromise = void 0;
        this.cloudId = `ari:cloud:platform::site/${cloudId}`;
        this.client = (0, $DdJXy.createActivityClient)('v3', 'editor', undefined, url);
    }
}


const $7a079a70f1242941$var$ACTIVITY_URL = '/gateway/api/graphql';
async function $7a079a70f1242941$export$a2b55b950e46bdd9(cloudId) {
    return Promise.resolve(new (0, $284d31c82e7ca85e$export$2e2bcd8739ae039)($7a079a70f1242941$var$ACTIVITY_URL, cloudId));
}
module.exports["getActivityProvider"] = $7a079a70f1242941$export$a2b55b950e46bdd9;

});

parcelRegister("3Cz3M", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $2sp5n = parcelRequire("2sp5n");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $iwIwp = parcelRequire("iwIwp");


var $cozmU = parcelRequire("cozmU");


var $7yhDb = parcelRequire("7yhDb");


var $ljOiP = parcelRequire("ljOiP");





const $a1ea65fa13d59a50$var$NativeEmbedUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("6ClSH")).then(({ default: NativeEmbedUIComponent })=>({
            default: NativeEmbedUIComponent
        })));
const $a1ea65fa13d59a50$export$589209289a008d27 = ({ node: node })=>{
    const { parameters: parameters } = node;
    const { url: url } = (0, $ljOiP.getParameters)(parameters);
    const manifest = url ? (0, $iwIwp.getNativeEmbedFacade)().getManifestByUrl(url) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7yhDb.NativeEmbedInitialPlaceholder), {
        manifest: manifest,
        parameters: parameters
    });
};
function $a1ea65fa13d59a50$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ea65fa13d59a50$export$589209289a008d27, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ea65fa13d59a50$var$NativeEmbedUI, props));
}



var $73a6g = parcelRequire("73a6g");


var $krYZG = parcelRequire("krYZG");





var $5Qi6J = parcelRequire("5Qi6J");


var $kCECX = parcelRequire("kCECX");


var $k9wGn = parcelRequire("k9wGn");







var $mW7G5 = parcelRequire("mW7G5");




const $ee20aa2809926709$var$getTransformLocalId = (attrs)=>attrs.localId;
const $ee20aa2809926709$var$LAYOUT_TO_ALIGNMENT = {
    center: 'center',
    'full-width': 'center',
    wide: 'center',
    'wrap-left': 'wrap-left',
    'wrap-right': 'wrap-right',
    'align-start': 'left',
    'align-end': 'right'
};
function $ee20aa2809926709$var$mapLayoutToAlignment(layout = 'center') {
    return $ee20aa2809926709$var$LAYOUT_TO_ALIGNMENT[layout] ?? 'center';
}
function $ee20aa2809926709$export$f7e09b33c87279a2(schema, attrs, api) {
    if (!(0, $mW7G5.expVal)('cc-maui-experiment', 'isEnabled', false) && !(0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience')) return undefined;
    const { url: url, layout: layout = 'center', originalHeight: originalHeight, originalWidth: originalWidth } = attrs;
    if (!(0, $73a6g.isSafeUrl)(url)) return undefined;
    const facade = (0, $iwIwp.getNativeEmbedFacade)();
    // Fast path: synchronous manifest lookup for regular (non-short-link) URLs.
    const manifest = facade.getManifestByUrl(url);
    if (manifest) return $ee20aa2809926709$var$buildNativeEmbedNode(schema, {
        url: url,
        layout: layout,
        originalHeight: originalHeight,
        originalWidth: originalWidth,
        localId: $ee20aa2809926709$var$getTransformLocalId(attrs)
    }, manifest);
    // Async path: for Confluence short-link URLs (/wiki/x/<token>), expand via ORS
    // and retry the manifest lookup with the resolved canonical URL.
    // Uses api.card.actions.resolveShortLinkUrl which accesses the card plugin's
    // internal CardClient — the same one used by all smart cards in the editor.
    if (api?.card?.actions?.resolveShortLinkUrl && (0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience')) return api.card.actions.resolveShortLinkUrl(url).then((resolvedUrl)=>{
        if (!resolvedUrl) return undefined;
        const resolvedManifest = facade.getManifestByUrl(resolvedUrl);
        if (!resolvedManifest) return undefined;
        return $ee20aa2809926709$var$buildNativeEmbedNode(schema, {
            url: resolvedUrl,
            layout: layout,
            originalHeight: originalHeight,
            originalWidth: originalWidth,
            localId: $ee20aa2809926709$var$getTransformLocalId(attrs)
        }, resolvedManifest);
    });
    return undefined;
}
function $ee20aa2809926709$var$buildNativeEmbedNode(schema, attrs, manifest) {
    const { url: url, layout: layout = 'center', originalHeight: originalHeight, originalWidth: originalWidth, localId: localId } = attrs;
    const hasOriginalDimensions = !!(originalWidth && originalHeight);
    const width = originalWidth ?? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).width;
    // Use aspectRatio when we have computed dimensions, or when a width is set/inferred
    // (so the renderer can derive height). Only fall back to a fixed height when there
    // is no width at all, because aspectRatio is meaningless without a width.
    const hasWidth = !!width;
    const { height: _defaultHeight, ...defaultsWithoutHeight } = (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS);
    const macroParams = (0, $ljOiP.setParameters)({}, {
        ...hasWidth ? defaultsWithoutHeight : (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS),
        url: url,
        alignment: $ee20aa2809926709$var$mapLayoutToAlignment(layout),
        width: width,
        aspectRatio: hasOriginalDimensions ? originalWidth / originalHeight : hasWidth ? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).aspectRatio : undefined,
        // height is only stored when there is no width (aspectRatio cannot be used without one)
        ...hasWidth ? {} : {
            height: (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).height
        }
    });
    const extensionAdf = {
        type: 'extension',
        attrs: {
            extensionKey: `${(0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)}:${manifest.id}`,
            extensionType: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
            ...localId ? {
                localId: localId
            } : {},
            parameters: {
                ...macroParams,
                macroMetadata: {
                    url: // Preserved data in case of revert.
                    url,
                    layout: layout,
                    originalHeight: originalHeight ?? undefined,
                    originalWidth: originalWidth ?? undefined
                }
            }
        }
    };
    return (0, $5Qi6J.processRawValue)(schema, extensionAdf);
}
function $ee20aa2809926709$export$a3e392087da04055(schema, node) {
    if (node.type === schema.nodes.embedCard) return $ee20aa2809926709$export$f7e09b33c87279a2(schema, {
        url: node.attrs.url,
        layout: node.attrs.layout,
        width: node.attrs.width,
        originalHeight: node.attrs.originalHeight,
        originalWidth: node.attrs.originalWidth,
        localId: node.attrs.localId
    });
    if (node.type === schema.nodes.paragraph && node.childCount === 1 && node.firstChild?.isText && node.firstChild.marks.length) {
        const linkMarkType = schema.marks.link;
        const linkMark = linkMarkType ? node.firstChild.marks.find((mark)=>mark.type === linkMarkType) : undefined;
        const url = linkMark?.attrs.href;
        if (url) return $ee20aa2809926709$export$f7e09b33c87279a2(schema, {
            url: url,
            layout: 'center',
            width: undefined
        });
    }
    return undefined;
}
function $ee20aa2809926709$var$appearanceForNodeType(schema, nodeType) {
    if (nodeType === schema.nodes.inlineCard) return 'inline';
    if (nodeType === schema.nodes.blockCard) return 'block';
    if (nodeType === schema.nodes.embedCard) return 'embed';
    return 'url';
}
function $ee20aa2809926709$export$182f08fa3d19e14d(options) {
    if (!(0, $mW7G5.expVal)('cc-maui-experiment', 'isEnabled', false) && !(0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience')) return ()=>false;
    const { augmentTransaction: augmentTransaction, editorAnalyticsApi: editorAnalyticsApi } = options ?? {};
    return (state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) return false;
        const url = selectedNode.attrs.url ?? selectedNode.attrs.data?.url;
        if (!url) return false;
        const previousType = $ee20aa2809926709$var$appearanceForNodeType(state.schema, selectedNode.type);
        const embedAttrs = {
            url: url,
            layout: selectedNode.attrs.layout ?? 'center',
            width: selectedNode.attrs.width ?? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).width,
            originalHeight: selectedNode.attrs.originalHeight ?? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).height,
            originalWidth: selectedNode.attrs.originalWidth ?? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).width,
            localId: selectedNode.attrs.localId
        };
        const extensionNode = $ee20aa2809926709$export$f7e09b33c87279a2(state.schema, embedAttrs);
        if (!extensionNode) return false;
        const { from: from, to: to } = state.selection;
        const tr = state.tr.replaceWith(from, to, extensionNode);
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        augmentTransaction?.(tr, state);
        if (dispatch) {
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: 'nativeEmbed',
                    previousType: previousType
                }
            })(tr);
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}



var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");





var $brzQy = parcelRequire("brzQy");





var $9ppjA = parcelRequire("9ppjA");


var $kpCD8 = parcelRequire("kpCD8");


var $2w79Z = parcelRequire("2w79Z");

var $gLqwM = parcelRequire("gLqwM");


var $6SJ6d = parcelRequire("6SJ6d");





var $bjg0G = parcelRequire("bjg0G");


var $1e1p5 = parcelRequire("1e1p5");





var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");

const $2b3b139efe9f8926$export$fca8c83126802dc4 = (selectedNativeEmbed)=>(state, dispatch)=>{
        const { pos: pos, node: node } = selectedNativeEmbed;
        const localId = typeof node.attrs?.localId === 'string' ? node.attrs.localId : undefined;
        let resolvedPos = pos;
        let resolvedNode = node;
        if (localId) {
            const nodeAtCapturedPos = state.doc.nodeAt(pos);
            if (nodeAtCapturedPos?.attrs?.localId === localId) resolvedNode = nodeAtCapturedPos;
            else {
                let found = false;
                state.doc.descendants((candidateNode, candidatePos)=>{
                    if (found) return false;
                    if (candidateNode.attrs?.localId === localId) {
                        resolvedPos = candidatePos;
                        resolvedNode = candidateNode;
                        found = true;
                        return false;
                    }
                    return true;
                });
                if (!found) return false;
            }
        }
        if (dispatch) dispatch(state.tr.delete(resolvedPos, resolvedPos + resolvedNode.nodeSize));
        return true;
    };

















/**
 * Returns the currently selected extension node, if any.
 */ const $e4ec95534c49ff7b$var$getSelectedExtension = (state)=>{
    const { schema: schema, selection: selection } = state;
    return (0, $bjg0G.findSelectedNodeOfType)(schema.nodes.extension)(selection) || undefined;
};
const $e4ec95534c49ff7b$export$a990e9e9e93229aa = (node)=>{
    return node.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY));
};
const $e4ec95534c49ff7b$export$1782ddbca43ac707 = (state)=>{
    const selected = $e4ec95534c49ff7b$var$getSelectedExtension(state);
    if (selected && $e4ec95534c49ff7b$export$a990e9e9e93229aa(selected.node)) return selected;
    return undefined;
};


const $2ccfcd916ade3c87$export$c6ebfc99aca468b = 'mauiEditRevisionId';
const $2ccfcd916ade3c87$export$e9511646d6e150ed = 'nativeEmbedsPlugin.remixVersionTrigger';
const $2ccfcd916ade3c87$var$isRecord = (value)=>value !== null && typeof value === 'object';
const $2ccfcd916ade3c87$export$1eff6c893386cae2 = (value)=>{
    if (!$2ccfcd916ade3c87$var$isRecord(value)) return undefined;
    const { previousValue: previousValue, revisionId: revisionId, slot: slot, value: nextValue } = value;
    if (typeof previousValue !== 'string' || typeof revisionId !== 'string' || typeof slot !== 'string' || typeof nextValue !== 'string') return undefined;
    return {
        previousValue: previousValue,
        revisionId: revisionId,
        slot: slot,
        value: nextValue
    };
};
const $2ccfcd916ade3c87$export$351d2c288be55601 = (value)=>{
    if (!$2ccfcd916ade3c87$var$isRecord(value) || typeof value.remixAppId !== 'string' || value.remixAppId === '' || typeof value.revisionId !== 'string' && value.revisionId !== undefined) return undefined;
    return {
        remixAppId: value.remixAppId,
        revisionId: value.revisionId
    };
};
const $2ccfcd916ade3c87$export$d2fcd9dbd2df7b9f = (value)=>{
    if (!$2ccfcd916ade3c87$var$isRecord(value)) return undefined;
    return value.action === 'undo' || value.action === 'redo' ? value.action : undefined;
};
const $2ccfcd916ade3c87$export$c3f813cc96e33692 = (value)=>{
    const version = $2ccfcd916ade3c87$export$351d2c288be55601(value);
    if (!version || !$2ccfcd916ade3c87$var$isRecord(value) || !Array.isArray(value.slots)) return undefined;
    const slots = [];
    for (const slot of value.slots){
        if (!$2ccfcd916ade3c87$var$isRecord(slot) || typeof slot.slot !== 'string' || typeof slot.value !== 'string') return undefined;
        slots.push({
            slot: slot.slot,
            value: slot.value
        });
    }
    return {
        ...version,
        slots: slots
    };
};
const $2ccfcd916ade3c87$export$4e22ee2fed222a18 = (tr, node, pos, flushed)=>{
    const current = node.attrs.parameters;
    const parameters = $2ccfcd916ade3c87$var$isRecord(current) ? current : {};
    return tr.setNodeMarkup(pos, undefined, {
        ...node.attrs,
        parameters: {
            ...(0, $ljOiP.setParameters)(parameters, {
                remixAppId: flushed.remixAppId
            }),
            [$2ccfcd916ade3c87$export$c6ebfc99aca468b]: flushed.revisionId
        }
    }).setMeta('addToHistory', false).setMeta($2ccfcd916ade3c87$export$e9511646d6e150ed, 'edit_echo');
};
const $2ccfcd916ade3c87$export$3ccddd9ee432a9c5 = (node)=>{
    const parameters = node.attrs.parameters;
    if (!$2ccfcd916ade3c87$var$isRecord(parameters)) return undefined;
    const revisionId = parameters[$2ccfcd916ade3c87$export$c6ebfc99aca468b];
    return typeof revisionId === 'string' ? revisionId : undefined;
};
const $2ccfcd916ade3c87$export$72954e99f452281d = (tr, node, pos, edit)=>{
    const parametersValue = node.attrs.parameters;
    const parameters = $2ccfcd916ade3c87$var$isRecord(parametersValue) ? parametersValue : {};
    const continuesRevision = parameters[$2ccfcd916ade3c87$export$c6ebfc99aca468b] === edit.revisionId;
    if (continuesRevision) return undefined;
    tr.setNodeMarkup(pos, undefined, {
        ...node.attrs,
        parameters: {
            ...parameters,
            [$2ccfcd916ade3c87$export$c6ebfc99aca468b]: edit.revisionId
        }
    });
    return tr;
};
const $2ccfcd916ade3c87$export$7d14078a46b907b0 = (tr, node, pos, versionId)=>{
    tr.setNodeMarkup(pos, undefined, {
        ...node.attrs,
        parameters: (0, $ljOiP.setParameters)(node.attrs.parameters, {
            remixAppId: versionId
        })
    });
    return tr.setMeta('addToHistory', false);
};
const $2ccfcd916ade3c87$export$a2bf6ddc35e8ff3c = (tr)=>{
    let changed = false;
    tr.doc.descendants((node, pos)=>{
        if (!(0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(node)) return true;
        const revisionId = $2ccfcd916ade3c87$export$3ccddd9ee432a9c5(node);
        const versionId = (0, $1e1p5.getRemixVersionForRevision)(node.attrs.localId, revisionId);
        if (!versionId || (0, $ljOiP.getParameters)(node.attrs.parameters, 'remixAppId') === versionId) return false;
        $2ccfcd916ade3c87$export$7d14078a46b907b0(tr, node, pos, versionId);
        changed = true;
        return false;
    });
    return changed ? tr : undefined;
};


const $d93aad3c468d7dd0$export$b409d0fce060e04e = (selectedNode)=>(0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'remixAppId');
const $d93aad3c468d7dd0$export$aaaed9780b43bdb2 = (remixAppId, pos, selectedNode, transitionTrigger)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...selectedNode.attrs,
                parameters: (0, $ljOiP.setParameters)(selectedNode.attrs.parameters, {
                    remixAppId: remixAppId
                })
            });
            if (transitionTrigger) tr.setMeta((0, $2ccfcd916ade3c87$export$e9511646d6e150ed), transitionTrigger);
            dispatch(tr);
        }
        return true;
    };



/**
 * Whether `key` has been EXPLICITLY persisted in the embed's macroParams.
 *
 * We deliberately do not use `getParameters(...)` here — that helper falls
 * back to `NATIVE_EMBED_PARAMETER_DEFAULTS`, so an unset axis would still
 * appear non-null and the gate would reject every request.
 */ const $b05c344de0002e31$var$isAxisPersisted = (params, key)=>params?.macroParams?.[key] !== undefined;
function $b05c344de0002e31$export$7bdcb3d58987b22e(params, request, policy) {
    return {
        width: policy.gateWidth && $b05c344de0002e31$var$isAxisPersisted(params, 'width') ? undefined : request.width,
        height: policy.gateHeight && $b05c344de0002e31$var$isAxisPersisted(params, 'height') ? undefined : request.height
    };
}



const $0cb3cd0e94f03703$var$clippingOverflow = /^(auto|scroll|hidden|clip)$/u;
const $0cb3cd0e94f03703$export$354666ad4bcf1010 = (container)=>{
    const frame = container?.ownerDocument.activeElement;
    const win = container?.ownerDocument.defaultView;
    if (!frame || !win || frame.tagName !== 'IFRAME' || !container?.contains(frame)) return false;
    const rect = frame.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0 || rect.top < 0 || rect.left < 0 || rect.bottom > win.innerHeight || rect.right > win.innerWidth) return false;
    // The iframe can fit in the window but still be clipped by the editor's scroll container.
    for(let parent = frame.parentElement; parent; parent = parent.parentElement){
        const style = win.getComputedStyle(parent);
        const clipsX = $0cb3cd0e94f03703$var$clippingOverflow.test(style.overflowX);
        const clipsY = $0cb3cd0e94f03703$var$clippingOverflow.test(style.overflowY);
        if (!clipsX && !clipsY) continue;
        const bounds = parent.getBoundingClientRect();
        const scaleX = parent.offsetWidth ? bounds.width / parent.offsetWidth : 1;
        const scaleY = parent.offsetHeight ? bounds.height / parent.offsetHeight : 1;
        const left = bounds.left + parent.clientLeft * scaleX;
        const top = bounds.top + parent.clientTop * scaleY;
        if (clipsX && (rect.left < left || rect.right > left + parent.clientWidth * scaleX) || clipsY && (rect.top < top || rect.bottom > top + parent.clientHeight * scaleY)) return false;
    }
    return true;
};


let $ccdeb71fb1aeba65$var$scopeIds = new WeakMap();
let $ccdeb71fb1aeba65$var$nextScopeId = 0;
const $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId = new Map();
const $ccdeb71fb1aeba65$var$listenersByScopedLocalId = new Map();
const $ccdeb71fb1aeba65$var$getScopedLocalId = (scope, localId)=>{
    const existing = $ccdeb71fb1aeba65$var$scopeIds.get(scope);
    if (existing) return `${existing}:${localId}`;
    const created = `scope-${$ccdeb71fb1aeba65$var$nextScopeId++}`;
    $ccdeb71fb1aeba65$var$scopeIds.set(scope, created);
    return `${created}:${localId}`;
};
function $ccdeb71fb1aeba65$export$e6dec7f2e1126484(scope, localId, maxHeight) {
    const scopedLocalId = $ccdeb71fb1aeba65$var$getScopedLocalId(scope, localId);
    $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId.set(scopedLocalId, maxHeight);
    const listeners = $ccdeb71fb1aeba65$var$listenersByScopedLocalId.get(scopedLocalId);
    if (!listeners) return;
    for (const listener of listeners)try {
        listener(maxHeight);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[max-height-store] listener for "${localId}" threw:`, error);
    }
}
function $ccdeb71fb1aeba65$export$825c16631b262763(scope, localId) {
    return $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId.get($ccdeb71fb1aeba65$var$getScopedLocalId(scope, localId));
}
function $ccdeb71fb1aeba65$export$7b97fa0ebb9b65f6(scope, localId) {
    const scopedLocalId = $ccdeb71fb1aeba65$var$getScopedLocalId(scope, localId);
    $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId.delete(scopedLocalId);
    $ccdeb71fb1aeba65$var$listenersByScopedLocalId.delete(scopedLocalId);
}
function $ccdeb71fb1aeba65$export$955213572ce75a0(scope, localId, listener) {
    const scopedLocalId = $ccdeb71fb1aeba65$var$getScopedLocalId(scope, localId);
    let listeners = $ccdeb71fb1aeba65$var$listenersByScopedLocalId.get(scopedLocalId);
    if (!listeners) {
        listeners = new Set();
        $ccdeb71fb1aeba65$var$listenersByScopedLocalId.set(scopedLocalId, listeners);
    }
    listeners.add(listener);
    return ()=>{
        const set = $ccdeb71fb1aeba65$var$listenersByScopedLocalId.get(scopedLocalId);
        if (!set) return;
        set.delete(listener);
        if (set.size === 0) $ccdeb71fb1aeba65$var$listenersByScopedLocalId.delete(scopedLocalId);
    };
}
function $ccdeb71fb1aeba65$export$1ccd7a1bde88ea45() {
    $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId.clear();
    $ccdeb71fb1aeba65$var$listenersByScopedLocalId.clear();
    $ccdeb71fb1aeba65$var$scopeIds = new WeakMap();
    $ccdeb71fb1aeba65$var$nextScopeId = 0;
}


/**
 * Given a candidate document position (already mapped through the latest
 * transaction), returns the position if it still points to a native embed
 * node, or `null` if the embed has been deleted or replaced.
 *
 * Extracted as a named helper so the intent is clear at the call-site and
 * the validation logic can be updated in one place if needed.
 */ const $d598f2eb7a08550e$var$resolveTrackedEmbedPos = (pos, newEditorState)=>{
    const docSize = newEditorState.doc.content.size;
    if (pos >= docSize) return null;
    const nodeAtPos = newEditorState.doc.nodeAt(pos);
    if (!nodeAtPos || !(0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(nodeAtPos)) return null;
    return pos;
};
const $d598f2eb7a08550e$var$findEventEmbedContainer = (view, event)=>{
    const target = event.target;
    if (!(target instanceof HTMLElement)) return undefined;
    let nodeViewDom = target;
    while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
    return nodeViewDom && nodeViewDom !== view.dom ? nodeViewDom : undefined;
};
const $d598f2eb7a08550e$var$findNativeEmbedFromEvent = (view, event)=>{
    const nodeViewDom = $d598f2eb7a08550e$var$findEventEmbedContainer(view, event);
    if (!nodeViewDom) return undefined;
    try {
        const pos = view.posAtDOM(nodeViewDom, 0);
        const $pos = view.state.doc.resolve(pos);
        if ($pos.nodeAfter && (0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)($pos.nodeAfter)) return {
            node: $pos.nodeAfter,
            pos: pos,
            dom: nodeViewDom
        };
        for(let depth = $pos.depth; depth >= 0; depth--){
            const node = $pos.node(depth);
            if ((0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(node)) return {
                node: node,
                pos: $pos.before(depth),
                dom: nodeViewDom
            };
        }
    } catch  {
        return undefined;
    }
    return undefined;
};
const $d598f2eb7a08550e$var$applyToNativeEmbedFromEvent = (view, event, apply)=>{
    const embed = $d598f2eb7a08550e$var$findNativeEmbedFromEvent(view, event);
    return embed ? apply(embed.node, embed.pos, embed.dom) : false;
};
const $d598f2eb7a08550e$var$getInsertionMethod = (transactions)=>{
    for (const transaction of transactions){
        const { inputMethod: inputMethod } = (0, $brzQy.getLinkMetadataFromTransaction)(transaction);
        if (inputMethod) return inputMethod;
    }
    return (0, $krYZG.INPUT_METHOD).MANUAL;
};
const $d598f2eb7a08550e$var$getRemixVersionTransitionTrigger = (tr)=>{
    const explicitTrigger = tr.getMeta((0, $2ccfcd916ade3c87$export$e9511646d6e150ed));
    if (explicitTrigger === 'undo' || explicitTrigger === 'redo' || explicitTrigger === 'collab' || explicitTrigger === 'edit_echo' || explicitTrigger === 'host_version_change') return explicitTrigger;
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    if (typeof historyMeta === 'object' && historyMeta !== null && 'redo' in historyMeta) {
        const { redo: redo } = historyMeta;
        if (redo === true) return 'redo';
        if (redo === false) return 'undo';
    }
    return tr.getMeta('isRemote') ? 'collab' : 'host_version_change';
};
const $d598f2eb7a08550e$var$indexRemixVersionState = (doc)=>{
    const versionStateByLocalId = new Map();
    doc.descendants((node)=>{
        if (!(0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(node) || typeof node.attrs.localId !== 'string') return true;
        versionStateByLocalId.set(node.attrs.localId, {
            revisionId: (0, $2ccfcd916ade3c87$export$3ccddd9ee432a9c5)(node),
            versionId: (0, $ljOiP.resolveRemixVersionId)({
                storedRemixAppId: (0, $d93aad3c468d7dd0$export$b409d0fce060e04e)(node),
                url: (0, $ljOiP.getParameters)(node.attrs.parameters, 'url')
            })
        });
        return false;
    });
    return versionStateByLocalId;
};
const $d598f2eb7a08550e$var$remixVersionStatesAreEqual = (left, right)=>{
    if (left.size !== right.size) return false;
    for (const [localId, leftState] of left){
        const rightState = right.get(localId);
        if (!rightState || leftState.revisionId !== rightState.revisionId || leftState.versionId !== rightState.versionId) return false;
    }
    return true;
};
const $d598f2eb7a08550e$var$shouldCreateRemixTransition = ({ current: current, previous: previous, trigger: trigger })=>{
    // A durable version change always needs to be synchronized to the iframe.
    if (previous.versionId !== current.versionId) return true;
    // A forward local edit is already visible in its originating iframe, so
    // sending its revision back would be an echo. Revision-only transitions are
    // meaningful only when undo/redo navigates editor history before minting.
    const isHistoryNavigation = trigger === 'undo' || trigger === 'redo';
    return isHistoryNavigation && previous.revisionId !== current.revisionId;
};
const $d598f2eb7a08550e$var$getRemixStateTransitions = (previousVersionState, currentVersionState, trigger)=>{
    const transitions = [];
    for (const [localId, current] of currentVersionState){
        const previous = previousVersionState.get(localId);
        if (!current.versionId) continue;
        // Redo can restore an edited embed after undo removed the entire node.
        if (!previous) {
            if (trigger === 'redo' && current.revisionId !== undefined) transitions.push({
                localId: localId,
                revisionId: current.revisionId,
                versionId: current.versionId
            });
            continue;
        }
        if (!$d598f2eb7a08550e$var$shouldCreateRemixTransition({
            current: current,
            previous: previous,
            trigger: trigger
        })) continue;
        transitions.push({
            localId: localId,
            ...current.revisionId === undefined ? {} : {
                revisionId: current.revisionId
            },
            versionId: current.versionId
        });
    }
    return transitions;
};
const $d598f2eb7a08550e$export$68fc950519fc9e9f = 'nativeEmbedsPlugin.isResizing';
const $d598f2eb7a08550e$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('nativeEmbedsPlugin');
/**
 * Walks the document to find all native embed extension nodes and syncs
 * the `data-native-embed-nested` attribute on their DOM `.extension-container`
 * element. This ensures the attribute stays correct after drag-and-drop moves
 * an embed into or out of a nested container.
 *
 * Deferred to a requestAnimationFrame so that the DOM has been fully rebuilt
 * by ProseMirror before we attempt to locate elements.
 */ let $d598f2eb7a08550e$var$syncRAFHandle = null;
const $d598f2eb7a08550e$var$syncNativeEmbedNestedAttributes = (view)=>{
    if ($d598f2eb7a08550e$var$syncRAFHandle !== null) cancelAnimationFrame($d598f2eb7a08550e$var$syncRAFHandle);
    $d598f2eb7a08550e$var$syncRAFHandle = requestAnimationFrame(()=>{
        $d598f2eb7a08550e$var$syncRAFHandle = null;
        if (view.isDestroyed) return;
        const { state: state } = view;
        state.doc.descendants((node, pos)=>{
            if (!(0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(node)) return true; // continue traversal
            try {
                // Use view.nodeDOM to get the actual node's DOM element, bypassing
                // decorations (like gap cursors) that share the same position.
                const rawDom = view.nodeDOM(pos);
                const element = rawDom instanceof HTMLElement ? rawDom : rawDom instanceof Node ? rawDom.parentElement : null;
                if (!element) return false;
                const container = element.querySelector('.extension-container') ?? element.closest('.extension-container') ?? element;
                if ((0, $9ppjA.getNestedParentNode)(pos, state) !== null) container.setAttribute('data-native-embed-nested', '');
                else container.removeAttribute('data-native-embed-nested');
            } catch  {
            // DOM may not be available for this position yet — skip
            }
            return false; // no need to descend into extension node
        });
    });
};
const $d598f2eb7a08550e$export$ae829ec7b2625219 = (editorAnalyticsApi, undoRedoActions)=>{
    const writtenMaxHeightLocalIds = new Set();
    // Experiment value is stable for the lifetime of the plugin, so resolve it
    // once at construction time. Avoids redundant flag lookups (and exposure
    // logs) on every child resize event.
    const childResizePolicy = {
        gateWidth: true,
        gateHeight: (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true)
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $d598f2eb7a08550e$export$18d4026d1ea86bb1,
        props: {
            handleDOMEvents: {
                // Handle click-inside events dispatched by the native embed iframe
                // extension component. We create a proper ProseMirror NodeSelection
                // so that keyboard interactions (Delete, Backspace) work as expected.
                'native-embed-click-inside': (view, event)=>{
                    const target = event.target;
                    if (!(target instanceof HTMLElement)) return false;
                    // Walk up the DOM from the event target to find the node view
                    // wrapper element (identified by the extensionView-content-wrap
                    // class added by ReactNodeView). This element has a pmViewDesc
                    // that ProseMirror can resolve to a document position.
                    let nodeViewDom = target;
                    while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
                    if (!nodeViewDom || nodeViewDom === view.dom) return false;
                    try {
                        const pos = view.posAtDOM(nodeViewDom, 0);
                        const $pos = view.state.doc.resolve(pos);
                        // For atom nodes (like extension), posAtDOM on the node
                        // view wrapper resolves to the position of the node.
                        // Check nodeAfter at this position.
                        const nodeAfter = $pos.nodeAfter;
                        if (nodeAfter && nodeAfter.type.name === 'extension' && nodeAfter.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && nodeAfter.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                            const tr = view.state.tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, pos));
                            view.dispatch(tr);
                            if (event.detail?.shouldFocus !== false) view.focus();
                            return true;
                        }
                        // Fallback: walk up the ancestor chain in case the position
                        // resolved inside a wrapper node.
                        for(let d = $pos.depth; d >= 0; d--){
                            const node = $pos.node(d);
                            if (node.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                                const nodePos = $pos.before(d);
                                const tr = view.state.tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, nodePos));
                                view.dispatch(tr);
                                if (event.detail?.shouldFocus !== false) view.focus();
                                return true;
                            }
                        }
                    } catch  {
                    // posAtDOM can throw if the DOM element is not within the editor
                    }
                    return false;
                },
                'native-embed-request-resize': (view, event)=>{
                    const detail = event.detail;
                    const newWidth = typeof detail?.width === 'number' ? detail.width : undefined;
                    const newHeight = typeof detail?.height === 'number' ? detail.height : undefined;
                    const newMaxHeight = typeof detail?.maxHeight === 'number' && Number.isFinite(detail.maxHeight) ? detail.maxHeight : undefined;
                    const shouldPersistResize = newWidth !== undefined || newHeight !== undefined;
                    const target = event.target;
                    if (!(target instanceof HTMLElement) || newWidth === undefined && newHeight === undefined && newMaxHeight === undefined) return false;
                    let nodeViewDom = target;
                    while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
                    if (!nodeViewDom || nodeViewDom === view.dom) return false;
                    // Width is always gated — once the host has persisted a
                    // width, further child width requests are dropped. Height
                    // is gated behind `databases-native-embeds-v2` while the
                    // child-driven vertical-resize capability rolls out; in both cases
                    // the rule is "lock the axis on the first child-driven
                    // resize, ignore further child requests on that axis". See
                    // `resolve-child-resize.ts` for the pure policy fn; the
                    // policy itself is built once in `createPlugin` above.
                    const buildUpdatedParams = (params)=>{
                        const { width: applyWidth, height: applyHeight } = (0, $b05c344de0002e31$export$7bdcb3d58987b22e)(params, {
                            width: newWidth,
                            height: newHeight
                        }, childResizePolicy);
                        let updated = params ?? {};
                        if (applyWidth !== undefined) updated = (0, $ljOiP.setParameter)(updated, {
                            width: applyWidth
                        });
                        if (applyHeight !== undefined) updated = (0, $ljOiP.setParameter)(updated, {
                            height: applyHeight
                        });
                        return updated;
                    };
                    try {
                        const pos = view.posAtDOM(nodeViewDom, 0);
                        const $pos = view.state.doc.resolve(pos);
                        const nodeAfter = $pos.nodeAfter;
                        if (nodeAfter && nodeAfter.type.name === 'extension' && nodeAfter.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && nodeAfter.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                            const localId = nodeAfter.attrs?.localId;
                            if (typeof localId === 'string' && localId !== '' && newMaxHeight !== undefined && newMaxHeight > 0) {
                                (0, $ccdeb71fb1aeba65$export$e6dec7f2e1126484)(view, localId, newMaxHeight);
                                writtenMaxHeightLocalIds.add(localId);
                            }
                            if (!shouldPersistResize) return true;
                            const updatedParams = buildUpdatedParams(nodeAfter.attrs.parameters);
                            const tr = view.state.tr.setNodeMarkup(pos, undefined, {
                                ...nodeAfter.attrs,
                                parameters: updatedParams
                            });
                            view.dispatch(tr);
                            return true;
                        }
                        for(let d = $pos.depth; d >= 0; d--){
                            const node = $pos.node(d);
                            if (node.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                                const localId = node.attrs?.localId;
                                if (typeof localId === 'string' && localId !== '' && newMaxHeight !== undefined && newMaxHeight > 0) {
                                    (0, $ccdeb71fb1aeba65$export$e6dec7f2e1126484)(view, localId, newMaxHeight);
                                    writtenMaxHeightLocalIds.add(localId);
                                }
                                if (!shouldPersistResize) return true;
                                const nodePos = $pos.before(d);
                                const updatedParams = buildUpdatedParams(node.attrs.parameters);
                                const tr = view.state.tr.setNodeMarkup(nodePos, undefined, {
                                    ...node.attrs,
                                    parameters: updatedParams
                                });
                                view.dispatch(tr);
                                return true;
                            }
                        }
                    } catch  {
                    // posAtDOM can throw if the DOM element is not within the editor
                    }
                    return false;
                },
                'native-embed-new-version': (view, event)=>{
                    if (!(0, $4o0zT.isExperimentEnabled)('cc_maui_editing_experience')) return false;
                    const detail = event instanceof CustomEvent ? (0, $2ccfcd916ade3c87$export$351d2c288be55601)(event.detail) : undefined;
                    if (!detail) return false;
                    return $d598f2eb7a08550e$var$applyToNativeEmbedFromEvent(view, event, (embedNode, nodePos)=>{
                        const currentVersionId = (0, $ljOiP.resolveRemixVersionId)({
                            storedRemixAppId: (0, $d93aad3c468d7dd0$export$b409d0fce060e04e)(embedNode),
                            url: (0, $ljOiP.getParameters)(embedNode.attrs.parameters, 'url')
                        });
                        if (detail.revisionId) (0, $1e1p5.recordRemixRevisionVersion)(embedNode.attrs.localId, detail.revisionId, detail.remixAppId);
                        if (currentVersionId === detail.remixAppId) return true;
                        if (detail.revisionId) {
                            if ((0, $2ccfcd916ade3c87$export$3ccddd9ee432a9c5)(embedNode) !== detail.revisionId) return true;
                            view.dispatch((0, $2ccfcd916ade3c87$export$7d14078a46b907b0)(view.state.tr, embedNode, nodePos, detail.remixAppId).setMeta((0, $2ccfcd916ade3c87$export$e9511646d6e150ed), 'edit_echo'));
                            return true;
                        }
                        return (0, $d93aad3c468d7dd0$export$aaaed9780b43bdb2)(detail.remixAppId, nodePos, embedNode, 'edit_echo')(view.state, view.dispatch);
                    });
                },
                'native-embed-remix-flushed': (view, event)=>{
                    const detail = event instanceof CustomEvent ? (0, $2ccfcd916ade3c87$export$c3f813cc96e33692)(event.detail) : undefined;
                    if (!detail) return false;
                    return $d598f2eb7a08550e$var$applyToNativeEmbedFromEvent(view, event, (embedNode, nodePos)=>{
                        if (detail.revisionId) {
                            for (const { slot: slot, value: value } of detail.slots)(0, $1e1p5.recordRemixRevisionEdit)({
                                localId: embedNode.attrs.localId,
                                previousRevisionId: detail.revisionId,
                                previousValue: value,
                                revisionId: detail.revisionId,
                                slot: slot,
                                value: value
                            });
                            (0, $1e1p5.recordRemixRevisionVersion)(embedNode.attrs.localId, detail.revisionId, detail.remixAppId);
                        }
                        // A flush response is authoritative even if the async edit notification has not arrived.
                        view.dispatch((0, $2ccfcd916ade3c87$export$4e22ee2fed222a18)(view.state.tr, embedNode, nodePos, detail));
                        event.preventDefault();
                        return true;
                    });
                },
                'native-embed-remix-edit': (view, event)=>{
                    if (!(0, $4o0zT.isExperimentEnabled)('cc_maui_editing_experience')) return false;
                    const edit = event instanceof CustomEvent ? (0, $2ccfcd916ade3c87$export$1eff6c893386cae2)(event.detail) : undefined;
                    if (!edit) return false;
                    return $d598f2eb7a08550e$var$applyToNativeEmbedFromEvent(view, event, (embedNode, nodePos, embedDom)=>{
                        const currentVersionId = (0, $ljOiP.resolveRemixVersionId)({
                            storedRemixAppId: (0, $d93aad3c468d7dd0$export$b409d0fce060e04e)(embedNode),
                            url: (0, $ljOiP.getParameters)(embedNode.attrs.parameters, 'url')
                        });
                        (0, $1e1p5.recordRemixRevisionEdit)({
                            currentVersionId: currentVersionId,
                            localId: embedNode.attrs.localId,
                            previousRevisionId: (0, $2ccfcd916ade3c87$export$3ccddd9ee432a9c5)(embedNode),
                            previousValue: edit.previousValue,
                            revisionId: edit.revisionId,
                            slot: edit.slot,
                            value: edit.value
                        });
                        const tr = (0, $2ccfcd916ade3c87$export$72954e99f452281d)(view.state.tr, embedNode, nodePos, edit);
                        if (!tr) return false;
                        if ((0, $0cb3cd0e94f03703$export$354666ad4bcf1010)(embedDom)) tr.setMeta('scrollIntoView', false);
                        view.dispatch(tr);
                        return true;
                    });
                },
                // Gated: the embedded app forwarded a Cmd/Ctrl+Z undo/redo intent
                // (its editable text suppressed the browser's native contentEditable undo).
                // Run the editor's undo/redo so it is the single history authority that drives
                // the remix version pointer, whether focus is in the page or inside the app.
                'native-embed-editor-history': (view, event)=>{
                    if (!(0, $4o0zT.isExperimentEnabled)('cc_maui_editing_experience')) return false;
                    const action = event instanceof CustomEvent ? (0, $2ccfcd916ade3c87$export$d2fcd9dbd2df7b9f)(event.detail) : undefined;
                    if (action !== 'undo' && action !== 'redo') return false;
                    // The intent originated inside the embed iframe, so move focus to the editor
                    // before running the command.
                    view.focus();
                    return undoRedoActions?.[action]() ?? false;
                },
                // Handle delete requests from child embeds via the bridge.
                // The child sends { type: 'delete' } when the user presses
                // Delete/Backspace without a focused text input inside the
                // iframe. Only MAUI embeds are eligible for bridge-initiated
                // deletion (verified via the /remix/ui/ URL pattern).
                'native-embed-request-delete': (view)=>{
                    const selected = (0, $bjg0G.findSelectedNodeOfType)(view.state.schema.nodes.extension)(view.state.selection);
                    if (selected && (0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(selected.node)) {
                        const deleted = (0, $2b3b139efe9f8926$export$fca8c83126802dc4)(selected)(view.state, view.dispatch);
                        if (deleted) // After bridge-initiated deletion, transfer focus back to the
                        // editor so subsequent keyboard shortcuts (e.g. Ctrl+Z to undo)
                        // are handled by ProseMirror rather than being consumed by the
                        // now-removed iframe.
                        view.focus();
                        return deleted;
                    }
                    return false;
                }
            }
        },
        view: (editorView)=>{
            // Run an initial sync so embeds that are already nested when the
            // editor first mounts get the correct attribute immediately.
            $d598f2eb7a08550e$var$syncNativeEmbedNestedAttributes(editorView);
            // In view mode (editorView.editable === false), clicks on a native embed
            // node don't naturally select it via ProseMirror's event handling.
            // This listener intercepts mousedown events at the document level and
            // manually dispatches a NodeSelection for the clicked embed, so that
            // the floating toolbar appears as expected in view/live-page mode.
            const handleDocMouseDown = (event)=>{
                if (editorView.editable) return;
                const target = event.target;
                if (!(target instanceof HTMLElement)) return;
                const wrapper = target.closest('.extensionView-content-wrap');
                if (!wrapper || !editorView.dom.contains(wrapper)) return;
                try {
                    const pos = editorView.posAtDOM(wrapper, 0);
                    const nodeAfter = editorView.state.doc.resolve(pos).nodeAfter;
                    if (nodeAfter?.type.name === 'extension') {
                        const tr = editorView.state.tr.setSelection((0, $kCECX.NodeSelection).create(editorView.state.doc, pos));
                        editorView.dispatch(tr);
                    }
                } catch  {
                // pos stale
                }
            };
            const doc = (0, $1hQ0e.getDocument)();
            const unbindMouseDown = doc ? (0, $cbY7C.bind)(doc, {
                type: 'mousedown',
                listener: handleDocMouseDown,
                options: {
                    capture: true
                }
            }) : ()=>{};
            return {
                update: (view, prevState)=>{
                    if (prevState.doc !== view.state.doc) {
                        $d598f2eb7a08550e$var$syncNativeEmbedNestedAttributes(view);
                        const liveLocalIds = new Set();
                        view.state.doc.descendants((node)=>{
                            if ((0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(node) && typeof node.attrs.localId === 'string') liveLocalIds.add(node.attrs.localId);
                            return true;
                        });
                        for (const localId of writtenMaxHeightLocalIds)if (!liveLocalIds.has(localId)) {
                            (0, $ccdeb71fb1aeba65$export$7b97fa0ebb9b65f6)(editorView, localId);
                            writtenMaxHeightLocalIds.delete(localId);
                        }
                    }
                },
                destroy: ()=>{
                    unbindMouseDown();
                    if ($d598f2eb7a08550e$var$syncRAFHandle !== null) {
                        cancelAnimationFrame($d598f2eb7a08550e$var$syncRAFHandle);
                        $d598f2eb7a08550e$var$syncRAFHandle = null;
                    }
                    for (const localId of writtenMaxHeightLocalIds)(0, $ccdeb71fb1aeba65$export$7b97fa0ebb9b65f6)(editorView, localId);
                    writtenMaxHeightLocalIds.clear();
                }
            };
        },
        state: {
            init: (_config, editorState)=>({
                    isResizing: false,
                    remixVersionStateByLocalId: (0, $4o0zT.isExperimentEnabled)('cc_maui_editing_experience') ? $d598f2eb7a08550e$var$indexRemixVersionState(editorState.doc) : new Map(),
                    remixVersionTransitions: new Map(),
                    trackedEmbedPos: null,
                    hoveredEmbedPos: null,
                    selectedEmbed: null,
                    showUrlToolbar: false
                }),
            apply: (tr, state, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta($d598f2eb7a08550e$export$18d4026d1ea86bb1);
                let nextState = state;
                if (tr.docChanged && (0, $4o0zT.isExperimentEnabled)('cc_maui_editing_experience')) {
                    const trigger = $d598f2eb7a08550e$var$getRemixVersionTransitionTrigger(tr);
                    const indexedRemixVersionState = $d598f2eb7a08550e$var$indexRemixVersionState(newEditorState.doc);
                    const remixVersionStateByLocalId = $d598f2eb7a08550e$var$remixVersionStatesAreEqual(state.remixVersionStateByLocalId, indexedRemixVersionState) ? state.remixVersionStateByLocalId : indexedRemixVersionState;
                    const remixTransitions = $d598f2eb7a08550e$var$getRemixStateTransitions(state.remixVersionStateByLocalId, remixVersionStateByLocalId, trigger);
                    let remixVersionTransitions = nextState.remixVersionTransitions;
                    if (remixTransitions.length > 0) {
                        const updatedTransitions = new Map(remixVersionTransitions);
                        for (const transition of remixTransitions)updatedTransitions.set(transition.localId, {
                            ...transition,
                            applyId: crypto.randomUUID(),
                            trigger: trigger
                        });
                        remixVersionTransitions = updatedTransitions;
                    }
                    if (remixVersionTransitions.size > 0) {
                        let updatedTransitions;
                        for (const localId of remixVersionTransitions.keys())if (!remixVersionStateByLocalId.has(localId)) {
                            updatedTransitions ?? (updatedTransitions = new Map(remixVersionTransitions));
                            updatedTransitions.delete(localId);
                        }
                        if (updatedTransitions) remixVersionTransitions = updatedTransitions;
                    }
                    if (remixVersionStateByLocalId !== state.remixVersionStateByLocalId || remixVersionTransitions !== state.remixVersionTransitions) nextState = {
                        ...nextState,
                        remixVersionStateByLocalId: remixVersionStateByLocalId,
                        remixVersionTransitions: remixVersionTransitions
                    };
                }
                // Map the last-known embed positions through document changes
                // (following the card/paste/extension plugin pattern).
                // When content above an embed is inserted or removed, the
                // mapped pos shifts — producing a new shared state that
                // triggers onChange in React overlays.
                if (tr.docChanged) {
                    if (nextState.trackedEmbedPos !== null) {
                        const mappedPos = tr.mapping.map(nextState.trackedEmbedPos);
                        const resolvedPos = $d598f2eb7a08550e$var$resolveTrackedEmbedPos(mappedPos, newEditorState);
                        if (resolvedPos !== nextState.trackedEmbedPos) nextState = {
                            ...nextState,
                            trackedEmbedPos: resolvedPos
                        };
                    }
                    if (nextState.hoveredEmbedPos !== null) {
                        const mappedPos = tr.mapping.map(nextState.hoveredEmbedPos);
                        const resolvedPos = $d598f2eb7a08550e$var$resolveTrackedEmbedPos(mappedPos, newEditorState);
                        if (resolvedPos !== nextState.hoveredEmbedPos) nextState = {
                            ...nextState,
                            hoveredEmbedPos: resolvedPos
                        };
                    }
                }
                if (meta?.type === 'SET_HOVERED_EMBED_POS') {
                    // Defensively map `meta.pos` through this transaction's mapping
                    // before storing. The coordinator computes the pos against the
                    // PRE-dispatch view.state, but if a concurrent input rule or
                    // other appendTransaction has rewritten the doc in this same
                    // transaction, the raw pos can be off by N. Mapping then
                    // resolving keeps the stored hoveredEmbedPos consistent with
                    // the doc that this `apply()` is producing.
                    if (meta.pos === null) nextState = {
                        ...nextState,
                        hoveredEmbedPos: null
                    };
                    else {
                        const mappedPos = tr.docChanged ? tr.mapping.map(meta.pos) : meta.pos;
                        const resolvedPos = $d598f2eb7a08550e$var$resolveTrackedEmbedPos(mappedPos, newEditorState);
                        nextState = {
                            ...nextState,
                            hoveredEmbedPos: resolvedPos
                        };
                    }
                }
                if (meta?.type === 'SHOW_URL_TOOLBAR') nextState = {
                    ...nextState,
                    showUrlToolbar: true
                };
                if (meta?.type === 'HIDE_URL_TOOLBAR') nextState = {
                    ...nextState,
                    showUrlToolbar: false
                };
                if (meta?.type === 'SET_RESIZING') nextState = {
                    ...nextState,
                    isResizing: meta.isResizing,
                    resizingWidth: meta.width
                };
                const { schema: schema, selection: selection } = newEditorState;
                const selected = (0, $bjg0G.findSelectedNodeOfType)(schema.nodes.extension)(selection);
                const isNativeEmbed = selected && (0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(selected.node);
                if (isNativeEmbed) {
                    const newPos = selected.pos;
                    const newAlignment = (0, $ljOiP.getParameters)(selected.node.attrs.parameters, 'alignment');
                    const newLocalId = selected.node.attrs.localId;
                    const prev = nextState.selectedEmbed;
                    if (newPos !== prev?.selectionPos || newAlignment !== prev?.alignment || newLocalId !== prev?.localId) nextState = {
                        ...nextState,
                        trackedEmbedPos: newPos,
                        selectedEmbed: {
                            selectionPos: newPos,
                            alignment: newAlignment,
                            localId: newLocalId
                        }
                    };
                } else if (nextState.selectedEmbed !== null) nextState = {
                    ...nextState,
                    selectedEmbed: null
                };
                return nextState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            if ((0, $4o0zT.isExperimentEnabled)('cc_maui_editing_experience')) {
                const normalized = (0, $2ccfcd916ade3c87$export$a2bf6ddc35e8ff3c)(newState.tr);
                if (normalized) {
                    const trigger = transactions.map($d598f2eb7a08550e$var$getRemixVersionTransitionTrigger).find((candidate)=>candidate !== 'host_version_change') ?? 'host_version_change';
                    return normalized.setMeta((0, $2ccfcd916ade3c87$export$e9511646d6e150ed), trigger);
                }
            }
            if (!editorAnalyticsApi) return null;
            if ((0, $6SJ6d.isReplaceDocOperation)(transactions, oldState)) return null;
            const isNotLocalInsert = transactions.some((t)=>{
                const action = (0, $brzQy.getLinkMetadataFromTransaction)(t).action;
                const isRemote = t.getMeta('isRemote');
                return isRemote || !(action === (0, $krYZG.ACTION).INSERTED || action === undefined);
            });
            if (isNotLocalInsert) return null;
            const existingLocalIds = new Set();
            oldState.doc.descendants((node)=>{
                if ((0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(node) && node.attrs.localId) existingLocalIds.add(node.attrs.localId);
            });
            const insertedEmbeds = transactions.flatMap((tr)=>{
                const inserted = [];
                if (!tr.docChanged) return inserted;
                tr.steps.forEach((step)=>{
                    if ((0, $gLqwM.stepHasSlice)(step)) step.slice.content.descendants((node)=>{
                        if ((0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(node) && node.attrs.localId !== null && !existingLocalIds.has(node.attrs.localId)) inserted.push(node);
                    });
                });
                return inserted;
            });
            if (insertedEmbeds.length === 0) return null;
            const tr = newState.tr;
            const payload = {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    insertedCount: insertedEmbeds.length,
                    inputMethod: $d598f2eb7a08550e$var$getInsertionMethod(transactions)
                }
            };
            editorAnalyticsApi.attachAnalyticsEvent(payload)(tr);
            return tr;
        }
    });
};





parcelRequire("cozmU");


var $ldqjS = parcelRequire("ldqjS");


var $ImNkk = parcelRequire("ImNkk");


var $5NB3T = parcelRequire("5NB3T");

var $3FYPH = parcelRequire("3FYPH");

var $91WyP = parcelRequire("91WyP");

var $iEFx5 = parcelRequire("iEFx5");

var $2BvhC = parcelRequire("2BvhC");


var $2VYYv = parcelRequire("2VYYv");








var $f0b2F = parcelRequire("f0b2F");


var $bH62g = parcelRequire("bH62g");


var $f922E = parcelRequire("f922E");


var $2PKI8 = parcelRequire("2PKI8");


var $eDtFr = parcelRequire("eDtFr");


var $f4MCV = parcelRequire("f4MCV");


var $iUhs4 = parcelRequire("iUhs4");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $8VfSP = parcelRequire("8VfSP");


var $V3JOP = parcelRequire("V3JOP");


var $1WMy0 = parcelRequire("1WMy0");
















var $kSwu1 = parcelRequire("kSwu1");

const $05b362cd50fa2589$export$271a7654ce32757b = (0, $kSwu1.defineMessages)({
    copy: {
        id: "editor-plugin-native-embeds.messages.block-menu.copy",
        defaultMessage: "Copy"
    }
});





const $94ce71f66457d23a$export$cdc1205423c9f2de = (0, $kSwu1.defineMessages)({
    alwaysShowTitle: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.alwaysShowTitle",
        defaultMessage: "Show embed title"
    },
    expandPreview: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.expandPreview",
        defaultMessage: "Expand"
    },
    refresh: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.refresh",
        defaultMessage: "Refresh"
    },
    setEmbedType: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.setEmbedType",
        defaultMessage: "Set embed type"
    },
    summarise: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.summarise",
        defaultMessage: "Summarize"
    }
});



var $cXtTj = parcelRequire("cXtTj");













const $f02260fba5bb4551$var$NATIVE_EMBED_EXPERIENCE_PREFIX = 'native-embed:';
const $f02260fba5bb4551$var$NATIVE_EMBED_MAX_WIDTH_CONFIG = 'platform_native_embeds_max_width';
// eslint-disable-next-line require-unicode-regexp
const $f02260fba5bb4551$var$DATABASE_NATIVE_EMBED_URL_PATTERN = /\/wiki\/spaces\/[^/]+\/database\/\d+(\?.*)?$/;
// Gates the vertical-resize behavior for db native embeds. While the experiment
// is off, the short-circuit for database embeds is skipped and
// `nativeEmbedAllowsVerticalResize` always reports `false`, so behavior is
// identical to the horizontal-only resize state. Pre-checks `cc-maui-experiment`
// (without firing exposure) so the v2 exposure population stays scoped to the
// MAUI cohort.
const $f02260fba5bb4551$var$isNativeDbEmbedsV2ExperimentEnabled = ()=>(0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
const $f02260fba5bb4551$export$c63b2d526fa9c9d1 = (extensionKey)=>{
    if (!extensionKey) return undefined;
    const idx = extensionKey.indexOf($f02260fba5bb4551$var$NATIVE_EMBED_EXPERIENCE_PREFIX);
    if (idx === -1) return undefined;
    const id = extensionKey.slice(idx + $f02260fba5bb4551$var$NATIVE_EMBED_EXPERIENCE_PREFIX.length);
    return id || undefined;
};
const $f02260fba5bb4551$var$getNativeEmbedNodeUrl = (parameters)=>{
    const urlFromMacroParams = (0, $ljOiP.getParameters)(parameters, 'url');
    if (urlFromMacroParams) return urlFromMacroParams;
    const flatUrl = parameters?.url;
    if (typeof flatUrl === 'string') return flatUrl;
    return flatUrl?.value;
};
const $f02260fba5bb4551$export$5656dd81bb31ebb8 = (node)=>{
    const facade = (0, $iwIwp.getNativeEmbedFacade)();
    const experienceId = $f02260fba5bb4551$export$c63b2d526fa9c9d1(node.attrs.extensionKey);
    if (experienceId) {
        const byId = facade.getManifestById(experienceId);
        if (byId) return byId;
    }
    const nodeUrl = $f02260fba5bb4551$var$getNativeEmbedNodeUrl(node.attrs.parameters);
    if (nodeUrl) return facade.getManifestByUrl(nodeUrl);
    return undefined;
};
const $f02260fba5bb4551$export$5afeb39b81d798eb = (url)=>{
    return !!url && $f02260fba5bb4551$var$DATABASE_NATIVE_EMBED_URL_PATTERN.test(url);
};
const $f02260fba5bb4551$export$fcdc775fd72fbed9 = (node)=>{
    if ($f02260fba5bb4551$var$isNativeDbEmbedsV2ExperimentEnabled()) {
        const id = $f02260fba5bb4551$export$c63b2d526fa9c9d1(node.attrs.extensionKey);
        const nodeUrl = $f02260fba5bb4551$var$getNativeEmbedNodeUrl(node.attrs.parameters);
        if (id === 'database' || id === 'database-entry' || $f02260fba5bb4551$export$5afeb39b81d798eb(nodeUrl)) return false;
    }
    const manifest = $f02260fba5bb4551$export$5656dd81bb31ebb8(node);
    if (manifest) return manifest.lockResizeAspectRatio?.() ?? true;
    return true;
};
const $f02260fba5bb4551$export$b594514954d95745 = (node)=>{
    if (!$f02260fba5bb4551$var$isNativeDbEmbedsV2ExperimentEnabled()) return false;
    const manifest = $f02260fba5bb4551$export$5656dd81bb31ebb8(node);
    return manifest?.allowVerticalResize ?? false;
};
const $f02260fba5bb4551$export$d37a0d761f58309a = (node)=>{
    const manifest = $f02260fba5bb4551$export$5656dd81bb31ebb8(node);
    return manifest?.allowMaxWidth === true && (0, $cXtTj.default).getExperimentValue($f02260fba5bb4551$var$NATIVE_EMBED_MAX_WIDTH_CONFIG, 'value', false);
};





const $ea287d488ebca970$export$cd1350638370dbe1 = '#091E4224';
const $ea287d488ebca970$export$368b62735a1b3872 = 1;
const $ea287d488ebca970$export$1f2a2eaba9ed74e9 = (selectedNode)=>{
    const macroParams = selectedNode.attrs.parameters?.macroParams ?? {};
    // Access as extended params (borderColor/borderSize added in MAUI-478)
    const extendedParams = macroParams;
    return {
        color: extendedParams.borderColor?.value || undefined,
        size: extendedParams.borderSize?.value ? Number(extendedParams.borderSize.value) : undefined
    };
};
/**
 * Removes borderColor and borderSize keys from macroParams entirely.
 */ const $ea287d488ebca970$var$removeBorderFromParameters = (parameters)=>{
    const { borderColor: _bc, borderSize: _bs, ...restMacroParams } = parameters?.macroParams ?? {};
    return {
        ...parameters ?? {},
        macroParams: restMacroParams
    };
};
const $ea287d488ebca970$export$d8d3b5afcdf52490 = (api, color, selectedNode)=>()=>{
        const currentParams = selectedNode.attrs.parameters;
        const extendedParams = currentParams?.macroParams;
        const hasBorderSize = !!extendedParams?.borderSize?.value;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const update = {
            borderColor: color,
            // Only set a default size if none is already stored
            ...!hasBorderSize ? {
                borderSize: $ea287d488ebca970$export$368b62735a1b3872
            } : {}
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newParameters = (0, $ljOiP.setParameters)(currentParams, update);
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: newParameters
                }
            }));
        return true;
    };
const $ea287d488ebca970$export$332491e877ad56a5 = (api, size, selectedNode)=>()=>{
        const currentParams = selectedNode.attrs.parameters;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newParameters = (0, $ljOiP.setParameters)(currentParams, {
            borderSize: size
        });
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: newParameters
                }
            }));
        return true;
    };
const $ea287d488ebca970$export$ad24774c83d7117b = (api, selectedNode)=>()=>{
        const currentParams = selectedNode.attrs.parameters;
        const currentColor = currentParams?.macroParams?.borderColor?.value;
        let newParameters;
        if (currentColor) // Remove border — delete borderColor and borderSize from macroParams
        newParameters = $ea287d488ebca970$var$removeBorderFromParameters(currentParams);
        else // Add border with defaults
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        newParameters = (0, $ljOiP.setParameters)(currentParams, {
            borderColor: $ea287d488ebca970$export$cd1350638370dbe1,
            borderSize: $ea287d488ebca970$export$368b62735a1b3872
        });
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: newParameters
                }
            }));
        return true;
    };






const $87f12a99e92167f9$export$3c49c185de0c2bfc = (selectedNode)=>{
    return (0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'width');
};
const $87f12a99e92167f9$export$ea9f617f119f6cd3 = (api, width, selectedNode, height, opts)=>()=>{
        const { isMaxWidth: isMaxWidth = false, ...docUpdateOpts } = opts ?? {};
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>{
            const params = current.attrs?.parameters;
            let updatedParams = (0, $ljOiP.setParameter)(params, {
                width: width
            });
            updatedParams = (0, $ljOiP.setParameter)(updatedParams, {
                isMaxWidth: isMaxWidth
            });
            if (height !== undefined) updatedParams = (0, $ljOiP.setParameter)(updatedParams, {
                height: height
            });
            return {
                attrs: {
                    ...current.attrs,
                    parameters: updatedParams
                }
            };
        }, docUpdateOpts);
        return true;
    };
const $87f12a99e92167f9$export$e8152faa2a85727 = (isResizing, width)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = state.tr;
            tr.setMeta((0, $d598f2eb7a08550e$export$18d4026d1ea86bb1), {
                type: 'SET_RESIZING',
                isResizing: isResizing,
                width: width
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
        }
        return true;
    };











var $9bUBT = parcelRequire("9bUBT");


var $bI2nS = parcelRequire("bI2nS");




var $hade9 = parcelRequire("hade9");


var $11OF7 = parcelRequire("11OF7");


var $kvJb4 = parcelRequire("kvJb4");


var $foj7F = parcelRequire("foj7F");


var $hWLxu = parcelRequire("hWLxu");


var $9d7Pd = parcelRequire("9d7Pd");


var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");

const $d77861c8602f769f$var$APPEARANCE_OPTIONS = [
    'url',
    'inline',
    'block',
    'embed'
];
const $d77861c8602f769f$var$appearanceMetadataMap = {
    url: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9))),
        message: (0, $bI2nS.messages).urlTitle
    },
    inline: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLxu))),
        message: (0, $bI2nS.messages).inlineTitle
    },
    block: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))),
        message: (0, $bI2nS.messages).blockTitle
    },
    embed: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($foj7F))),
        message: (0, $bI2nS.messages).embedTitle,
        description: (0, $bI2nS.messages).embedToBlockCardWarning
    }
};
const $d77861c8602f769f$var$buildAppearanceDropdownOptions = (intl, onAppearanceClick)=>$d77861c8602f769f$var$APPEARANCE_OPTIONS.map((appearance)=>({
            id: `native-embed-appearance-${appearance}`,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d77861c8602f769f$var$appearanceMetadataMap[appearance].icon, {
                color: 'currentColor',
                label: '',
                spacing: 'spacious'
            }),
            onClick: onAppearanceClick(appearance),
            selected: appearance === 'embed',
            title: intl.formatMessage($d77861c8602f769f$var$appearanceMetadataMap[appearance].message),
            description: $d77861c8602f769f$var$appearanceMetadataMap[appearance].description && intl.formatMessage($d77861c8602f769f$var$appearanceMetadataMap[appearance].description)
        }));
const $d77861c8602f769f$var$NativeEmbedAppearanceMenu = ({ dispatchCommand: dispatchCommand, intl: intl, options: options })=>{
    const preferencesHref = (0, $9bUBT.getLinkPreferencesURLFromENV)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $6IL1T.default), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                children: options.map((option)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
                        iconBefore: option.icon,
                        /* eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders,@atlassian/perf-linting/no-unstable-inline-props  */ onClick: ()=>dispatchCommand(option.onClick),
                        isSelected: option.selected,
                        description: option.description,
                        shouldDescriptionWrap: true,
                        children: option.title
                    }, option.id ?? option.title))
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($11OF7))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    }),
                    href: preferencesHref,
                    target: "_blank",
                    children: intl.formatMessage((0, $iEFx5.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $d77861c8602f769f$export$8777833158c4a88c = ({ intl: intl, onAppearanceClick: onAppearanceClick })=>{
    const options = $d77861c8602f769f$var$buildAppearanceDropdownOptions(intl, onAppearanceClick);
    const dropdownOptions = {
        render: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)($d77861c8602f769f$var$NativeEmbedAppearanceMenu, {
                dispatchCommand: props.dispatchCommand,
                intl: intl,
                options: options
            }),
        width: 220,
        height: 260
    };
    const title = intl.formatMessage($d77861c8602f769f$var$appearanceMetadataMap.embed.message);
    const iconBefore = $d77861c8602f769f$var$appearanceMetadataMap.embed.icon;
    return {
        id: 'native-embed-appearance-dropdown',
        type: 'dropdown',
        testId: 'native-embed-appearance-dropdown',
        title: title,
        iconBefore: iconBefore,
        options: dropdownOptions
    };
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $koQIB = parcelRequire("koQIB");

function $a0b3fecddae323a7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a0b3fecddae323a7$var$buttonWrapperStyles = {
    name: "1tyrre4",
    styles: "& button{&::after{display:none;}}"
};
const $a0b3fecddae323a7$var$buttonOverlaySurfaceStyles = {
    name: "1u6x4so",
    styles: "& button{background-color:var(--ds-surface-overlay, #FFFFFF);}& button:hover{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}"
};
const $a0b3fecddae323a7$var$buttonLabelStyles = {
    name: "5703k4",
    styles: "color:var(--ds-text-subtle, #505258)"
};
const $a0b3fecddae323a7$var$buttonSpacingStyles = {
    name: "ucxi6t",
    styles: "& button{padding-inline:var(--ds-space-100, 8px);gap:var(--ds-space-075, 6px);}"
}; /**
    * Renders the Ask Rovo button for the native embed floating toolbar.
    */ 
function $a0b3fecddae323a7$export$cc61d4d88dbc5bf9({ button: button, isDisabled: isDisabled, onClick: onClick }) {
    const tooltipContent = typeof button.tooltipContent !== 'function' ? button.tooltipContent : undefined;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $a0b3fecddae323a7$var$buttonWrapperStyles,
            $a0b3fecddae323a7$var$buttonOverlaySurfaceStyles,
            $a0b3fecddae323a7$var$buttonSpacingStyles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $koQIB.ConversationAssistantButtonNav4), {
        isActive: false,
        isDisabled: isDisabled,
        label: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: $a0b3fecddae323a7$var$buttonLabelStyles
        }, button.title),
        onClick: onClick,
        productKey: "confluence",
        siteId: "stub-site-id",
        tooltipContent: tooltipContent
    }));
}





parcelRequire("cozmU");





var $3FyXx = parcelRequire("3FyXx");











const $62a3743d70492368$export$98ee8d0cf866fa75 = (selectedNode)=>{
    return (0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'url');
};
const $62a3743d70492368$export$179dd5c00c1b0557 = (selectedNode)=>()=>{
        const url = $62a3743d70492368$export$98ee8d0cf866fa75(selectedNode);
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
        return true;
    };
const $62a3743d70492368$export$fff41c4cbbf6af3e = (selectedNode)=>()=>{
        const url = $62a3743d70492368$export$98ee8d0cf866fa75(selectedNode);
        if (url) navigator.clipboard.writeText(url);
        return true;
    };
const $62a3743d70492368$export$15a48157d97d7f65 = (state, dispatch)=>{
    dispatch?.(state.tr.setMeta((0, $d598f2eb7a08550e$export$18d4026d1ea86bb1), {
        type: 'SHOW_URL_TOOLBAR'
    }));
    return true;
};
const $62a3743d70492368$export$61961fed5a5ec57a = (state, dispatch)=>{
    dispatch?.(state.tr.setMeta((0, $d598f2eb7a08550e$export$18d4026d1ea86bb1), {
        type: 'HIDE_URL_TOOLBAR'
    }));
    return true;
};
const $62a3743d70492368$export$c5f149c9cc530c8e = (href)=>(state, dispatch)=>{
        const { embedCard: embedCard } = state.schema.nodes;
        if (!embedCard) return false;
        const selectedNode = state.selection.node;
        if (!selectedNode) return false;
        const embedCardNode = embedCard.createChecked({
            url: href,
            layout: 'center'
        });
        const { from: from, to: to } = state.selection;
        const tr = state.tr.replaceWith(from, to, embedCardNode);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };


const $113683d07a1f0e4a$export$dc6224f1e35e5cf8 = ({ api: api, linkPickerOptions: linkPickerOptions, lpLinkPicker: lpLinkPicker, providerFactory: providerFactory, selectedNativeEmbed: selectedNativeEmbed, view: view })=>{
    const currentUrl = (0, $ljOiP.getParameters)(selectedNativeEmbed.node.attrs.parameters, 'url');
    const currentDisplayText = (0, $ljOiP.getParameters)(selectedNativeEmbed.node.attrs.parameters, 'displayText');
    const localId = selectedNativeEmbed.node.attrs.localId;
    const onSubmit = (href, _title, displayText)=>{
        (0, $62a3743d70492368$export$61961fed5a5ec57a)(view.state, view.dispatch);
        const urlChanged = href !== currentUrl;
        const displayTextChanged = displayText !== currentDisplayText;
        if (urlChanged) {
            // If the new URL is no longer supported by any native embed experience,
            // convert the native embed extension back to a standard embed card.
            const isNativeEmbedUrl = Boolean((0, $iwIwp.getNativeEmbedFacade)().getManifestByUrl(href));
            if (!isNativeEmbedUrl) {
                (0, $62a3743d70492368$export$c5f149c9cc530c8e)(href)(view.state, view.dispatch);
                return;
            }
        }
        if ((urlChanged || displayTextChanged) && localId) {
            const extensionApi = api?.extension?.actions?.api();
            if (extensionApi?.doc?.update) extensionApi.doc.update(localId, (current)=>({
                    attrs: {
                        ...current.attrs,
                        parameters: (0, $ljOiP.setParameter)(current.attrs?.parameters, {
                            url: href,
                            displayText: displayText
                        })
                    }
                }));
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3FyXx.HyperlinkAddToolbar), {
        view: view,
        providerFactory: providerFactory,
        linkPickerOptions: linkPickerOptions,
        displayUrl: currentUrl,
        displayText: currentDisplayText,
        lpLinkPicker: lpLinkPicker,
        invokeMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onSubmit: (href, title, displayText)=>onSubmit(href, title, displayText),
        onEscapeCallback: (0, $62a3743d70492368$export$61961fed5a5ec57a),
        onClickAwayCallback: (0, $62a3743d70492368$export$61961fed5a5ec57a)
    });
};
const $113683d07a1f0e4a$export$13e482484d5c4da9 = (props)=>({
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view)=>view ? /*#__PURE__*/ (0, $8aG6j.jsx)($113683d07a1f0e4a$export$dc6224f1e35e5cf8, {
                api: props.api,
                linkPickerOptions: props.linkPickerOptions,
                lpLinkPicker: props.lpLinkPicker,
                providerFactory: props.providerFactory,
                selectedNativeEmbed: props.selectedNativeEmbed,
                view: view
            }) : null
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled










var $lBKFk = parcelRequire("lBKFk");





var $a79Sy = parcelRequire("a79Sy");


var $kTb7m = parcelRequire("kTb7m");





var $c0A7H = parcelRequire("c0A7H");






const $d2f33fb2ab6a837a$export$3b3f7272b13b81ea = (selectedNode)=>{
    return (0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'alwaysShowTitle');
};
const $d2f33fb2ab6a837a$export$9f930146f49815d = (api, selectedNode)=>()=>{
        const localId = selectedNode.attrs.localId;
        if (!localId) return;
        const extensionApi = api?.extension?.actions?.api();
        if (!extensionApi?.doc?.update) return;
        const current = $d2f33fb2ab6a837a$export$3b3f7272b13b81ea(selectedNode);
        extensionApi.doc.update(localId, (node)=>({
                attrs: {
                    ...node.attrs,
                    parameters: (0, $ljOiP.setParameter)(node.attrs?.parameters, {
                        alwaysShowTitle: !current
                    })
                }
            }), {
            scrollIntoView: false
        });
    };


function $8956bd0cd4887675$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8956bd0cd4887675$var$toggleButtonStyles = {
    name: "1u30rvm",
    styles: "display:flex;align-items:center;cursor:default;&&{background:none;border:none;padding:0;min-height:unset;}& label{margin:0;}"
};
const $8956bd0cd4887675$var$createHandlerCommand = (handler)=>()=>{
        handler?.();
        return true;
    };
function $8956bd0cd4887675$var$convertCustomActionToDropdownOption(action, parameters, editorToolbarHandlers) {
    const IconComponent = action.icon;
    const handler = editorToolbarHandlers[action.handlerKey];
    return {
        id: `native-embed-${action.key}`,
        title: action.label,
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)(IconComponent, {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        disabled: action.disabled,
        onClick: $8956bd0cd4887675$var$createHandlerCommand(handler ? ()=>handler(parameters) : undefined)
    };
}
/**
 * Creates a registry of built-in "More Options" dropdown items.
 */ function $8956bd0cd4887675$var$createBuiltinMoreOptionsRegistry(api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, intl) {
    const toggleAlwaysShowTitle = (0, $d2f33fb2ab6a837a$export$9f930146f49815d)(api, selectedNativeEmbed.node);
    return {
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE]: {
            id: 'native-embed-always-show-title',
            title: intl.formatMessage((0, $94ce71f66457d23a$export$cdc1205423c9f2de).alwaysShowTitle),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
                type: "button",
                css: $8956bd0cd4887675$var$toggleButtonStyles,
                onClick: (e)=>{
                    e.stopPropagation();
                    toggleAlwaysShowTitle();
                }
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c0A7H.default), {
                isChecked: (0, $d2f33fb2ab6a837a$export$3b3f7272b13b81ea)(selectedNativeEmbed.node),
                label: intl.formatMessage((0, $94ce71f66457d23a$export$cdc1205423c9f2de).alwaysShowTitle)
            })),
            onClick: editorToolbarHandlers.onShowTitleClick()
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SET_EMBED_TYPE]: {
            id: 'native-embed-set-embed-type',
            title: intl.formatMessage((0, $94ce71f66457d23a$export$cdc1205423c9f2de).setEmbedType),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onSetEmbedTypeClick()
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY]: {
            id: 'native-embed-copy',
            title: intl.formatMessage((0, $05b362cd50fa2589$export$271a7654ce32757b).copy),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onCopyClick()
        },
        /**
     * @private
     * @deprecated Use COPY instead. Will be removed in a follow-up PR.
     */ [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY_LINK]: {
            id: 'native-embed-copy-link',
            title: intl.formatMessage((0, $3FYPH.messages).copyLink),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onCopyLinkClick()
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE]: {
            id: 'native-embed-delete',
            title: intl.formatMessage((0, $3FYPH.messages).deleteBlock),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onDeleteClick(),
            ...deleteHoverProps
        }
    };
}
const $8956bd0cd4887675$var$DEFAULT_MORE_OPTIONS = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SET_EMBED_TYPE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
];
function $8956bd0cd4887675$var$resolveMoreOptions(items, builtinRegistry, customActions, parameters, editorToolbarHandlers) {
    const options = [];
    for (const key of items){
        if (key === (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR) options.push({
            type: 'separator'
        });
        else if (key in builtinRegistry) options.push(builtinRegistry[key]);
        else if (customActions && key in customActions) options.push($8956bd0cd4887675$var$convertCustomActionToDropdownOption(customActions[key], parameters, editorToolbarHandlers));
    }
    return options;
}
const $8956bd0cd4887675$export$6030df2c7cd7819c = (api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, parameters, intl, moreItems, customActions)=>{
    const builtinRegistry = $8956bd0cd4887675$var$createBuiltinMoreOptionsRegistry(api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, intl);
    const items = moreItems ?? $8956bd0cd4887675$var$DEFAULT_MORE_OPTIONS;
    const options = $8956bd0cd4887675$var$resolveMoreOptions(items, builtinRegistry, customActions, parameters, editorToolbarHandlers);
    return {
        id: 'native-embed-more-options-button',
        testId: 'native-embed-more-options-button',
        type: 'overflow-dropdown',
        dropdownWidth: 250,
        options: options
    };
};


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");





var $ixa4K = parcelRequire("ixa4K");


var $feeMI = parcelRequire("feeMI");


var $7XIuB = parcelRequire("7XIuB");


var $3aDYK = parcelRequire("3aDYK");

var $8VCvx = parcelRequire("8VCvx");

var $7xQNd = parcelRequire("7xQNd");


var $g9ric = parcelRequire("g9ric");

var $9RT19 = parcelRequire("9RT19");

var $gLi18 = parcelRequire("gLi18");

var $ldbHR = parcelRequire("ldbHR");


var $czp8P = parcelRequire("czp8P");


var $lRXxm = parcelRequire("lRXxm");


var $7sJoX = parcelRequire("7sJoX");


var $fxA94 = parcelRequire("fxA94");


var $fRmp0 = parcelRequire("fRmp0");


var $jdueN = parcelRequire("jdueN");


var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");

// packages/editor/editor-core/src/plugins/floating-toolbar/ui/DropdownMenu.tsx
const $5737ffde100b61ed$var$menuItemDimensions = {
    width: 175,
    height: 32
};
const $5737ffde100b61ed$var$itemSpacing = 4; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$contextualMenuArrow = null; // top is set via inline style per usage (dynamic index not extractable by @compiled)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$contextualSubMenuBase = null; // Pre-computed top offsets for submenu indices 0 and 1
const $5737ffde100b61ed$var$contextualSubMenuTop0 = 0;
const $5737ffde100b61ed$var$contextualSubMenuTop1 = $5737ffde100b61ed$var$menuItemDimensions.height + $5737ffde100b61ed$var$itemSpacing * 2; // backgroundColor is set via inline style (selected state not extractable by @compiled)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/design-system/use-tokens-shape -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$buttonStyleBase = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$buttonWrapperStyle = null; // Static base — enabled/isOpen hover states applied via separate conditional css objects
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$toolbarButtonWrapperBase = null; // Applied when !enabled: show hover highlight on the main button
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$toolbarButtonWrapperHoverBtn = null; // Applied when !isOpen && !enabled: show hover highlight on the dropdown button
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$toolbarButtonWrapperHoverDropdown = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$dropdownOptionButton = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$dropdownWrapper = null;
const $5737ffde100b61ed$var$NativeEmbedBorder = ({ intl: { formatMessage: formatMessage }, borderColor: borderColor, borderSize: borderSize, toggleBorder: toggleBorder, setBorderColor: setBorderColor, setBorderSize: setBorderSize })=>{
    const popupTarget = (0, $cozmU.useRef)(null);
    const dropDownColorOptionButton = (0, $cozmU.useRef)(null);
    const dropDownSizeOptionButton = (0, $cozmU.useRef)(null);
    const colorSubmenuRef = (0, $cozmU.useRef)(null);
    const sizeSubmenuRef = (0, $cozmU.useRef)(null);
    const openDropdownButtonRef = (0, $cozmU.useRef)(null);
    const enabled = !!borderColor;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isOpenByKeyboard, setIsOpenedByKeyboard] = (0, $cozmU.useState)(false);
    const [isColorSubmenuOpen, setIsColorSubmenuOpen] = (0, $cozmU.useState)(false);
    const [isSizeSubmenuOpen, setIsSizeSubmenuOpen] = (0, $cozmU.useState)(false);
    const handleColorSubmenuEsc = (0, $cozmU.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsColorSubmenuOpen(false);
        dropDownColorOptionButton?.current?.focus();
    }, []);
    const handleSizeSubmenuEsc = (0, $cozmU.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsSizeSubmenuOpen(false);
        dropDownSizeOptionButton?.current?.focus();
    }, []);
    const handleSubMenuRef = (ref)=>{
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        if (rect.left + rect.width > window.innerWidth) ref.style.left = `-${rect.width}px`;
    };
    const handleTriggerByKeyboard = (event, allowedKeys, callback)=>{
        if (!allowedKeys.includes(event.key)) return;
        event.preventDefault();
        callback();
        setIsOpenedByKeyboard(true);
    };
    const handleTriggerToolbarByKeyboard = (event, callback)=>{
        handleTriggerByKeyboard(event, [
            'Enter',
            ' '
        ], callback);
    };
    const handleTriggerSubmenuByKeyboard = (event, callback)=>{
        handleTriggerByKeyboard(event, [
            'Enter',
            'ArrowRight'
        ], callback);
    };
    (0, $cozmU.useEffect)(()=>{
        const focusFirstOption = (submenuRef, isOpen)=>{
            if (!isOpenByKeyboard) return;
            if (isOpen && submenuRef.current) {
                const firstOption = submenuRef.current.querySelector('button');
                if (!firstOption) return;
                firstOption.focus();
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                firstOption.dispatchEvent(keyboardEvent);
            }
        };
        focusFirstOption(colorSubmenuRef, isColorSubmenuOpen);
        focusFirstOption(sizeSubmenuRef, isSizeSubmenuOpen);
    }, [
        isColorSubmenuOpen,
        isSizeSubmenuOpen,
        isOpenByKeyboard
    ]);
    const borderSizeOptions = [
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeSubtle),
            value: 1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdueN)))
        },
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeMedium),
            value: 2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fRmp0)))
        },
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeBold),
            value: 3,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxA94)))
        }
    ];
    const items = [
        {
            content: /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
                        ref: dropDownColorOptionButton,
                        type: "button",
                        "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderColorDropdownAriaLabel),
                        "data-testid": "native-embed-border-dropdown-button-color",
                        "aria-expanded": isColorSubmenuOpen,
                        onKeyDown: (e)=>handleTriggerSubmenuByKeyboard(e, ()=>{
                                setIsColorSubmenuOpen((prev)=>{
                                    const next = !prev;
                                    if (next) setIsSizeSubmenuOpen(false);
                                    return next;
                                });
                            }),
                        className: (0, $hekY6.default)([
                            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2V7sgO2M4S _3hxITi6wH8 _3vBAKHjOvk _0KLXrujOvk _3iDTPbQ4SZ _39xV02N91d _0hPCNLDIqT _37wbyuI7V3 _0xkEdpnXvL _1iy5hxo126"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                children: formatMessage((0, $ixa4K.imageBorderMessages).borderColor)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                className: (0, $hekY6.default)([
                                    "_3iDTPbQ4SZ _0GBAIrhvWj _1G7t7N1Y8M _2GPgly8ujp"
                                ])
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU,
                        ref: colorSubmenuRef,
                        children: isColorSubmenuOpen && /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic top offset required
                        , {
                            style: {
                                top: `${$5737ffde100b61ed$var$contextualSubMenuTop0}px`
                            },
                            ref: handleSubMenuRef,
                            className: (0, $hekY6.default)([
                                "_0bjKvDzXzM _0KLXruoI2d _2OUyjtGk8v _3iDTPbQ4SZ _1mT5xdWVPG _3OE6xYPZWa _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _1C8dRadnbC _0rUhZjdnbC _3c7I3RdnbC _1stIVYdnbC"
                            ]),
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
                                type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                                handleClose: (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleColorSubmenuEsc();
                                },
                                disableCloseOnArrowClick: true,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7xQNd.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                ), {
                                    onClick: (color)=>{
                                        setBorderColor(color);
                                        setIsOpen(false);
                                    },
                                    onKeyDown: (color, _, event)=>{
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            setBorderColor(color);
                                            setIsOpen(false);
                                            setIsColorSubmenuOpen(false);
                                            setIsSizeSubmenuOpen(false);
                                            openDropdownButtonRef.current?.focus();
                                        }
                                    },
                                    selectedColor: borderColor ?? null,
                                    paletteOptions: {
                                        palette: (0, $3aDYK.default),
                                        paletteColorTooltipMessages: (0, $8VCvx.borderPaletteTooltipMessages),
                                        hexToPaletteColor: (0, $czp8P.hexToEditorBorderPaletteColor)
                                    }
                                })
                            })
                        })
                    })
                ]
            }),
            'data-testid': 'dropdown-item__Color',
            key: 'dropdown-menu-native-embed-border-color-button',
            value: {
                name: 'color'
            },
            'aria-label': '',
            wrapperTabIndex: null
        },
        {
            content: /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
                        type: "button",
                        "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderSizeDropdownAriaLabel),
                        "data-testid": "native-embed-border-dropdown-button-size",
                        /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ "aria-expanded": isSizeSubmenuOpen,
                        ref: dropDownSizeOptionButton,
                        onKeyDown: (e)=>handleTriggerSubmenuByKeyboard(e, ()=>{
                                setIsSizeSubmenuOpen((prev)=>{
                                    const next = !prev;
                                    if (next) setIsColorSubmenuOpen(false);
                                    return next;
                                });
                            }),
                        className: (0, $hekY6.default)([
                            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2V7sgO2M4S _3hxITi6wH8 _3vBAKHjOvk _0KLXrujOvk _3iDTPbQ4SZ _39xV02N91d _0hPCNLDIqT _37wbyuI7V3 _0xkEdpnXvL _1iy5hxo126"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                children: formatMessage((0, $ixa4K.imageBorderMessages).borderSize)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                className: (0, $hekY6.default)([
                                    "_3iDTPbQ4SZ _0GBAIrhvWj _1G7t7N1Y8M _2GPgly8ujp"
                                ])
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU,
                        ref: sizeSubmenuRef,
                        children: isSizeSubmenuOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
                            type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                            handleClose: (e)=>{
                                e.preventDefault();
                                handleSizeSubmenuEsc();
                            },
                            disableCloseOnArrowClick: true,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic top offset required
                            , {
                                style: {
                                    top: `${$5737ffde100b61ed$var$contextualSubMenuTop1}px`
                                },
                                ref: handleSubMenuRef,
                                className: (0, $hekY6.default)([
                                    "_0bjKvDzXzM _0KLXruoI2d _2OUyjtGk8v _3iDTPbQ4SZ _1mT5xdWVPG _3OE6xYPZWa _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _1C8dRadnbC _0rUhZjdnbC _3c7I3RdnbC _1stIVYdnbC"
                                ]),
                                children: borderSizeOptions.map(({ name: name, value: value, icon: icon }, idx)=>{
                                    // Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    const ButtonIcon = icon;
                                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                                        content: name,
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                            className: (0, $hekY6.default)([
                                                "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKTcp _3vBAKHjOvk _3hxITi6wH8 _2V7sgONvrM _313842FQfX _0adFHsgVvo _1DCdHiFQfX _2XsHFMFQfX _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _0xkEdp9r67 _1jJ2xk9r67 _0hPERG9r67"
                                            ]),
                                            children: /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                                                type: "button",
                                                style: {
                                                    backgroundColor: value === borderSize ? "var(--ds-text, #292A2E)" : "var(--ds-background-neutral, #0515240F)"
                                                },
                                                "aria-label": name,
                                                role: "radio",
                                                "aria-checked": value === borderSize,
                                                onClick: ()=>{
                                                    setBorderSize(value);
                                                    setIsOpen(false);
                                                },
                                                onKeyDown: (event)=>{
                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                        setBorderSize(value);
                                                        setIsOpen(false);
                                                        setIsColorSubmenuOpen(false);
                                                        setIsSizeSubmenuOpen(false);
                                                        openDropdownButtonRef.current?.focus();
                                                    }
                                                },
                                                onMouseDown: (e)=>{
                                                    e.preventDefault();
                                                },
                                                className: (0, $hekY6.default)([
                                                    "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0bjKvDKxmn _30huDKNCjk _0jFU0VXjOh _39xV02XjOh _0wOv4Q7zJH _3iDTPbvLZJ"
                                                ]),
                                                children: /*#__PURE__*/ (0, $8aG6j.jsx)(ButtonIcon, {
                                                    color: value === borderSize ? "var(--ds-icon-inverse, #FFFFFF)" : 'currentColor',
                                                    spacing: "spacious",
                                                    label: ""
                                                })
                                            })
                                        })
                                    }, value);
                                })
                            })
                        })
                    })
                ]
            }),
            'data-testid': 'dropdown-item__Size',
            key: 'dropdown-menu-native-embed-border-size-button',
            value: {
                name: 'size'
            },
            'aria-label': '',
            wrapperTabIndex: null
        }
    ];
    const fitTolerance = 10;
    const fitWidth = $5737ffde100b61ed$var$menuItemDimensions.width;
    const fitHeight = items.length * ($5737ffde100b61ed$var$menuItemDimensions.height + $5737ffde100b61ed$var$itemSpacing);
    const isAnySubMenuOpen = isSizeSubmenuOpen || isColorSubmenuOpen;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _3WnBpzdnbC _3lek9IdnbC _0xoxQjdnbC _2ohVmldnbC _2VwcDIYbGa _2tIZMednbC _2iD5MIdnbC _2L5PptdnbC _4b2PHudnbC _1SNkEOdnbC _3Eg8tBdnbC _4agDqWdnbC _0oSCRbdnbC _1jEfLzdnbC _11iFdRdnbC _40pvfcYbGa _07isDRdnbC _4ep9xMdnbC _2FsIHbdnbC _3MP3kOdnbC _1B6x7DIRC9 _0gy92ZAASz _2BQqqNAASz _0jkAlgFQfX",
                    !enabled && "_4a9X0jo126",
                    !isOpen && !enabled && "_3qKl4Go126"
                ]),
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- className required to target CSS selectors in toolbarButtonWrapper
                    ), {
                        className: "native-embed-border-toolbar-btn",
                        selected: enabled,
                        onClick: toggleBorder,
                        spacing: "compact",
                        "aria-label": enabled ? formatMessage((0, $ixa4K.imageBorderMessages).removeBorder) : formatMessage((0, $ixa4K.imageBorderMessages).addBorder),
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lRXxm))), {
                            color: "currentColor",
                            label: "",
                            spacing: "spacious"
                        }),
                        title: enabled ? formatMessage((0, $ixa4K.imageBorderMessages).removeBorder) : formatMessage((0, $ixa4K.imageBorderMessages).addBorder)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        ref: popupTarget,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- className required to target CSS selectors in toolbarButtonWrapper
                        ), {
                            className: "native-embed-border-toolbar-dropdown",
                            ref: openDropdownButtonRef,
                            selected: enabled || isOpen,
                            "aria-expanded": isOpen,
                            "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderOptions),
                            title: formatMessage((0, $ixa4K.imageBorderMessages).borderOptions),
                            spacing: "compact",
                            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                                color: "currentColor",
                                spacing: "spacious",
                                label: "",
                                size: "small"
                            }),
                            onClick: ()=>{
                                setIsOpen(!isOpen);
                                setIsOpenedByKeyboard(false);
                            },
                            onKeyDown: (e)=>handleTriggerToolbarByKeyboard(e, ()=>setIsOpen(!isOpen))
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
                target: popupTarget.current ? popupTarget.current : undefined,
                fitWidth: fitWidth + fitTolerance,
                fitHeight: fitHeight + fitTolerance,
                forcePlacement: true,
                stick: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    onMouseLeave: ()=>{
                        setIsColorSubmenuOpen(false);
                        setIsSizeSubmenuOpen(false);
                    },
                    onBlur: ()=>{
                        setIsColorSubmenuOpen(false);
                        setIsSizeSubmenuOpen(false);
                    },
                    className: (0, $hekY6.default)([
                        "_4yaZqadnbC _16MBIHdnbC _04KsFKdnbC _06cBbSdnbC"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gLi18.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    ), {
                        arrowKeyNavigationProviderOptions: {
                            type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                            disableArrowKeyNavigation: isAnySubMenuOpen
                        },
                        allowEnterDefaultBehavior: isAnySubMenuOpen,
                        handleEscapeKeydown: isAnySubMenuOpen ? ()=>{
                            return;
                        } : ()=>{
                            openDropdownButtonRef.current?.focus();
                        },
                        items: [
                            {
                                items: items
                            }
                        ],
                        isOpen: isOpen,
                        shouldFocusFirstItem: ()=>isOpenByKeyboard,
                        onOpenChange: ()=>{
                            setIsOpen(false);
                            setIsColorSubmenuOpen(false);
                            setIsSizeSubmenuOpen(false);
                            setIsOpenedByKeyboard(false);
                        },
                        onItemActivated: ({ item: item })=>{
                            if (item.value.name === 'color') setIsColorSubmenuOpen((prev)=>{
                                const next = !prev;
                                if (next) setIsSizeSubmenuOpen(false);
                                return next;
                            });
                            if (item.value.name === 'size') setIsSizeSubmenuOpen((prev)=>{
                                const next = !prev;
                                if (next) setIsColorSubmenuOpen(false);
                                return next;
                            });
                        },
                        onMouseEnter: ({ item: item })=>{
                            if (item.value.name === 'color') {
                                setIsColorSubmenuOpen(true);
                                setIsOpenedByKeyboard(false);
                            }
                            if (item.value.name === 'size') {
                                setIsSizeSubmenuOpen(true);
                                setIsOpenedByKeyboard(false);
                            }
                        },
                        onMouseLeave: ({ item: item })=>{
                            if (item.value.name === 'color') setIsColorSubmenuOpen(false);
                            if (item.value.name === 'size') setIsSizeSubmenuOpen(false);
                        },
                        fitWidth: fitWidth + fitTolerance,
                        fitHeight: fitHeight + fitTolerance
                    })
                })
            })
        ]
    });
};
var $5737ffde100b61ed$export$2e2bcd8739ae039 = $5737ffde100b61ed$var$NativeEmbedBorder;





var $1SZMn = parcelRequire("1SZMn");


var $jfFbl = parcelRequire("jfFbl");


var $1TzXg = parcelRequire("1TzXg");



















const $45134b38997529c5$export$f0989780f32bfcda = (selectedNode)=>{
    return (0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'alignment');
};
const $45134b38997529c5$export$c29861a26436e3b2 = (api, alignment, selectedNode, opts)=>()=>{
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: (0, $ljOiP.setParameter)(current.attrs?.parameters, {
                        alignment: alignment
                    })
                }
            }), opts);
        return true;
    };











function $27b07c57841355c7$var$buildUrlReplacement(schema, url) {
    const { link: link } = schema.marks;
    if (!link) return null;
    const linkContent = schema.text(url, [
        link.create({
            href: url
        })
    ]);
    return schema.nodes.paragraph.create(null, linkContent);
}
function $27b07c57841355c7$var$buildCardReplacement(schema, appearance, url) {
    const cardType = appearance === 'inline' ? schema.nodes.inlineCard : schema.nodes.blockCard;
    if (!cardType) return null;
    const cardNode = cardType.create({
        url: url
    });
    return appearance === 'inline' ? schema.nodes.paragraph.create(null, cardNode) : cardNode;
}
const $27b07c57841355c7$export$22fb0ae5e9d8c713 = (selected, appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        if (appearance === 'embed') return false;
        const { pos: pos, node: node } = selected;
        const { schema: schema } = state;
        const url = (0, $ljOiP.getParameter)(node.attrs.parameters, 'url');
        let content = null;
        if (url && (0, $73a6g.isSafeUrl)(url)) {
            if (appearance === 'url') content = $27b07c57841355c7$var$buildUrlReplacement(schema, url);
            else if (appearance === 'inline' || appearance === 'block') content = $27b07c57841355c7$var$buildCardReplacement(schema, appearance, url);
        }
        if (content && dispatch) {
            const tr = state.tr.replaceWith(pos, pos + node.nodeSize, content).scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: appearance,
                    previousType: 'nativeEmbed'
                }
            })(tr);
            dispatch(tr);
        }
        return true;
    };



const $9f384a008ac93b94$var$createHandlerCommand = (handler)=>()=>{
        handler?.();
        return true;
    };
function $9f384a008ac93b94$var$wrapManifestHandler(handler, parameters, handlerContext) {
    return ()=>$9f384a008ac93b94$var$createHandlerCommand(()=>handler(parameters, handlerContext));
}
function $9f384a008ac93b94$var$wrapManifestHandlerWithContext(handler, parameters, handlerContext) {
    return (context)=>$9f384a008ac93b94$var$createHandlerCommand(()=>handler(parameters, context, handlerContext));
}
/**
 * Extracts the hostname from a URL string for use as a fallback display name
 * in the Rovo chat context banner.
 */ function $9f384a008ac93b94$var$getHostnameFromUrl(url) {
    try {
        return new URL(url).hostname;
    } catch  {
        return '';
    }
}
function $9f384a008ac93b94$var$isMauiNativeEmbed(extensionKey) {
    return extensionKey === `${0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY}:maui`;
}
function $9f384a008ac93b94$var$createCopyNodeCommand(selectedNativeEmbed, api) {
    return (state, dispatch)=>{
        if (!dispatch) return true;
        const node = selectedNativeEmbed.node;
        const nodeWithoutAnnotations = node.mark(node.marks.filter((mark)=>mark.type.name !== 'annotation'));
        const domNode = (0, $1TzXg.toDOM)(nodeWithoutAnnotations, state.schema);
        (0, $1TzXg.copyDomNode)(domNode, nodeWithoutAnnotations.type, state.selection);
        const tr = state.tr;
        const analyticsPayload = (0, $jfFbl.getNodeCopiedAnalyticsPayload)(node, (0, $krYZG.INPUT_METHOD).FLOATING_TB);
        api?.analytics?.actions.attachAnalyticsEvent(analyticsPayload)(tr);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
        return true;
    };
}
/**
 * Opens all unresolved comments on the selected native embed. If there are no
 * unresolved comments, starts a whole-block draft through the annotation plugin.
 */ function $9f384a008ac93b94$var$createCommentCommand(selectedNativeEmbed, api) {
    return (state, dispatch)=>{
        const annotationActions = api.annotation?.actions;
        if (!annotationActions) return false;
        // Native embeds use the same block-comment path as media. Passing this
        // through lets the Confluence provider position/open the draft editor from
        // the floating toolbar instead of treating it as a regular selection.
        const isOpeningCommentFromToolbar = (0, $iDrrr.fg)('cc_maui_annotations_on_extensions') ? true : undefined;
        const openedExistingComments = annotationActions.showCommentForBlockNode(selectedNativeEmbed.node, (0, $1SZMn.VIEW_METHOD).COMMENT_BUTTON, isOpeningCommentFromToolbar)(state, dispatch);
        if (openedExistingComments) return true;
        const localId = selectedNativeEmbed.node.attrs?.localId;
        return annotationActions.setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).FLOATING_TB, 'block', typeof localId === 'string' ? localId : undefined, isOpeningCommentFromToolbar)(state, dispatch);
    };
}
function $9f384a008ac93b94$export$f4fb53cb783b2797(selectedNativeEmbed, api, intl, schema, parameters) {
    const node = selectedNativeEmbed.node;
    const isInViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
    const askRovoTarget = !isInViewMode && $9f384a008ac93b94$var$isMauiNativeEmbed(node.attrs?.extensionKey) && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? 'remix-app' : 'default';
    const embedUrl = parameters.url ?? '';
    const embedName = $9f384a008ac93b94$var$getHostnameFromUrl(embedUrl);
    const askRovoButton = api?.aiExperience?.actions?.getAskRovoFloatingToolbarButton?.({
        intl: intl,
        triggeredFor: schema.nodes.extension,
        target: askRovoTarget,
        openInRovoChat: true,
        rovoChatAIFeatureContext: embedName ? {
            projectContext: {
                projectId: embedUrl,
                projectName: embedName,
                projectUrl: embedUrl
            }
        } : undefined
    });
    const summariseButton = parameters.url ? api?.aiExperience?.actions?.getSummariseSmartlinkFloatingToolbarButton?.({
        intl: intl,
        smartlinkUrl: parameters.url,
        triggeredFor: schema.nodes.extension
    }) : undefined;
    return {
        onAppearanceClick: (appearance)=>(0, $27b07c57841355c7$export$22fb0ae5e9d8c713)(selectedNativeEmbed, appearance, api?.analytics?.actions),
        onAlignmentClick: (alignment)=>(0, $45134b38997529c5$export$c29861a26436e3b2)(api, alignment, node),
        onCommentClick: api?.annotation ? ()=>$9f384a008ac93b94$var$createCommentCommand(selectedNativeEmbed, api) : undefined,
        onCopyClick: ()=>$9f384a008ac93b94$var$createCopyNodeCommand(selectedNativeEmbed, api),
        onCopyLinkClick: ()=>(0, $62a3743d70492368$export$fff41c4cbbf6af3e)(node),
        onDeleteClick: ()=>(0, $2b3b139efe9f8926$export$fca8c83126802dc4)(selectedNativeEmbed),
        onShowTitleClick: ()=>$9f384a008ac93b94$var$createHandlerCommand((0, $d2f33fb2ab6a837a$export$9f930146f49815d)(api, node)),
        onExpandClick: ()=>(_state, _dispatch, view)=>{
                if (view) try {
                    const domRef = (0, $bjg0G.findDomRefAtPos)(selectedNativeEmbed.pos, view.domAtPos.bind(view));
                    if (domRef instanceof HTMLElement) {
                        const extensionContainer = domRef.classList.contains('extension-container') ? domRef : domRef.querySelector('.extension-container') ?? domRef;
                        extensionContainer.dispatchEvent(new CustomEvent('native-embed-open-fullscreen', {
                            bubbles: true
                        }));
                    }
                } catch  {
                // ignore
                }
                return true;
            },
        onOpenInNewWindowClick: ()=>(0, $62a3743d70492368$export$179dd5c00c1b0557)(node),
        onEditUrlClick: ()=>(0, $62a3743d70492368$export$15a48157d97d7f65),
        onEditClick: ()=>(0, $62a3743d70492368$export$15a48157d97d7f65),
        askRovoButton: askRovoButton,
        onAskRovoClick: askRovoButton ? ()=>askRovoButton.onClick : undefined,
        getRemixButton: (0, $iDrrr.fg)('maui_remixable_page_native_embeds') ? api?.malleableUi?.actions?.getRemixFloatingToolbarButton : undefined,
        getRemixVariantButton: api?.malleableUi?.actions?.getRemixVariantFloatingToolbarButton,
        onSummariseClick: ()=>summariseButton?.onClick ?? $9f384a008ac93b94$var$createHandlerCommand(()=>{}),
        onRefreshClick: ()=>$9f384a008ac93b94$var$createHandlerCommand(()=>{}),
        onChangeBorderClick: ()=>$9f384a008ac93b94$var$createHandlerCommand(()=>{}),
        onSetEmbedTypeClick: ()=>$9f384a008ac93b94$var$createHandlerCommand(()=>{})
    };
}
function $9f384a008ac93b94$export$dfa1706461ea0aa3(selectedNativeEmbed, manifestHandlers, api, parameters, intl, schema) {
    const defaultHandlers = $9f384a008ac93b94$export$f4fb53cb783b2797(selectedNativeEmbed, api, intl, schema, parameters);
    const result = {
        ...defaultHandlers
    };
    const selectedNodeLocalId = typeof selectedNativeEmbed.node.attrs?.localId === 'string' ? selectedNativeEmbed.node.attrs.localId : undefined;
    const handlerContext = {
        editorApi: api,
        selectedNodeLocalId: selectedNodeLocalId
    };
    for (const key of (0, $k9wGn.EDITOR_TOOLBAR_HANDLER_KEYS)){
        const manifestHandler = manifestHandlers?.[key];
        if (!manifestHandler) continue;
        switch(key){
            case 'onAlignmentClick':
                result.onAlignmentClick = $9f384a008ac93b94$var$wrapManifestHandlerWithContext(manifestHandler, parameters, handlerContext);
                break;
            case 'onAppearanceClick':
                result.onAppearanceClick = $9f384a008ac93b94$var$wrapManifestHandlerWithContext(manifestHandler, parameters, handlerContext);
                break;
            case 'onAskRovoClick':
                if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) result[key] = result[key] !== undefined ? $9f384a008ac93b94$var$wrapManifestHandler(manifestHandler, parameters, handlerContext) : undefined;
                else result[key] = $9f384a008ac93b94$var$wrapManifestHandler(manifestHandler, parameters, handlerContext);
                break;
            default:
                result[key] = $9f384a008ac93b94$var$wrapManifestHandler(manifestHandler, parameters, handlerContext);
        }
    }
    return result;
}


const $31267a1dabad5140$var$ALIGNMENT_ICONS = {
    left: (0, (/*@__PURE__*/$parcel$interopDefault($f922E))),
    center: (0, (/*@__PURE__*/$parcel$interopDefault($bH62g))),
    right: (0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))),
    'wrap-left': (0, (/*@__PURE__*/$parcel$interopDefault($f4MCV))),
    'wrap-right': (0, (/*@__PURE__*/$parcel$interopDefault($iUhs4)))
};
const $31267a1dabad5140$var$getAlignmentLabel = (alignment, intl)=>{
    switch(alignment){
        case 'left':
            return intl.formatMessage((0, $5NB3T.alignmentMessages).alignLeft);
        case 'center':
            return intl.formatMessage((0, $5NB3T.alignmentMessages).alignCenter);
        case 'right':
            return intl.formatMessage((0, $5NB3T.alignmentMessages).alignRight);
        case 'wrap-left':
            return intl.formatMessage((0, $2BvhC.toolbarMessages).wrapLeft);
        case 'wrap-right':
            return intl.formatMessage((0, $2BvhC.toolbarMessages).wrapRight);
    }
};
const $31267a1dabad5140$var$getAlignmentIcon = (alignment, intl)=>{
    const IconComponent = $31267a1dabad5140$var$ALIGNMENT_ICONS[alignment];
    return /*#__PURE__*/ (0, $8aG6j.jsx)(IconComponent, {
        color: "currentColor",
        spacing: "spacious",
        label: $31267a1dabad5140$var$getAlignmentLabel(alignment, intl)
    });
};
const $31267a1dabad5140$var$NativeEmbedDropdownIcon = ({ icon: IconComponent, label: label })=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginRight: "var(--ds-space-negative-100, -8px)"
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(IconComponent, {
            color: "currentColor",
            label: label,
            spacing: "none"
        })
    }); /**
           * Converts a custom EditorToolbarAction to a FloatingToolbarItem.
           * Uses customActionHandlers from manifest when resolving handler.
           */ 
function $31267a1dabad5140$var$convertCustomActionToToolbarItem(action, customActionHandlers) {
    return {
        id: `native-embed-${action.key}`,
        type: 'button',
        title: action.label,
        showTitle: action.showTitle,
        icon: action.icon,
        disabled: action.disabled,
        onClick: ()=>{
            customActionHandlers[action.handlerKey];
            return true;
        },
        focusEditoronEnter: true,
        tabIndex: null
    };
} /**
   * Creates a registry of built-in toolbar items keyed by their BUILTIN_TOOLBAR_KEYS.
   * Resolves handlers from manifest first, then falls back to default actions.
   */ 
function $31267a1dabad5140$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, state, embedWidth, lineLength, api, manifestHandlers, isAskRovoEnabled, selectedNode, onCommentButtonMount) {
    // When the embed width is greater than or equal to the layout width,
    // only "center" alignment is valid — disable all other options.
    const shouldDisableNonCenterAlignments = embedWidth !== undefined && lineLength !== undefined && embedWidth >= lineLength;
    const alignmentOptions = (0, $k9wGn.ALIGNMENT_VALUES).map((alignment)=>({
            id: `native-embed-alignment-${alignment}`,
            title: $31267a1dabad5140$var$getAlignmentLabel(alignment, intl),
            onClick: handlers.onAlignmentClick(alignment),
            selected: parameters.alignment === alignment,
            disabled: shouldDisableNonCenterAlignments && alignment !== 'center',
            icon: $31267a1dabad5140$var$getAlignmentIcon(alignment, intl)
        }));
    const alignmentDropdownTitle = $31267a1dabad5140$var$getAlignmentLabel(parameters.alignment, intl);
    const AlignmentIconComponent = $31267a1dabad5140$var$ALIGNMENT_ICONS[parameters.alignment]; // When a manifest provides its own handler, leave gating up to the experience itself.
    // When the experience provides an isAskRovoEnabled gate, use that.
    // Otherwise, fall back to the default experiment check.
    const showAskRovo = Boolean(manifestHandlers?.onAskRovoClick) || (isAskRovoEnabled ? isAskRovoEnabled() : (0, $ieeJu.expValEquals)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true));
    const showSummarise = Boolean(manifestHandlers?.onSummariseClick) || (0, $ieeJu.expValEquals)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
    const askRovoButton = handlers.askRovoButton;
    const showAskRovoFloatingToolbarButton = (0, $iDrrr.fg)('platform_editor_maui_jira_updates') ? showAskRovo && handlers.onAskRovoClick && askRovoButton : showAskRovo && askRovoButton;
    const showRemixFloatingToolbarButton = (0, $iDrrr.fg)('maui_remixable_page_native_embeds');
    const shouldDisableRemix = api?.malleableUi?.actions?.shouldDisableRemix?.() && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar');
    const annotations = api?.annotation?.sharedState.currentState()?.annotations;
    const hasUnresolvedComments = Boolean(selectedNode && annotations && selectedNode.marks.some((mark)=>mark.type.name === 'annotation' && !annotations[mark.attrs.id]));
    const commentTitle = intl.formatMessage(hasUnresolvedComments ? (0, $ImNkk.commentMessages).viewCommentsOnMedia : (0, $ImNkk.commentMessages).addCommentOnMedia);
    return {
        ...showAskRovoFloatingToolbarButton && askRovoButton ? {
            [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO]: {
                type: 'custom',
                fallback: [],
                supportsViewMode: true,
                render: (view)=>view ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a0b3fecddae323a7$export$cc61d4d88dbc5bf9), {
                        button: askRovoButton,
                        isDisabled: shouldDisableRemix,
                        onClick: ()=>handlers.onAskRovoClick?.()(view.state, view.dispatch)
                    }) : null
            },
            [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT]: handlers.getRemixVariantButton?.({
                intl: intl,
                node: selectedNode,
                schema: schema,
                state: state
            }),
            ...showRemixFloatingToolbarButton ? {
                [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX]: handlers.getRemixButton?.({
                    intl: intl,
                    node: selectedNode
                })
            } : {}
        } : {},
        ...showSummarise ? {
            [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE]: {
                id: 'native-embed-summarise-button',
                type: 'button',
                title: intl.formatMessage((0, $94ce71f66457d23a$export$cdc1205423c9f2de).summarise),
                showTitle: true,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))),
                onClick: handlers.onSummariseClick(),
                focusEditoronEnter: true,
                tabIndex: null
            }
        } : {},
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REFRESH]: {
            id: 'native-embed-refresh-button',
            type: 'button',
            title: intl.formatMessage((0, $94ce71f66457d23a$export$cdc1205423c9f2de).refresh),
            showTitle: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1WMy0))),
            onClick: handlers.onRefreshClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COMMENT]: {
            id: 'native-embed-comment-button',
            testId: 'native-embed-comment-button',
            type: 'button',
            title: commentTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
            onClick: handlers.onCommentClick?.() ?? (()=>false),
            onMount: onCommentButtonMount,
            tooltipContent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                description: commentTitle
            }),
            disabled: !handlers.onCommentClick,
            focusEditoronEnter: true,
            tabIndex: null,
            supportsViewMode: true
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED]: {
            ...(0, $d77861c8602f769f$export$8777833158c4a88c)({
                intl: intl,
                onAppearanceClick: handlers.onAppearanceClick
            })
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER]: {
            type: 'custom',
            render: (view, idx)=>{
                if (!view || !selectedNode) return null;
                 // Access borderColor/borderSize via raw macroParams since they were added in MAUI-478
                const extendedMacroParams = selectedNode.attrs.parameters?.macroParams;
                const borderColor = extendedMacroParams?.borderColor?.value || undefined;
                const borderSize = extendedMacroParams?.borderSize?.value ? Number(extendedMacroParams.borderSize.value) : undefined; // Pre-create stable command references to satisfy perf-linting/no-unstable-inline-props
                const toggleBorder = ()=>(0, $ea287d488ebca970$export$ad24774c83d7117b)(api, selectedNode)(view.state, view.dispatch);
                const setBorderColor = (color)=>(0, $ea287d488ebca970$export$d8d3b5afcdf52490)(api, color, selectedNode)(view.state, view.dispatch);
                const setBorderSize = (size)=>(0, $ea287d488ebca970$export$332491e877ad56a5)(api, size, selectedNode)(view.state, view.dispatch);
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5737ffde100b61ed$export$2e2bcd8739ae039), {
                    intl: intl,
                    borderColor: borderColor,
                    borderSize: borderSize,
                    toggleBorder: toggleBorder,
                    setBorderColor: setBorderColor,
                    setBorderSize: setBorderSize
                }, idx);
            },
            fallback: []
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT]: {
            id: 'native-embed-alignment-dropdown',
            type: 'dropdown',
            tooltip: alignmentDropdownTitle,
            title: ' ',
            iconBefore: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($31267a1dabad5140$var$NativeEmbedDropdownIcon, {
                    icon: AlignmentIconComponent,
                    label: alignmentDropdownTitle
                }),
            options: alignmentOptions
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW]: {
            id: 'native-embed-open-new-window-button',
            type: 'button',
            title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            onClick: handlers.onOpenInNewWindowClick(),
            focusEditoronEnter: true,
            tabIndex: null,
            supportsViewMode: true
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EXPAND]: {
            id: 'native-embed-expand-button',
            type: 'button',
            title: intl.formatMessage((0, $94ce71f66457d23a$export$cdc1205423c9f2de).expandPreview),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            onClick: handlers.onExpandClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL]: {
            id: 'native-embed-edit-url-button',
            type: 'button',
            title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            onClick: handlers.onEditUrlClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT]: {
            id: 'native-embed-edit-button',
            type: 'button',
            title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editDatasourceStandalone),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            onClick: handlers.onEditClick()
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY]: {
            id: 'native-embed-copy-button',
            type: 'button',
            title: intl.formatMessage((0, $05b362cd50fa2589$export$271a7654ce32757b).copy),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            onClick: handlers.onCopyClick(),
            focusEditoronEnter: true,
            tabIndex: null,
            supportsViewMode: true
        },
        /**
    * @private
    * @deprecated Use COPY instead. Will be removed in a follow-up PR.
    */ [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY_LINK]: {
            id: 'native-embed-copy-link-button',
            type: 'button',
            title: intl.formatMessage((0, $3FYPH.messages).copyLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            onClick: handlers.onCopyLinkClick(),
            focusEditoronEnter: true,
            tabIndex: null,
            supportsViewMode: true
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE]: {
            id: 'native-embed-delete-button',
            type: 'button',
            title: intl.formatMessage((0, $3FYPH.messages).deleteBlock),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            onClick: handlers.onDeleteClick(),
            focusEditoronEnter: true,
            tabIndex: null
        }
    };
}
/**
 * Resolves toolbar items from the manifest's items array.
 * Looks up each key in the built-in registry or customActions.
 */ function $31267a1dabad5140$var$resolveToolbarItemsFromItems(items, builtinRegistry, customActions, editorToolbarHandlers) {
    const resolvedItems = [];
    for (const key of items){
        if (key === (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR) resolvedItems.push({
            type: 'separator',
            fullHeight: true,
            supportsViewMode: true
        });
        else if (key in builtinRegistry && ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? builtinRegistry[key] : true)) resolvedItems.push(builtinRegistry[key]);
        else if (customActions && key in customActions) resolvedItems.push($31267a1dabad5140$var$convertCustomActionToToolbarItem(customActions[key], editorToolbarHandlers));
    }
    return resolvedItems;
} /**
   * Converts manifest-defined toolbar actions to FloatingToolbarItems.
   * Uses `items` array with built-in registry + custom actions.
   */ 
function $31267a1dabad5140$var$convertManifestActionsToToolbarItems(manifestActions, handlers, parameters, intl, schema, state, embedWidth, lineLength, api, manifestHandlers, isAskRovoEnabled, selectedNode, onCommentButtonMount) {
    if (!manifestActions.items) return [];
    const builtinRegistry = $31267a1dabad5140$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, state, embedWidth, lineLength, api, manifestHandlers, isAskRovoEnabled, selectedNode, onCommentButtonMount);
    return $31267a1dabad5140$var$resolveToolbarItemsFromItems(manifestActions.items, builtinRegistry, manifestActions.customActions, handlers);
}
const $31267a1dabad5140$var$editUrlToolbarConfig = (showUrlToolbar, lpLinkPicker)=>{
    return showUrlToolbar ? {
        height: lpLinkPicker ? (0, $2VYYv.LINKPICKER_HEIGHT_IN_PX) : (0, $2VYYv.RECENT_SEARCH_HEIGHT_IN_PX),
        width: (0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX),
        forcePlacement: true
    } : {};
}; /**
    * Default items of toolbar items when no manifest is provided.
    */ 
const $31267a1dabad5140$var$DEFAULT_TOOLBAR_ITEMS = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REFRESH,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW
];
const $31267a1dabad5140$var$VIEW_MODE_TOOLBAR_ITEMS = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EXPAND
]; /**
                                                                                                                                                                    * Resolves the DOM element to anchor the toolbar to, so it stays underneath the
                                                                                                                                                                    * aligned embed (left/center/right/wrap-left/wrap-right) instead of the full-width wrapper.
                                                                                                                                                                    * Prefers .extension-container when present (as child or ancestor).
                                                                                                                                                                    */ 
function $31267a1dabad5140$export$d8e43bed2cd6707f(node) {
    if (!(node instanceof HTMLElement)) return undefined;
    const container = node.querySelector('.extension-container') ?? node.closest('.extension-container');
    return container instanceof HTMLElement ? container : node;
} /**
   * Returns the default toolbar items when no manifest actions are provided.
   */ 
function $31267a1dabad5140$var$getDefaultToolbarItems(handlers, parameters, intl, schema, state, embedWidth, lineLength, api, selectedNode, onCommentButtonMount) {
    const builtinRegistry = $31267a1dabad5140$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, state, embedWidth, lineLength, api, undefined, undefined, selectedNode, onCommentButtonMount);
    return $31267a1dabad5140$var$resolveToolbarItemsFromItems($31267a1dabad5140$var$DEFAULT_TOOLBAR_ITEMS, builtinRegistry, undefined, handlers);
}
const $31267a1dabad5140$export$86ce8f8241c20a3 = ({ api: api, linkPickerOptions: linkPickerOptions, lpLinkPicker: lpLinkPicker, onCommentButtonMount: onCommentButtonMount })=>(state, intl, providerFactory, _activeConfigs)=>{
        const selectedNativeEmbed = (0, $e4ec95534c49ff7b$export$1782ddbca43ac707)(state);
        if (!selectedNativeEmbed) return undefined;
        const pluginState = (0, $d598f2eb7a08550e$export$18d4026d1ea86bb1).getState(state);
        const isShowingUrlToolbar = pluginState?.showUrlToolbar ?? false;
        const hoverDecoration = api?.decorations?.actions.hoverDecoration;
        const nodeType = state.schema.nodes.extension;
        const deleteHoverPropsFactory = (nt)=>({
                onMouseEnter: hoverDecoration?.(nt, true),
                onMouseLeave: hoverDecoration?.(nt, false),
                onFocus: hoverDecoration?.(nt, true),
                onBlur: hoverDecoration?.(nt, false)
            });
        const parameters = (0, $ljOiP.getParameters)(selectedNativeEmbed.node.attrs.parameters); // Resolve manifest from facade — try URL first, then fall back to
        // experience ID extracted from the extensionKey. The URL-based lookup
        // can fail when the embed is reinserted (e.g. after a Rovo edit)
        // without macroParams being preserved.
        const facade = (0, $iwIwp.getNativeEmbedFacade)();
        let manifest = parameters.url ? facade.getManifestByUrl(parameters.url) : undefined;
        if (!manifest) {
            const extensionKey = selectedNativeEmbed.node.attrs.extensionKey;
            const experienceId = extensionKey?.split(':')[1];
            if (experienceId) manifest = facade.getManifestById(experienceId);
        }
        const rawActions = manifest?.uiConfig?.editorToolbarActions;
        const manifestActions = typeof rawActions === 'function' ? rawActions() : rawActions; // Determine handlers based on manifest, falling back to defaults
        const resolvedHandlers = (0, $9f384a008ac93b94$export$dfa1706461ea0aa3)(selectedNativeEmbed, manifest?.uiConfig.editorToolbarHandlers, api, parameters, intl, state.schema);
        const getDomRef = (view)=>{
            try {
                const node = (0, $bjg0G.findDomRefAtPos)(selectedNativeEmbed.pos, view.domAtPos.bind(view));
                return $31267a1dabad5140$export$d8e43bed2cd6707f(node);
            } catch  {
                return undefined;
            }
        }; // For database native embeds with vertical resize (databases-native-embeds-v2 experiment),
        // increase the toolbar offset to clear the bottom drag handle (20px gap).
        const hasVerticalResize = (0, $f02260fba5bb4551$export$b594514954d95745)(selectedNativeEmbed.node);
        const toolbarOffset = hasVerticalResize ? [
            0,
            20
        ] : [
            0,
            8
        ]; // If URL toolbar is showing, render the edit URL toolbar instead of normal items
        if (isShowingUrlToolbar) return {
            title: 'Native Embed floating toolbar',
            getDomRef: getDomRef,
            nodeType: state.schema.nodes.extension,
            offset: [
                0,
                8
            ],
            scrollable: false,
            ...$31267a1dabad5140$var$editUrlToolbarConfig(true, lpLinkPicker),
            items: [
                (0, $113683d07a1f0e4a$export$13e482484d5c4da9)({
                    api: api,
                    linkPickerOptions: linkPickerOptions,
                    lpLinkPicker: lpLinkPicker ?? true,
                    providerFactory: providerFactory,
                    selectedNativeEmbed: selectedNativeEmbed
                })
            ]
        };
         // Determine the embed's current width and the layout line length so we
        // can disable non-center alignment options when the embed is as wide as
        // (or wider than) the layout.
        const widthState = api?.width?.sharedState?.currentState();
        const lineLength = widthState?.lineLength || (0, $7Y8M5.akEditorDefaultLayoutWidth);
        const embedWidth = (0, $87f12a99e92167f9$export$3c49c185de0c2bfc)(selectedNativeEmbed.node) ?? lineLength;
        const isInViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        if (isInViewMode) {
            const builtinRegistry = $31267a1dabad5140$var$createBuiltinToolbarRegistry(resolvedHandlers, parameters, intl, state.schema, state, embedWidth, lineLength, api, manifest?.uiConfig.editorToolbarHandlers, manifest?.uiConfig.isAskRovoEnabled, selectedNativeEmbed.node, onCommentButtonMount);
            return {
                title: 'Native Embed floating toolbar',
                getDomRef: getDomRef,
                nodeType: state.schema.nodes.extension,
                offset: toolbarOffset,
                items: $31267a1dabad5140$var$resolveToolbarItemsFromItems($31267a1dabad5140$var$VIEW_MODE_TOOLBAR_ITEMS, builtinRegistry, undefined, resolvedHandlers)
            };
        } // Convert manifest actions to FloatingToolbarItems, or fall back to default items
        const items = manifestActions ? $31267a1dabad5140$var$convertManifestActionsToToolbarItems(manifestActions, resolvedHandlers, parameters, intl, state.schema, state, embedWidth, lineLength, api, manifest?.uiConfig.editorToolbarHandlers, manifest?.uiConfig.isAskRovoEnabled, selectedNativeEmbed.node, onCommentButtonMount) : $31267a1dabad5140$var$getDefaultToolbarItems(resolvedHandlers, parameters, intl, state.schema, state, embedWidth, lineLength, api, selectedNativeEmbed.node, onCommentButtonMount); // Auto-append the "More Options" dropdown when there are items to show.
        // Default toolbar (no manifest): always show with default items.
        // Manifest toolbar: only show when moreItems is provided with items.
        const showMoreOptions = manifestActions?.moreItems ? Boolean(manifestActions?.moreItems?.length) : true;
        if (showMoreOptions) items.push((0, $8956bd0cd4887675$export$6030df2c7cd7819c)(api, selectedNativeEmbed, deleteHoverPropsFactory(nodeType), resolvedHandlers, parameters, intl, manifestActions?.moreItems, manifestActions?.customActions));
        return {
            title: 'Native Embed floating toolbar',
            getDomRef: getDomRef,
            nodeType: state.schema.nodes.extension,
            offset: toolbarOffset,
            items: items
        };
    };








/**
 * We are limiting context extraction to this temporary allow list of content types at this stage
 * of the object level remix feature development (object level remix is currently only enabled for pages)
 */ const $687681592c67e711$var$NATIVE_EMBED_CONTENT_TYPE_ALLOW_LIST = [
    'page'
];
const $687681592c67e711$export$1e215007d7182b46 = (node)=>{
    if (node.type !== 'extension') return null;
    const pmNode = node;
    if (!pmNode.attrs) return null;
    const localId = pmNode.attrs?.localId;
    if (!localId) return null;
    const extensionKey = pmNode.attrs.extensionKey;
    if (!extensionKey || !extensionKey.startsWith((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) /** return null if not a native embed */ return null;
    const contentType = extensionKey.split(':')[1];
    if (!$687681592c67e711$var$NATIVE_EMBED_CONTENT_TYPE_ALLOW_LIST.includes(contentType)) /** return null if the content type is not in the allow list */ return null;
    const readContentCommandResult = (0, $iwIwp.getNativeEmbedFacade)().sendReadContent(localId);
    readContentCommandResult.catch(()=>undefined);
    return {
        type: 'nativeContentContext',
        contentType: contentType,
        contentResult: readContentCommandResult
    };
};


/* ResizableNativeEmbed.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");

/* ResizableNativeEmbedCoordinator.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlassian/perf-linting/no-chain-state-updates -- the coordinator deliberately
 * groups multiple state slices behind subscription callbacks; the lint rule's static
 * analysis can't tell that branches like `setSelectedTarget(null)` in different effect
 * paths aren't actually chained, only conditionally exclusive.
 */ 

















/* EmbedResizeOverlay.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $9kbTQ = parcelRequire("9kbTQ");











var $ktOsK = parcelRequire("ktOsK");

var $b8q5K = parcelRequire("b8q5K");

var $lPlPa = parcelRequire("lPlPa");

var $78UMD = parcelRequire("78UMD");


var $jv11C = parcelRequire("jv11C");





var $45O09 = parcelRequire("45O09");


var $aWssQ = parcelRequire("aWssQ");

















var $fGLaj = parcelRequire("fGLaj");






const $d14336950ceda964$export$721d3977e29c986e = 'nativeEmbedPlugin.isResizing';
const $d14336950ceda964$export$18e96586e523cafb = 'nativeEmbedPlugin.resizing-width';



const $5b360b0052eb7219$export$98f6cdba475114d7 = (view, localId)=>{
    if (!view || !localId) return null;
    let result = null;
    try {
        view.state.doc.descendants((node, pos)=>{
            if (result) return false;
            if (node.attrs?.localId === localId) {
                result = {
                    pos: pos,
                    node: node
                };
                return false;
            }
            return true;
        });
    } catch  {
        return null;
    }
    return result;
};






const $5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE = 'data-native-embed-loading';
const $5fec31b17069136f$var$getObservedElement = (container, innerContainer)=>{
    if (innerContainer?.hasAttribute($5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE)) return innerContainer;
    return container?.querySelector(`[${$5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE}]`) ?? null;
};
const $5fec31b17069136f$var$readLoadingState = (container, innerContainer)=>{
    return $5fec31b17069136f$var$getObservedElement(container, innerContainer)?.getAttribute($5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE) === 'true';
};
const $5fec31b17069136f$export$14197b94b2594c4e = (container, innerContainer)=>{
    const observedElement = $5fec31b17069136f$var$getObservedElement(container, innerContainer);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(()=>$5fec31b17069136f$var$readLoadingState(container, innerContainer));
    (0, $cozmU.useEffect)(()=>{
        if (!observedElement || typeof MutationObserver === 'undefined') {
            setIsLoading(false);
            return;
        }
        const updateLoadingState = ()=>{
            setIsLoading(observedElement.getAttribute($5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE) === 'true');
        };
        updateLoadingState();
        const observer = new MutationObserver(updateLoadingState);
        observer.observe(observedElement, {
            attributes: true,
            attributeFilter: [
                $5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement
    ]);
    return isLoading;
};






var $jkcNT = parcelRequire("jkcNT");

const $47f918af983fe56e$var$calcLayoutMaxWidth = (containerWidth, layoutMaxWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $7Y8M5.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, layoutMaxWidth);
};
const $47f918af983fe56e$export$de18d2ff56094455 = (containerWidth, editorAppearance)=>$47f918af983fe56e$var$calcLayoutMaxWidth(containerWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth), editorAppearance);
const $47f918af983fe56e$export$5538447ebeb7ef8a = (containerWidth)=>{
    const gutterPadding = containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    return Math.min(containerWidth - gutterPadding * 2 - (0, $7Y8M5.akEditorGutterPadding), (0, $7Y8M5.akEditorMaxWidthLayoutWidth));
};
const $47f918af983fe56e$export$a460879aa582cf90 = (maxWidth)=>{
    const guidelineOffset = maxWidth / 2;
    return [
        {
            key: 'max_width_left',
            position: {
                x: -guidelineOffset
            }
        },
        {
            key: 'max_width_right',
            position: {
                x: guidelineOffset
            }
        }
    ];
};
const $47f918af983fe56e$export$1d9fdc71b83a8eac = 200;
const $47f918af983fe56e$export$70d33a2740b029ae = 200;
const $47f918af983fe56e$export$daa2496be4772440 = 748;
const $47f918af983fe56e$export$6cdb476c834bc60 = 8;
const $47f918af983fe56e$export$a8e17888670204c = '--native-embed-width';
const $47f918af983fe56e$export$fe623d3106c02058 = 'nativeEmbed.resizerNext.testid';
const $47f918af983fe56e$export$2afbeef35ab767b0 = (alignment)=>{
    if (alignment === 'left') return 'align-start';
    if (alignment === 'right') return 'align-end';
    // 'center', 'wrap-left', 'wrap-right' pass through unchanged
    return alignment;
};


const $470ca23c824bbe28$var$resizerWrapperStyles = null;
const $470ca23c824bbe28$var$resizerPointerEventsPassThroughStyles = null;
const $470ca23c824bbe28$var$resizerRootPointerEventsPassThroughStyle = {
    pointerEvents: 'none'
};
const $470ca23c824bbe28$var$resizerPlaceholderStyles = null;
const $470ca23c824bbe28$var$NATIVE_EMBED_RESIZE_BORDER_SUPPRESSION_CONFIG = 'native_embed_resize_border_suppression';
const $470ca23c824bbe28$var$NATIVE_EMBEDS_PANEL_RESIZE_CONTAINMENT_KILLSWITCH = 'native_embeds_panel_resize_containment_killswitch';
const $470ca23c824bbe28$var$NATIVE_EMBEDS_RESIZER_POINTER_KILLSWITCH = 'native_embeds_resizer_pointer_killswitch';
const $470ca23c824bbe28$var$NATIVE_EMBED_RESIZE_OBSERVABILITY_KILLSWITCH = 'native_embed_resize_observability_killswitch';
const $470ca23c824bbe28$var$SELECTED_BORDER_TOKEN = '--ds-border-selected';
const $470ca23c824bbe28$var$RESIZE_ERROR_MODE = 'live-update';
const $470ca23c824bbe28$var$RESIZE_ERROR_OWNER = 'coordinator-overlay';
const $470ca23c824bbe28$var$RESIZE_MEASUREMENT_ERROR_LOCATION = 'editor-plugin-native-embeds/EmbedResizeOverlay/handleResizeStart';
const $470ca23c824bbe28$var$BOUNDED_RESIZE_ERROR_NAMES = new Set([
    'Error',
    'InvalidStateError',
    'RangeError',
    'TypeError'
]);
const $470ca23c824bbe28$var$getBoundedResizeErrorName = (error)=>{
    if (!(error instanceof Error)) return 'UnknownError';
    return $470ca23c824bbe28$var$BOUNDED_RESIZE_ERROR_NAMES.has(error.name) ? error.name : 'OtherError';
};
const $470ca23c824bbe28$var$normalizeResizeMeasurementError = (error)=>{
    if (error instanceof Error) return error;
    const normalizedError = new Error('Native embed resize drag-start measurement failed');
    normalizedError.name = 'UnknownError';
    return normalizedError;
};
const $470ca23c824bbe28$var$reportResizeMeasurementError = (error, pluginInjectionApi)=>{
    if ((0, $fGLaj.dynamicConfigBooleanValue)($470ca23c824bbe28$var$NATIVE_EMBED_RESIZE_OBSERVABILITY_KILLSWITCH)) return;
    const normalizedError = $470ca23c824bbe28$var$normalizeResizeMeasurementError(error);
    (0, $jv11C.logException)(normalizedError, {
        location: $470ca23c824bbe28$var$RESIZE_MEASUREMENT_ERROR_LOCATION,
        mode: $470ca23c824bbe28$var$RESIZE_ERROR_MODE,
        owner: $470ca23c824bbe28$var$RESIZE_ERROR_OWNER
    });
    const analyticsPayload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
        attributes: {
            errorName: $470ca23c824bbe28$var$getBoundedResizeErrorName(error),
            mode: $470ca23c824bbe28$var$RESIZE_ERROR_MODE,
            owner: $470ca23c824bbe28$var$RESIZE_ERROR_OWNER
        },
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    };
    pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent(analyticsPayload);
};
const $470ca23c824bbe28$var$getMeasuredResizeRect = (measureEl, innerContainer)=>{
    const outerRect = measureEl.getBoundingClientRect();
    const innerRect = innerContainer?.getBoundingClientRect(); // Wrapped embeds can collapse the node-view wrapper height while the iframe
    // remains visible, so fall back to the frame rect for overlay sizing.
    const visibleInnerRect = innerRect && innerRect.width > 0 && innerRect.height > 0 ? innerRect : measureEl.querySelector('iframe')?.getBoundingClientRect();
    if (!visibleInnerRect || visibleInnerRect.width <= 0 || visibleInnerRect.height <= 0) return outerRect;
    const left = Math.min(outerRect.left, visibleInnerRect.left);
    const right = Math.max(outerRect.right, visibleInnerRect.right);
    const top = Math.min(outerRect.top, visibleInnerRect.top);
    const bottom = Math.max(outerRect.bottom, visibleInnerRect.bottom);
    return {
        bottom: bottom,
        height: bottom - top,
        left: left,
        right: right,
        top: top,
        width: right - left
    };
};
const $470ca23c824bbe28$var$getPanelContentWidth = (container)=>{
    const widths = [
        container.closest(`.${(0, $45O09.PanelSharedCssClassName).content}`)?.getBoundingClientRect().width,
        container.closest(`.${(0, $45O09.PanelSharedCssClassName).prefix}`)?.getBoundingClientRect().width
    ].filter((width)=>Boolean(width && width > 0));
    return widths.length > 0 ? Math.round(Math.min(...widths)) : undefined;
};
const $470ca23c824bbe28$var$getContentBoxWidth = (container)=>{
    const { borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth, paddingLeft: paddingLeft, paddingRight: paddingRight } = getComputedStyle(container);
    const horizontalInsets = [
        borderLeftWidth,
        borderRightWidth,
        paddingLeft,
        paddingRight
    ].reduce((total, value)=>total + (Number.parseFloat(value) || 0), 0);
    return Math.max(0, container.getBoundingClientRect().width - horizontalInsets);
};
const $470ca23c824bbe28$var$getLiveNestedContainerWidth = (container, isResizeContainmentEnabled)=>{
    const panelContentWidth = isResizeContainmentEnabled ? $470ca23c824bbe28$var$getPanelContentWidth(container) : undefined;
    const nestedContainer = container.offsetParent;
    const nestedContainerWidth = nestedContainer ? isResizeContainmentEnabled ? $470ca23c824bbe28$var$getContentBoxWidth(nestedContainer) : nestedContainer.getBoundingClientRect().width : undefined;
    const widths = [
        panelContentWidth,
        nestedContainerWidth
    ].filter((width)=>Boolean(width && width > 0));
    return widths.length > 0 ? Math.round(Math.min(...widths)) : null;
};
const $470ca23c824bbe28$var$getNestedResizeMaxWidth = (pluginMaxWidth, liveNestedWidth, allowMaxWidth)=>{
    if (liveNestedWidth === null) return pluginMaxWidth;
     // Plugin parent width can stay stale after a nested container resize while
    // the overlay stays mounted. Live nested width is the ceiling unless the
    // embed opts into the editor max-width cap.
    if (!allowMaxWidth) return liveNestedWidth;
    return Math.min(pluginMaxWidth, liveNestedWidth);
};
const $470ca23c824bbe28$export$a777b135e925da43 = (props)=>{
    const { target: target, mode: mode, view: view, portalTarget: portalTarget, pluginInjectionApi: pluginInjectionApi, appearance: appearance, disabled: disabled, containerWidth: containerWidth, lineLength: lineLength, currentAlignment: currentAlignment, onAlignmentChange: onAlignmentChange, onResizeStart: onResizeStart, onResizeStop: onResizeStop } = props;
    const disableHandles = !!disabled;
    const isNativeEmbedLoading = (0, $5fec31b17069136f$export$14197b94b2594c4e)(target.container, target.innerContainer);
    const handlesBlocked = disableHandles || isNativeEmbedLoading; // -----------------------------------------------------------------------
    // Per-overlay state
    // -----------------------------------------------------------------------
    const [isResizing, setIsResizing] = (0, $cozmU.useState)(false);
    const [snaps, setSnaps] = (0, $cozmU.useState)({});
    const isPanelResizeContainmentEnabled = !(0, $fGLaj.dynamicConfigBooleanValue)($470ca23c824bbe28$var$NATIVE_EMBEDS_PANEL_RESIZE_CONTAINMENT_KILLSWITCH); // Tracks which handle is currently being dragged so resizeRatio can be
    // switched per-direction (re-resizable applies a single ratio to both axes).
    const [activeResizeDirection, setActiveResizeDirection] = (0, $cozmU.useState)(null);
    const shouldPassPointerEventsThroughOverlay = !(0, $iDrrr.fg)($470ca23c824bbe28$var$NATIVE_EMBEDS_RESIZER_POINTER_KILLSWITCH) && !isResizing;
    const isResizingRef = (0, $cozmU.useRef)(false);
    const aspectRatioRef = (0, $cozmU.useRef)(null);
    const fixedHeightRef = (0, $cozmU.useRef)(null);
    const lastSnappedGuidelineKeysRef = (0, $cozmU.useRef)([]);
    const committedWidthRef = (0, $cozmU.useRef)(null);
    const committedHeightRef = (0, $cozmU.useRef)(null);
    const innerEmbedContainerRef = (0, $cozmU.useRef)(target.innerContainer);
    const resizeFrameRafRef = (0, $cozmU.useRef)(null);
    const bottomDraggedRef = (0, $cozmU.useRef)(false);
    const suppressedSelectedBorderElementRef = (0, $cozmU.useRef)(null); // Plugin nestedMaxWidth can stay stale after a nested container resize while
    // this overlay stays mounted, so live DOM width is the nested ceiling. Keep a
    // ref for synchronous drag clamping and state so ResizerNext re-renders when
    // the parent container grows.
    const nestedContainerWidthRef = (0, $cozmU.useRef)(null);
    const [liveNestedContainerWidth, setLiveNestedContainerWidth] = (0, $cozmU.useState)(null);
    const [embedDomElement, setEmbedDomElement] = (0, $cozmU.useState)(target.container);
    const [nodeRect, setNodeRect] = (0, $cozmU.useState)(null);
    const isResizeBorderSuppressionKillswitchOn = (0, $cXtTj.default).getExperimentValue($470ca23c824bbe28$var$NATIVE_EMBED_RESIZE_BORDER_SUPPRESSION_CONFIG, 'value', false);
    const suppressSelectedBorder = (0, $cozmU.useCallback)(()=>{
        if (isResizeBorderSuppressionKillswitchOn) return;
         // Host-only chrome override: keep PM selection unchanged and clear from the
        // exact element on every stop/unmount path so stale selection chrome cannot leak.
        const previousElement = suppressedSelectedBorderElementRef.current;
        if (previousElement && previousElement !== target.container) previousElement.style.removeProperty($470ca23c824bbe28$var$SELECTED_BORDER_TOKEN);
        target.container.style.setProperty($470ca23c824bbe28$var$SELECTED_BORDER_TOKEN, 'transparent');
        suppressedSelectedBorderElementRef.current = target.container;
    }, [
        isResizeBorderSuppressionKillswitchOn,
        target.container
    ]);
    const clearSelectedBorderSuppression = (0, $cozmU.useCallback)(()=>{
        const suppressedElement = suppressedSelectedBorderElementRef.current;
        if (suppressedElement) {
            suppressedElement.style.removeProperty($470ca23c824bbe28$var$SELECTED_BORDER_TOKEN);
            suppressedSelectedBorderElementRef.current = null;
        }
    }, []);
    const updateMeasuredNodeRect = (0, $cozmU.useCallback)((measureEl, container)=>{
        const containerRect = container.getBoundingClientRect();
        const nodeRectRaw = $470ca23c824bbe28$var$getMeasuredResizeRect(measureEl, innerEmbedContainerRef.current);
        const nextNodeRect = {
            top: nodeRectRaw.top - containerRect.top + container.scrollTop,
            left: nodeRectRaw.left - containerRect.left + container.scrollLeft,
            width: nodeRectRaw.width,
            height: nodeRectRaw.height,
            panelContentWidth: isPanelResizeContainmentEnabled ? $470ca23c824bbe28$var$getPanelContentWidth(measureEl) : undefined
        };
        setNodeRect((prevNodeRect)=>{
            if (prevNodeRect && prevNodeRect.top === nextNodeRect.top && prevNodeRect.left === nextNodeRect.left && prevNodeRect.width === nextNodeRect.width && prevNodeRect.height === nextNodeRect.height && prevNodeRect.panelContentWidth === nextNodeRect.panelContentWidth) return prevNodeRect;
            return nextNodeRect;
        });
        if (committedHeightRef.current !== null && Math.round(nextNodeRect.height) === committedHeightRef.current) committedHeightRef.current = null;
    }, [
        isPanelResizeContainmentEnabled
    ]); // Sync refs / DOM element when the target changes
    (0, $cozmU.useEffect)(()=>{
        setEmbedDomElement(target.container);
        innerEmbedContainerRef.current = target.innerContainer;
    }, [
        target
    ]); // Stable ref to the localId we last reported as "started" so the unmount
    // cleanup can pair the start with a matching stop using the same id, even
    // if `target` has since changed identity.
    const resizingStartedLocalIdRef = (0, $cozmU.useRef)(null); // Make sure if we unmount mid-drag the coordinator's resize ownership is
    // released. We pair start/stop by localId so the coordinator can ignore
    // stops for any embed other than the one currently owning the resize.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (isResizingRef.current && resizingStartedLocalIdRef.current) {
                const startedLocalId = resizingStartedLocalIdRef.current;
                isResizingRef.current = false;
                resizingStartedLocalIdRef.current = null;
                clearSelectedBorderSuppression(); // Signal drag-stop to the editor-extension even if we unmount mid-drag.
                if (!(0, $f02260fba5bb4551$export$fcdc775fd72fbed9)(target.node)) try {
                    target.container.dispatchEvent(new CustomEvent('native-embed-resize-state-change', {
                        bubbles: true,
                        detail: {
                            active: false,
                            localId: startedLocalId
                        }
                    }));
                } catch  {}
                onResizeStop?.(startedLocalId);
            }
            if (resizeFrameRafRef.current !== null) {
                cancelAnimationFrame(resizeFrameRafRef.current);
                resizeFrameRafRef.current = null;
            }
            clearSelectedBorderSuppression();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // -----------------------------------------------------------------------
    // Width derivation
    // -----------------------------------------------------------------------
    const currentWidth = (0, $cozmU.useMemo)(()=>{
        const node = target.node;
        if (!node) return lineLength;
        const storedWidth = (0, $87f12a99e92167f9$export$3c49c185de0c2bfc)(node);
        if (storedWidth) return storedWidth;
        const layout = node.attrs.layout || 'default';
        const paramWidth = node.attrs.parameters?.width;
        if (typeof paramWidth === 'number' && paramWidth > 0) return paramWidth;
        if (layout === 'wide') return Math.ceil(lineLength * 1.4);
        if (layout === 'full-width') return 0, $7Y8M5.akEditorFullWidthLayoutWidth;
        return lineLength;
    }, [
        target.node,
        lineLength
    ]); // Live-measured container width that overrides the potentially stale
    // plugin value. On non-maximized Mac windows the width plugin's
    // ResizeObserver can report an inflated containerWidth on initial page
    // load (before the content-tree sidebar has finished rendering). This
    // is updated at the start of each drag with the actual DOM measurement
    // and reset to null when the plugin value updates (meaning it caught up).
    const [liveMeasuredContainerWidth, setLiveMeasuredContainerWidth] = (0, $cozmU.useState)(null); // When the plugin's containerWidth updates, clear the override — the
    // plugin has caught up (e.g. after a window resize).
    (0, $cozmU.useEffect)(()=>{
        setLiveMeasuredContainerWidth(null);
    }, [
        containerWidth
    ]);
    const effectiveContainerWidth = liveMeasuredContainerWidth ?? containerWidth;
    const nestedMaxWidth = (0, $cozmU.useMemo)(()=>{
        if (!view) return undefined;
        try {
            const parentNodeWidth = (0, $9ppjA.getParentNodeWidth)(target.pos, view.state, {
                width: effectiveContainerWidth,
                lineLength: lineLength
            });
            const widths = [
                parentNodeWidth,
                nodeRect?.panelContentWidth
            ].filter((width)=>width !== undefined);
            return widths.length > 0 ? Math.min(...widths) : undefined;
        } catch  {
            return undefined;
        }
    }, [
        target.pos,
        view,
        effectiveContainerWidth,
        lineLength,
        nodeRect?.panelContentWidth
    ]);
    const isNested = nestedMaxWidth !== undefined;
    const syncLiveNestedContainerWidth = (0, $cozmU.useCallback)((container)=>{
        if (!isNested || !container) {
            nestedContainerWidthRef.current = null;
            setLiveNestedContainerWidth((prev)=>prev === null ? prev : null);
            return;
        }
        const nextWidth = $470ca23c824bbe28$var$getLiveNestedContainerWidth(container, isPanelResizeContainmentEnabled);
        nestedContainerWidthRef.current = nextWidth;
        setLiveNestedContainerWidth((prev)=>prev === nextWidth ? prev : nextWidth);
    }, [
        isNested,
        isPanelResizeContainmentEnabled
    ]);
    const allowMaxWidth = (0, $cozmU.useMemo)(()=>(0, $f02260fba5bb4551$export$d37a0d761f58309a)(target.node), [
        target.node
    ]);
    const wideLayoutMaxWidth = (0, $cozmU.useMemo)(()=>(0, $47f918af983fe56e$export$de18d2ff56094455)(effectiveContainerWidth, appearance), [
        effectiveContainerWidth,
        appearance
    ]);
    const maximumLayoutMaxWidth = (0, $cozmU.useMemo)(()=>(0, $47f918af983fe56e$export$5538447ebeb7ef8a)(effectiveContainerWidth), [
        effectiveContainerWidth
    ]);
    const allowsMaxLayout = allowMaxWidth && (appearance === 'full-width' || appearance === 'max');
    const configuredMaxWidth = allowsMaxLayout ? maximumLayoutMaxWidth : wideLayoutMaxWidth;
    const maxWidth = (0, $cozmU.useMemo)(()=>{
        return nestedMaxWidth ?? configuredMaxWidth;
    }, [
        nestedMaxWidth,
        configuredMaxWidth
    ]);
    const [resizeWidth, setResizeWidth] = (0, $cozmU.useState)(currentWidth);
    const [resizeHeight, setResizeHeight] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!isResizing) {
            if (committedWidthRef.current !== null) {
                if (currentWidth === committedWidthRef.current) committedWidthRef.current = null;
                return;
            } // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- only one state update; the chain detection is a false positive when the initial useState value depends on a derived value (currentWidth)
            setResizeWidth(Math.min(currentWidth, maxWidth));
        }
    }, [
        currentWidth,
        isResizing,
        maxWidth
    ]);
    const allowVerticalResize = (0, $cozmU.useMemo)(()=>(0, $f02260fba5bb4551$export$b594514954d95745)(target.node), [
        target.node
    ]);
    const nativeEmbedExperienceId = (0, $f02260fba5bb4551$export$c63b2d526fa9c9d1)(target.node.attrs.extensionKey);
    const isDatabaseNativeEmbed = nativeEmbedExperienceId === 'database' || nativeEmbedExperienceId === 'database-entry';
    const [requestedMaxHeight, setRequestedMaxHeight] = (0, $cozmU.useState)(()=>(0, $ccdeb71fb1aeba65$export$825c16631b262763)(view, target.localId));
    (0, $cozmU.useEffect)(()=>{
        setRequestedMaxHeight((0, $ccdeb71fb1aeba65$export$825c16631b262763)(view, target.localId));
        return (0, $ccdeb71fb1aeba65$export$955213572ce75a0)(view, target.localId, (nextMaxHeight)=>{
            setRequestedMaxHeight(nextMaxHeight);
        });
    }, [
        view,
        target.localId
    ]);
    const effectiveMaxHeight = allowVerticalResize && isDatabaseNativeEmbed ? Math.max((0, $47f918af983fe56e$export$70d33a2740b029ae), Math.round(requestedMaxHeight ?? (0, $47f918af983fe56e$export$daa2496be4772440))) : undefined; // For database native embeds with vertical resize (gated behind databases-native-embeds-v2),
    // add extra padding around the bottom drag handle.
    const bottomHandleStyles = (0, $cozmU.useMemo)(()=>{
        if (!allowVerticalResize) return undefined;
        const handleHeight = "var(--ds-space-150, 12px)";
        return {
            bottom: {
                height: handleHeight,
                bottom: `calc(${handleHeight} * -1)`
            }
        };
    }, [
        allowVerticalResize
    ]); // -----------------------------------------------------------------------
    // Measure the embed DOM position for overlay positioning.
    // -----------------------------------------------------------------------
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isResizing) return;
        try {
            const measureEl = target.container;
            if (!measureEl) {
                setNodeRect(null);
                return;
            }
            updateMeasuredNodeRect(measureEl, portalTarget);
        } catch  {
            setNodeRect(null);
        }
    }, [
        target,
        portalTarget,
        isResizing,
        updateMeasuredNodeRect,
        lineLength,
        effectiveContainerWidth
    ]); // The host page can move the editor center line without changing the
    // selected node or PM position, e.g. when Confluence toggles its sidebar.
    // Re-measure on observed container/layout events so handles stay attached
    // to the live DOM box even when the embed only moves horizontally.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isResizing || !embedDomElement) return;
        let animationFrameId = null;
        const updateRectAndWidth = ()=>{
            updateMeasuredNodeRect(embedDomElement, portalTarget);
            syncLiveNestedContainerWidth(embedDomElement);
            const observedWidth = Math.round($470ca23c824bbe28$var$getMeasuredResizeRect(embedDomElement, innerEmbedContainerRef.current).width);
            if (observedWidth > 0) setResizeWidth((prevWidth)=>{
                return prevWidth === observedWidth ? prevWidth : observedWidth;
            });
        };
        const scheduleMeasure = ()=>{
            if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(()=>{
                animationFrameId = null;
                updateRectAndWidth();
            });
        };
        updateRectAndWidth();
        const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateRectAndWidth) : null;
        if (observer) {
            const elementsToObserve = new Set();
            elementsToObserve.add(embedDomElement);
            elementsToObserve.add(portalTarget);
            if (view.dom instanceof HTMLElement) elementsToObserve.add(view.dom);
            if (view.dom.parentElement) elementsToObserve.add(view.dom.parentElement);
            if (isPanelResizeContainmentEnabled) {
                const panelContent = target.container.closest(`.${(0, $45O09.PanelSharedCssClassName).content}`);
                const panelWrapper = target.container.closest(`.${(0, $45O09.PanelSharedCssClassName).prefix}`);
                if (panelContent) elementsToObserve.add(panelContent);
                if (panelWrapper) elementsToObserve.add(panelWrapper);
            }
            const nestedOffsetParent = embedDomElement.offsetParent instanceof HTMLElement ? embedDomElement.offsetParent : null;
            if (nestedOffsetParent) elementsToObserve.add(nestedOffsetParent);
            elementsToObserve.forEach((element)=>observer.observe(element));
        }
        const ownerWindow = view.dom.ownerDocument.defaultView;
        const unbindWindowEvents = ownerWindow ? (0, $cbY7C.bindAll)(ownerWindow, [
            {
                type: 'resize',
                listener: scheduleMeasure
            },
            {
                type: 'orientationchange',
                listener: scheduleMeasure
            }
        ]) : null;
        const unbindDocumentEvents = (0, $cbY7C.bindAll)(view.dom.ownerDocument, [
            {
                type: 'transitionend',
                listener: scheduleMeasure
            }
        ]);
        return ()=>{
            unbindWindowEvents?.();
            unbindDocumentEvents();
            observer?.disconnect();
            if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
        };
    }, [
        isResizing,
        embedDomElement,
        portalTarget,
        updateMeasuredNodeRect,
        view,
        isPanelResizeContainmentEnabled,
        target.container,
        syncLiveNestedContainerWidth
    ]); // During a side drag of an unlocked-AR embed, observe the inner container's
    // height so the drag handles reposition as the child iframe re-lays out.
    // Not needed for bottom drags (cursor drives height) or locked-AR embeds.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isResizing) return;
        if (bottomDraggedRef.current) return;
        if (aspectRatioRef.current !== null) return;
        const inner = innerEmbedContainerRef.current;
        if (!inner || typeof ResizeObserver === 'undefined') return;
        const onObserved = ()=>{
            const liveHeight = Math.round(inner.getBoundingClientRect().height);
            if (liveHeight <= 0 || liveHeight === fixedHeightRef.current) return;
            fixedHeightRef.current = liveHeight;
            setResizeHeight((prev)=>prev === liveHeight ? prev : liveHeight);
            if (embedDomElement) updateMeasuredNodeRect(embedDomElement, portalTarget);
        };
        const ro = new ResizeObserver(onObserved);
        ro.observe(inner);
        return ()=>ro.disconnect();
    }, [
        isResizing,
        activeResizeDirection,
        embedDomElement,
        portalTarget,
        updateMeasuredNodeRect
    ]); // -----------------------------------------------------------------------
    // Guidelines
    // -----------------------------------------------------------------------
    const defaultGuidelines = (0, $cozmU.useMemo)(()=>{
        if (isNested) return [];
        const guidelineLineLength = Math.min(lineLength, (0, $7Y8M5.akEditorDefaultLayoutWidth));
        const guidelines = (0, $b8q5K.generateDefaultGuidelines)(guidelineLineLength, effectiveContainerWidth, false);
        return allowsMaxLayout ? [
            ...guidelines,
            ...(0, $47f918af983fe56e$export$a460879aa582cf90)(maxWidth)
        ] : guidelines;
    }, [
        allowsMaxLayout,
        effectiveContainerWidth,
        isNested,
        lineLength,
        maxWidth
    ]);
    const guidelinesRef = (0, $cozmU.useMemo)(()=>({
            current: defaultGuidelines
        }), [
        defaultGuidelines
    ]);
    const isGuidelineEnabled = (0, $cozmU.useMemo)(()=>{
        return !!pluginInjectionApi?.guideline;
    }, [
        pluginInjectionApi
    ]); // -----------------------------------------------------------------------
    // Resize handlers
    // -----------------------------------------------------------------------
    const handleWrapperMouseDown = (0, $cozmU.useCallback)((e)=>{
        const t = e.target;
        if (!(t instanceof HTMLElement)) return;
        const handleEl = t.closest('.resizer-handle') || t.closest('.resizer-handle-thumb') || t.closest('.resizer-handle-track') || t.closest('[class*="resizer-handle"]');
        if (handleEl) {
            // Detect which handle was clicked so resizeRatio can be set per
            // direction. re-resizable applies a single resizeRatio to both
            // axes; for centered embeds we need 2 horizontally (symmetric L/R
            // drag) but 1 vertically (asymmetric bottom-only drag), otherwise
            // the bottom handle visually drifts off the embed's bottom edge.
            const handleClassName = handleEl instanceof HTMLElement ? handleEl.className : '';
            const inferredDirection = (()=>{
                if (handleClassName.includes('bottom') || handleEl.closest('[data-testid*="resizer-handle-bottom"]')) return 'bottom';
                if (handleClassName.includes('left') || handleEl.closest('[data-testid*="resizer-handle-left"]')) return 'left';
                if (handleClassName.includes('right') || handleEl.closest('[data-testid*="resizer-handle-right"]')) return 'right';
                return null;
            })();
            setActiveResizeDirection(inferredDirection); // Try to claim resize ownership from the coordinator. If another
            // overlay is already mid-resize the coordinator will reject us; in
            // that case we don't flip our local resizing flag and we let the
            // event bubble normally.
            const accepted = onResizeStart ? onResizeStart(target.localId) : true;
            if (!accepted) return;
            isResizingRef.current = true;
            resizingStartedLocalIdRef.current = target.localId;
            suppressSelectedBorder();
            e.stopPropagation();
        }
    }, [
        onResizeStart,
        suppressSelectedBorder,
        target.localId
    ]);
    const handleResizeStart = (0, $cozmU.useCallback)(()=>{
        // If we did not already claim ownership in handleWrapperMouseDown (for
        // example when ResizerNext starts a drag without our wrapper having
        // observed the mousedown), claim it here. The coordinator may reject
        // the start if another overlay is already mid-resize, in which case we
        // bail without flipping any local state or dispatching meta.
        if (resizingStartedLocalIdRef.current !== target.localId) {
            const accepted = onResizeStart ? onResizeStart(target.localId) : true;
            if (!accepted) return;
            resizingStartedLocalIdRef.current = target.localId;
        }
        suppressSelectedBorder();
        setIsResizing(true);
        isResizingRef.current = true;
        lastSnappedGuidelineKeysRef.current = [];
        bottomDraggedRef.current = false; // Signal drag-start to the editor-extension so it hands width ownership
        // to the overlay for the duration of the drag (prevents width clobber).
        if (!(0, $f02260fba5bb4551$export$fcdc775fd72fbed9)(target.node)) try {
            target.container.dispatchEvent(new CustomEvent('native-embed-resize-state-change', {
                bubbles: true,
                detail: {
                    active: true,
                    localId: target.localId
                }
            }));
        } catch  {}
        if (!view) return;
         // Re-measure the actual container width from the DOM. The width
        // plugin's ResizeObserver may have reported an inflated width on
        // initial page load (e.g. before the content-tree sidebar finished
        // rendering). Using the live measurement ensures maxWidth is
        // correct for this drag session.
        try {
            const scrollParent = (0, $1hQ0e.getDocument)()?.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollParent instanceof HTMLElement) {
                const liveWidth = Math.round(scrollParent.offsetWidth);
                if (liveWidth !== containerWidth) setLiveMeasuredContainerWidth(liveWidth);
            }
        } catch  {}
        try {
            const container = target.container;
            if (container) {
                setEmbedDomElement(container);
                syncLiveNestedContainerWidth(container);
                const innerContainer = target.innerContainer ?? container.querySelector('[data-testid="native-embed-extension"]') ?? null;
                innerEmbedContainerRef.current = innerContainer;
                const rect = $470ca23c824bbe28$var$getMeasuredResizeRect(container, innerContainer);
                if (rect.width > 0) {
                    const startWidth = Math.round(rect.width);
                    setResizeWidth(startWidth);
                    const shouldLockAspectRatio = (0, $f02260fba5bb4551$export$fcdc775fd72fbed9)(target.node);
                    if (shouldLockAspectRatio) {
                        // Use the live DOM measurement as the aspect ratio source.
                        // The stored aspectRatio parameter is not reliable — it defaults
                        // to 1 when no originalWidth/originalHeight was provided, and is
                        // never updated after a resize. The DOM rect at drag-start is the
                        // correct height/width ratio for the embed as it is currently rendered.
                        aspectRatioRef.current = rect.height / rect.width;
                        fixedHeightRef.current = null;
                        setResizeHeight(null);
                        const effectiveHeight = Math.round(rect.width * aspectRatioRef.current);
                        container.style.setProperty('--native-embed-aspect-ratio', `${rect.width} / ${effectiveHeight}`);
                    } else {
                        aspectRatioRef.current = null;
                        const innerHeight = innerEmbedContainerRef.current ? Math.round(innerEmbedContainerRef.current.getBoundingClientRect().height) : 0;
                        const measuredHeight = innerHeight > 0 ? innerHeight : Math.round(rect.height);
                        const currentHeight = effectiveMaxHeight !== undefined ? Math.min(measuredHeight, effectiveMaxHeight) : measuredHeight;
                        fixedHeightRef.current = currentHeight;
                        setResizeHeight(currentHeight);
                        container.style.removeProperty('aspect-ratio');
                        if (allowVerticalResize) {
                            container.style.setProperty('height', `${currentHeight}px`);
                            if (innerEmbedContainerRef.current) {
                                innerEmbedContainerRef.current.style.removeProperty('aspect-ratio');
                                innerEmbedContainerRef.current.style.setProperty('height', `${currentHeight}px`);
                            }
                        }
                    }
                }
            }
        } catch (error) {
            $470ca23c824bbe28$var$reportResizeMeasurementError(error, pluginInjectionApi); // Continue without live width updates.
        }
        const { state: state, dispatch: dispatch } = view;
        const tr = state.tr;
        tr.setMeta((0, $d14336950ceda964$export$721d3977e29c986e), true);
        tr.setMeta('is-resizer-resizing', true);
        tr.setMeta('scrollIntoView', false); // NOTE: deliberately DO NOT set selection here. Selection only transfers
        // at mouseup (handleResizeStop), which keeps R4 satisfied for the hover
        // overlay (and is a no-op for the selected overlay).
        dispatch(tr);
    }, [
        view,
        target,
        onResizeStart,
        containerWidth,
        allowVerticalResize,
        effectiveMaxHeight,
        suppressSelectedBorder,
        pluginInjectionApi,
        syncLiveNestedContainerWidth
    ]);
    const scheduleResizeFrame = (0, $cozmU.useCallback)(()=>{
        if (!view) return;
        if (resizeFrameRafRef.current !== null) return;
        resizeFrameRafRef.current = requestAnimationFrame(()=>{
            resizeFrameRafRef.current = null;
            if (!isResizingRef.current || !view || view.isDestroyed) return;
            const tr = view.state.tr;
            tr.setMeta('native-embed-resize-frame', true);
            tr.setMeta('addToHistory', false);
            tr.setMeta('scrollIntoView', false);
            view.dispatch(tr);
        });
    }, [
        view
    ]);
    const handleResize = (0, $cozmU.useCallback)((size, delta, direction)=>{
        if (direction === 'bottom' && allowVerticalResize) {
            // resizeRatio is forced to 1 for vertical drags below, so
            // delta.height already reflects the cursor movement 1:1 — no
            // need to divide. This keeps the bottom handle stuck to the
            // embed's bottom edge for centered embeds (where horizontal
            // resizeRatio is 2 to support symmetric L/R drag).
            const nextHeight = Math.max((0, $47f918af983fe56e$export$70d33a2740b029ae), Math.round(size.height + delta.height));
            const clampedHeight = effectiveMaxHeight !== undefined ? Math.min(effectiveMaxHeight, nextHeight) : nextHeight;
            fixedHeightRef.current = clampedHeight;
            bottomDraggedRef.current = true;
            setResizeHeight(clampedHeight);
            scheduleResizeFrame();
            return;
        }
        const newWidth = Math.round(size.width + delta.width);
        const effectiveMax = isNested ? $470ca23c824bbe28$var$getNestedResizeMaxWidth(maxWidth, nestedContainerWidthRef.current, allowMaxWidth) : maxWidth;
        const numericMinWidth = Math.min((0, $47f918af983fe56e$export$1d9fdc71b83a8eac), effectiveMax);
        const clampedWidth = Math.max(numericMinWidth, Math.min(newWidth, effectiveMax));
        setResizeWidth(clampedWidth);
        const isSideAligned = currentAlignment === 'left' || currentAlignment === 'right' || currentAlignment === 'wrap-left' || currentAlignment === 'wrap-right';
        if (!isNested && isSideAligned && clampedWidth > lineLength) {
            onAlignmentChange?.('center');
            if (view?.state && view?.dispatch) {
                // Re-resolve the live node by localId so we operate on the
                // current PMNode instance even if a transaction has landed
                // during the drag and shifted positions.
                const resolved = (0, $5b360b0052eb7219$export$98f6cdba475114d7)(view, target.localId);
                const liveNode = resolved?.node ?? target.node;
                if (liveNode) (0, $45134b38997529c5$export$c29861a26436e3b2)(pluginInjectionApi, 'center', liveNode)(view?.state, view?.dispatch);
            }
        }
        if (isGuidelineEnabled) {
            const layoutForGuidelines = (0, $47f918af983fe56e$export$2afbeef35ab767b0)(currentAlignment);
            const guidelineSnaps = (0, $lPlPa.getGuidelineSnaps)(guidelinesRef.current, lineLength, layoutForGuidelines);
            if (guidelineSnaps.snaps.x) {
                const { gap: gap, keys: activeGuidelineKeys } = (0, $ktOsK.findClosestSnap)(clampedWidth, guidelineSnaps.snaps.x, guidelineSnaps.guidelineReference, (0, $47f918af983fe56e$export$6cdb476c834bc60));
                lastSnappedGuidelineKeysRef.current = activeGuidelineKeys;
                const nextGuideLines = (0, $78UMD.getGuidelinesWithHighlights)(gap, (0, $47f918af983fe56e$export$6cdb476c834bc60), activeGuidelineKeys, guidelinesRef.current);
                view && pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
                    guidelines: nextGuideLines
                });
            }
            setSnaps({
                x: guidelineSnaps.snaps.x || []
            });
        }
    }, [
        maxWidth,
        isNested,
        lineLength,
        guidelinesRef,
        isGuidelineEnabled,
        currentAlignment,
        target,
        pluginInjectionApi,
        view,
        onAlignmentChange,
        allowVerticalResize,
        effectiveMaxHeight,
        scheduleResizeFrame,
        allowMaxWidth
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isResizing) return;
        if (embedDomElement) {
            embedDomElement.style.transition = 'none';
            if (isNested) {
                embedDomElement.style.width = '';
                embedDomElement.style.minWidth = '';
                embedDomElement.style.maxWidth = `${resizeWidth}px`;
                embedDomElement.style.setProperty((0, $47f918af983fe56e$export$a8e17888670204c), `${resizeWidth}px`);
            } else {
                // Write `--native-embed-width` FIRST — it's the cascade winner for
                // `.extension-container` width. Removing it even briefly causes
                // `width: var(--native-embed-width) !important` to resolve to
                // `auto` (full editor column width), producing a visible snap.
                embedDomElement.style.setProperty((0, $47f918af983fe56e$export$a8e17888670204c), `${resizeWidth}px`);
                embedDomElement.style.width = `${resizeWidth}px`;
                embedDomElement.style.minWidth = `${resizeWidth}px`;
                embedDomElement.style.maxWidth = `${resizeWidth}px`;
            }
            if (resizeHeight !== null) // Only force height for bottom drags; side drags let the child's
            // local height overrides flow through naturally.
            {
                if (bottomDraggedRef.current) {
                    embedDomElement.style.height = `${resizeHeight}px`;
                    embedDomElement.style.removeProperty('aspect-ratio');
                }
            }
        }
        const innerContainer = innerEmbedContainerRef.current;
        if (innerContainer) {
            innerContainer.style.width = `${resizeWidth}px`;
            if (resizeHeight !== null && bottomDraggedRef.current) {
                innerContainer.style.height = `${resizeHeight}px`;
                innerContainer.style.removeProperty('aspect-ratio');
            }
        }
    }, [
        isResizing,
        resizeWidth,
        resizeHeight,
        embedDomElement,
        isNested,
        activeResizeDirection
    ]);
    const handleResizeStop = (0, $cozmU.useCallback)((_size, _delta)=>{
        clearSelectedBorderSuppression();
        if (!(0, $f02260fba5bb4551$export$fcdc775fd72fbed9)(target.node)) try {
            target.container.dispatchEvent(new CustomEvent('native-embed-resize-state-change', {
                bubbles: true,
                detail: {
                    active: false,
                    localId: target.localId
                }
            }));
        } catch  {}
        const isFullWidthSnap = lastSnappedGuidelineKeysRef.current.some((key)=>key.startsWith('full_width'));
        const isMaxWidthSnap = lastSnappedGuidelineKeysRef.current.some((key)=>key.startsWith('max_width'));
        const effectiveMaxWidth = isNested ? $470ca23c824bbe28$var$getNestedResizeMaxWidth(maxWidth, nestedContainerWidthRef.current, allowMaxWidth) : maxWidth;
        const committedWidth = !isNested && isMaxWidthSnap ? effectiveMaxWidth : !isNested && isFullWidthSnap ? Math.min((0, $7Y8M5.akEditorFullWidthLayoutWidth), effectiveMaxWidth) : allowMaxWidth ? Math.min(resizeWidth, effectiveMaxWidth) : resizeWidth;
        const isMaxWidth = !isNested && allowsMaxLayout && !isFullWidthSnap && (isMaxWidthSnap || committedWidth === effectiveMaxWidth);
        committedWidthRef.current = committedWidth;
        if (allowVerticalResize && bottomDraggedRef.current && aspectRatioRef.current === null && fixedHeightRef.current !== null && effectiveMaxHeight !== undefined && fixedHeightRef.current > effectiveMaxHeight) fixedHeightRef.current = effectiveMaxHeight;
         // fixedHeightRef was captured at drag-start; re-measure the live
        // height before clearing styles so we commit the correct value.
        const innerContainer = innerEmbedContainerRef.current;
        if (fixedHeightRef.current !== null && innerContainer && !bottomDraggedRef.current) try {
            const liveHeight = Math.round(innerContainer.getBoundingClientRect().height);
            if (liveHeight > 0) fixedHeightRef.current = liveHeight;
        } catch  {}
        if (embedDomElement) {
            embedDomElement.style.transition = ''; // Write `--native-embed-width` before clearing inline overrides —
            // same reason as the drag-time effect above.
            embedDomElement.style.setProperty((0, $47f918af983fe56e$export$a8e17888670204c), `${committedWidth}px`);
            embedDomElement.style.width = '';
            embedDomElement.style.minWidth = '';
            embedDomElement.style.setProperty('max-width', 'var(--ak-editor-max-container-width)');
            if (fixedHeightRef.current !== null) {
                embedDomElement.style.setProperty('height', `${fixedHeightRef.current}px`);
                embedDomElement.style.removeProperty('aspect-ratio');
            } else embedDomElement.style.setProperty('height', 'auto');
        }
        if (innerContainer) {
            innerContainer.style.width = '';
            if (fixedHeightRef.current !== null) {
                innerContainer.style.height = `${fixedHeightRef.current}px`;
                innerContainer.style.removeProperty('aspect-ratio');
            } else innerContainer.style.height = '';
        }
        innerEmbedContainerRef.current = null;
        view && pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: []
        });
        lastSnappedGuidelineKeysRef.current = []; // Helper: release this overlay's claim on the coordinator's resize
        // ownership. We pair start/stop by localId so the coordinator can
        // safely ignore stops for any embed other than the one currently
        // owning the resize (defends against unmount-cleanup races).
        const releaseResizeOwnership = ()=>{
            const startedLocalId = resizingStartedLocalIdRef.current;
            resizingStartedLocalIdRef.current = null;
            if (startedLocalId !== null) onResizeStop?.(startedLocalId);
        };
        if (!view) {
            setIsResizing(false);
            setResizeHeight(null);
            isResizingRef.current = false;
            setActiveResizeDirection(null);
            releaseResizeOwnership();
            return;
        } // Re-resolve the live node + position via localId so we operate on
        // the current PMNode instance even if a transaction has landed
        // during the drag and shifted positions. Cached `target.pos` is
        // only used as a fallback for the selection transfer below.
        const resolved = (0, $5b360b0052eb7219$export$98f6cdba475114d7)(view, target.localId);
        const liveNode = resolved?.node ?? target.node;
        if (!liveNode) {
            setIsResizing(false);
            setResizeHeight(null);
            isResizingRef.current = false;
            setActiveResizeDirection(null);
            releaseResizeOwnership();
            return;
        }
        const committedHeight = aspectRatioRef.current !== null ? Math.round(committedWidth * aspectRatioRef.current) : fixedHeightRef.current ?? undefined;
        if (committedHeight !== undefined) committedHeightRef.current = committedHeight;
        else committedHeightRef.current = null;
         // Pass `scrollIntoView: false` through to the extension `doc.update`
        // transaction so the width-commit tx never triggers PM's
        // auto-scroll-to-selection behaviour. Without this opt the
        // underlying `tr.replaceWith(...)` lands while PM selection is
        // still on a previously-selected embed (e.g. one further up the
        // page), and PM scrolls that stale selection back into view on
        // mouseup.
        (0, $87f12a99e92167f9$export$ea9f617f119f6cd3)(pluginInjectionApi, committedWidth, liveNode, committedHeight, {
            isMaxWidth: isMaxWidth,
            scrollIntoView: false
        })(view.state, view.dispatch); // -----------------------------------------------------------------
        // Selection transfer: only at mouseup. With the continuous-overlay
        // architecture the coordinator renders one EmbedResizeOverlay per
        // embed (keyed by localId, with `mode` as a prop), so transferring
        // selection here does NOT cause the overlay to remount — it only
        // flips this overlay's mode prop. This means we can dispatch the
        // selection transfer synchronously without a flicker.
        //
        // Skip the dispatch if the selection is already on this node so we
        // don't add a spurious history entry.
        // -----------------------------------------------------------------
        try {
            const { state: selState, dispatch: selDispatch } = view;
            const currentSelection = selState.selection;
            const resolvedSelectionPos = resolved?.pos ?? target.pos;
            const isAlreadySelected = currentSelection instanceof (0, $kCECX.NodeSelection) && currentSelection.from === resolvedSelectionPos;
            if (!isAlreadySelected) {
                const selectionTr = selState.tr;
                selectionTr.setSelection((0, $kCECX.NodeSelection).create(selState.doc, resolvedSelectionPos));
                selectionTr.setMeta('scrollIntoView', false);
                selDispatch(selectionTr);
            }
        } catch  {}
        const { state: state, dispatch: dispatch } = view;
        const tr = state.tr;
        tr.setMeta((0, $d14336950ceda964$export$721d3977e29c986e), false);
        tr.setMeta('is-resizer-resizing', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
        requestAnimationFrame(()=>{
            setIsResizing(false);
            setResizeHeight(null);
            isResizingRef.current = false;
            setActiveResizeDirection(null);
            releaseResizeOwnership();
        });
        aspectRatioRef.current = null;
        fixedHeightRef.current = null;
        if (resizeFrameRafRef.current !== null) {
            cancelAnimationFrame(resizeFrameRafRef.current);
            resizeFrameRafRef.current = null;
        }
        bottomDraggedRef.current = false;
    }, [
        target,
        pluginInjectionApi,
        view,
        embedDomElement,
        resizeWidth,
        maxWidth,
        isNested,
        allowMaxWidth,
        allowsMaxLayout,
        onResizeStop,
        allowVerticalResize,
        effectiveMaxHeight,
        clearSelectedBorderSuppression
    ]); // -----------------------------------------------------------------------
    // Early return — nothing to render
    // -----------------------------------------------------------------------
    // The coordinator gates mounting:
    // - selected mode: overlay is mounted whenever an embed is selected.
    // - hover mode:    overlay is mounted only while the coordinator says the
    //                  embed is hovered (so we should be visible immediately).
    // We always render once we have a measured rect.
    if (!nodeRect) return null;
    const isRightTypeAligned = currentAlignment === 'right' || currentAlignment === 'wrap-right';
    const isLeftTypeAligned = currentAlignment === 'left' || currentAlignment === 'wrap-left';
    const enableRightHandle = !handlesBlocked && currentAlignment !== 'right' && currentAlignment !== 'wrap-right';
    const enableLeftHandle = !handlesBlocked && currentAlignment !== 'left' && currentAlignment !== 'wrap-left';
    const enableBottomHandle = !handlesBlocked && allowVerticalResize;
    let wrapperLeft;
    const actualNestedMax = liveNestedContainerWidth;
    const overlayWidth = isResizing ? isNested && actualNestedMax !== null ? Math.min(resizeWidth, actualNestedMax) : resizeWidth : Math.round(nodeRect.width);
    const overlayHeight = isResizing && resizeHeight !== null ? resizeHeight : Math.round(nodeRect.height);
    if ((0, $ieeJu.expValEquals)('platform_editor_fix_lagging_embed_resize_handle', 'isEnabled', true)) {
        if (isLeftTypeAligned) wrapperLeft = nodeRect.left;
        else if (isRightTypeAligned) wrapperLeft = nodeRect.left + nodeRect.width - overlayWidth;
        else {
            const centerX = nodeRect.left + nodeRect.width / 2;
            wrapperLeft = centerX - overlayWidth / 2;
        }
    } else {
        if (isResizing && embedDomElement && (isLeftTypeAligned || isRightTypeAligned)) {
            const portalRect = portalTarget.getBoundingClientRect();
            const embedRect = embedDomElement.getBoundingClientRect();
            wrapperLeft = embedRect.left - portalRect.left + portalTarget.scrollLeft;
        } else if (isResizing && embedDomElement) {
            const portalRect = portalTarget.getBoundingClientRect();
            const embedRect = embedDomElement.getBoundingClientRect(); // Centered embeds recenter as their width changes, including inside
            // panels and other nested containers. Position the new overlay width
            // around the live embed center so its handles move with the embed
            // instead of retaining the previous frame's left edge.
            const centerX = embedRect.left - portalRect.left + portalTarget.scrollLeft + embedRect.width / 2;
            wrapperLeft = centerX - overlayWidth / 2;
        } else if (isRightTypeAligned || isLeftTypeAligned) wrapperLeft = nodeRect.left;
        else {
            const centerX = nodeRect.left + nodeRect.width / 2;
            wrapperLeft = centerX - overlayWidth / 2;
        }
    }
    const resizerWrapperDynamicStyles = {
        top: nodeRect.top,
        left: wrapperLeft,
        width: overlayWidth
    }; // Visibility rules:
    // - selected overlay: handles always visible (R1) — independent of hover
    // - hover overlay: only mounted by the coordinator while the embed is
    //   hovered, so handles should be visible whenever it is mounted (R2/R3)
    const isHandleVisible = !handlesBlocked && !!nodeRect.height;
    const resizerMaxWidthBase = isNested && actualNestedMax !== null ? allowMaxWidth ? Math.min(maxWidth, actualNestedMax) : actualNestedMax : maxWidth; // While idle, the hover overlay is only drawing handles. If the layout-column
    // max is narrower than the measured frame, re-resizable visually clamps the
    // rail inward over the embed scrollbar, so keep display max at the measured
    // width. Active drags still use the real nested clamp.
    const resizerMaxWidth = mode === 'hover' && !isResizing ? Math.max(resizerMaxWidthBase, overlayWidth) : resizerMaxWidthBase; // re-resizable resolves minWidth after maxWidth, so a floor wider than the
    // container lays the box out past the embed and draws the adjacent handles
    // outside it. Media clamps its floor the same way in calcMinWidth.
    const resizerMinWidthBase = Math.min((0, $47f918af983fe56e$export$1d9fdc71b83a8eac), resizerMaxWidth);
    const resizerMinWidth = !isResizing ? `min(${resizerMinWidthBase}px, 100%)` : resizerMinWidthBase; // re-resizable applies a single resizeRatio to both axes. For centered
    // embeds the horizontal handles need ratio 2 (one drag = symmetric L/R
    // expansion), but the bottom handle is asymmetric (only the bottom edge
    // moves) and must use ratio 1 so it stays glued to the embed's bottom.
    const resizeRatio = activeResizeDirection === 'bottom' ? 1 : currentAlignment === 'center' ? 2 : 1; /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic overlay positioning from DOM measurements */ 
    const overlay = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": "native-embed-resizer",
        "data-overlay-mode": mode,
        "data-embed-local-id": target.localId,
        role: "presentation",
        onMouseDown: handleWrapperMouseDown,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: resizerWrapperDynamicStyles,
            "data-testid": "native-embed-resizer-wrapper",
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _1pp6NdIZbP _27sfqMWVPG _3YV52TIZbP _0rcXlhJFdS _1CNSDkZLw9",
                shouldPassPointerEventsThroughOverlay && "_1pp6NdYbGa"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aWssQ.default /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ ), {
                enable: {
                    left: enableLeftHandle,
                    right: enableRightHandle,
                    bottom: enableBottomHandle
                },
                width: overlayWidth,
                height: allowVerticalResize ? overlayHeight : undefined,
                style: shouldPassPointerEventsThroughOverlay ? $470ca23c824bbe28$var$resizerRootPointerEventsPassThroughStyle : undefined,
                minWidth: resizerMinWidth,
                maxWidth: resizerMaxWidth,
                minHeight: allowVerticalResize ? (0, $47f918af983fe56e$export$70d33a2740b029ae) : undefined,
                maxHeight: effectiveMaxHeight,
                handleResizeStart: handleResizeStart,
                handleResize: handleResize,
                handleResizeStop: handleResizeStop,
                snapGap: (0, $47f918af983fe56e$export$6cdb476c834bc60),
                snap: snaps,
                resizeRatio: resizeRatio,
                isHandleVisible: !!isHandleVisible,
                handleHighlight: "full-height",
                handlePositioning: "adjacent",
                handleStyles: bottomHandleStyles,
                "data-testid": (0, $47f918af983fe56e$export$fe623d3106c02058),
                children: (()=>{
                    const placeholderHeight = (()=>{
                        if (isResizing && resizeHeight !== null) return resizeHeight;
                        if (isResizing && aspectRatioRef.current !== null) return Math.round(resizeWidth * aspectRatioRef.current);
                         // When not resizing, prefer the live DOM height — it reflects
                        // what the embed is actually rendering at. Only fall back to
                        // an aspectRatio calculation when the DOM height is unavailable.
                        if (nodeRect.height) return nodeRect.height;
                        const storedAspectRatio = (0, $ljOiP.getParameters)(target.node.attrs.parameters, 'aspectRatio');
                        if (storedAspectRatio != null && storedAspectRatio > 0) // storedAspectRatio is width/height; height = width / aspectRatio.
                        // Use overlayWidth (actual DOM width) so the placeholder matches
                        // the visible embed proportions.
                        return Math.round(overlayWidth / storedAspectRatio);
                        return 600; // TODO: CNS-24595 - 600 is a hack, it can lose the select in cases and just falls back to this. We can do better
                    })();
                    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic height from DOM
                    , {
                        style: {
                            height: placeholderHeight
                        },
                        className: (0, $hekY6.default)([
                            "_39xV02N91d _1pp6NdYbGa"
                        ])
                    });
                })()
            })
        })
    }); /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(overlay, portalTarget);
};


const $371da16a9a10889f$export$5d91af3986d5a280 = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi, disabled: disabled, editorView: view, appearance: appearance } = props;
    const initialWidthState = pluginInjectionApi?.width.sharedState.currentState(); // State for width plugin subscription. We intentionally store both lineLength
    // and width in a single object so that updates from the width subscription
    // are applied atomically (avoids the no-chain-state-updates rule).
    const [widthState, setWidthState] = (0, $cozmU.useState)(()=>({
            lineLength: initialWidthState?.lineLength || (0, $7Y8M5.akEditorDefaultLayoutWidth),
            containerWidth: initialWidthState?.width || (0, $7Y8M5.akEditorDefaultLayoutWidth)
        }));
    const { lineLength: lineLength, containerWidth: containerWidth } = widthState;
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = pluginInjectionApi?.width.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState) setWidthState({
                lineLength: nextSharedState.lineLength || (0, $7Y8M5.akEditorDefaultLayoutWidth),
                containerWidth: nextSharedState.width || (0, $7Y8M5.akEditorDefaultLayoutWidth)
            });
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        pluginInjectionApi
    ]);
    const [selectionState, setSelectionState] = (0, $cozmU.useState)(()=>{
        const initial = pluginInjectionApi?.editorPluginNativeEmbeds?.sharedState?.currentState();
        return {
            selectedEmbed: initial?.selectedEmbed ?? null,
            trackedEmbedPos: null,
            hoveredEmbedPos: null,
            currentAlignment: initial?.selectedEmbed?.alignment ?? 'center'
        };
    });
    const { selectedEmbed: selectedEmbed, trackedEmbedPos: trackedEmbedPos, hoveredEmbedPos: hoveredEmbedPos, currentAlignment: currentAlignment } = selectionState; // Coordinator-wide single source of truth for "which embed is currently
    // being resized" (by localId). At most one overlay can own a resize at a
    // time; second-start attempts are rejected. Stored in a ref so hover and
    // shared-state callbacks can read it synchronously without re-render.
    const resizingLocalIdRef = (0, $cozmU.useRef)(null); // Tracks the last `pos` we dispatched in a SET_HOVERED_EMBED_POS meta.
    // We dispatch when the *position* changes (not only when the localId
    // changes) so that re-hovering the same embed after a doc transaction
    // re-syncs the plugin to the embed's latest pos rather than leaving it
    // pinned to a stale value. `null` means "no hover position currently
    // tracked by the plugin".
    const lastDispatchedHoverPosRef = (0, $cozmU.useRef)(null); // Resolve the selected target (DOM + node) ------------------------------
    const [selectedTarget, setSelectedTarget] = (0, $cozmU.useState)(null);
    const [hoveredTarget, setHoveredTarget] = (0, $cozmU.useState)(null);
    const handleAlignmentChange = (0, $cozmU.useCallback)((next)=>{
        setSelectionState((prev)=>({
                ...prev,
                currentAlignment: next
            }));
    }, []);
    /**
   * Called by a child overlay when it wants to start a resize. Returns
   * `true` if the start is accepted (this overlay now owns the resize), or
   * `false` if another overlay is already mid-resize and the start should
   * be rejected.
   *
   * NOTE: We deliberately do NOT clear `hoveredTarget` here, even though
   * Tier 1 (e) of the hardening plan suggested it. Clearing it synchronously
   * unmounts the hover overlay that just started the drag (because the
   * render tree no longer includes it), which destroys the ResizerNext
   * subtree mid-mousedown and the drag never reaches `handleResizeStart`.
   * The render-time dedup (`hoveredTarget.localId !== selectedTarget?.localId`)
   * is sufficient to prevent two overlays for the same embed.
   */ const handleResizeStart = (0, $cozmU.useCallback)((localId)=>{
        if (resizingLocalIdRef.current !== null && resizingLocalIdRef.current !== localId) // Another overlay is already mid-resize; reject the second start.
        return false;
        resizingLocalIdRef.current = localId;
        return true;
    }, []);
    /**
   * Called by a child overlay when its resize sequence has finished. We
   * ignore stops for any localId other than the one currently owning the
   * resize — defends against the unmount-cleanup race where a hover overlay
   * is unmounted (because its embed becomes selected) while the *selected*
   * overlay is still mid-resize.
   */ const handleResizeStop = (0, $cozmU.useCallback)((localId)=>{
        if (resizingLocalIdRef.current !== localId) return;
        resizingLocalIdRef.current = null; // Tier 1 (e): unconditionally clear hovered after a resize completes;
        // it will re-acquire on the next pointer movement if the cursor is
        // still inside an embed. (Safe here because the drag has already
        // finished; we're not unmounting an active ResizerNext subtree.)
        setHoveredTarget(null);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // Tier 1 (c): we deliberately do NOT short-circuit when a resize is in
        // progress. The PM `is-resizer-resizing` meta + plugin-state already
        // prevents the selection from being clobbered by the resize itself,
        // so dropping selection updates client-side just creates drift between
        // the coordinator's view of "selected" and the doc's truth.
        const unsub = pluginInjectionApi?.editorPluginNativeEmbeds?.sharedState?.onChange?.(({ nextSharedState: nextSharedState })=>{
            const nextEmbed = nextSharedState?.selectedEmbed ?? null;
            setSelectionState((prev)=>({
                    selectedEmbed: nextEmbed,
                    trackedEmbedPos: nextSharedState?.trackedEmbedPos ?? null,
                    hoveredEmbedPos: nextSharedState?.hoveredEmbedPos ?? null,
                    currentAlignment: nextEmbed !== null ? nextEmbed.alignment : prev.currentAlignment
                }));
        });
        return ()=>{
            unsub?.();
        };
    }, [
        pluginInjectionApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!view) {
            setSelectedTarget(null);
            return;
        }
        const selected = (0, $e4ec95534c49ff7b$export$1782ddbca43ac707)(view.state);
        if (!selected) {
            setSelectedTarget(null);
            return;
        }
        try {
            const posForLookup = trackedEmbedPos ?? selected.pos;
            const domNode = (0, $bjg0G.findDomRefAtPos)(posForLookup, view.domAtPos.bind(view));
            const element = domNode instanceof HTMLElement ? domNode : domNode.parentElement;
            if (!element) {
                setSelectedTarget(null);
                return;
            }
            const container = element.querySelector('.extension-container') ?? element.closest('.extension-container') ?? element;
            const innerContainer = container.querySelector('[data-testid="native-embed-extension"]') ?? null;
            const localId = selected.node.attrs?.localId ?? '';
            setSelectedTarget({
                pos: selected.pos,
                localId: localId,
                node: selected.node,
                container: container,
                innerContainer: innerContainer
            });
        } catch  {
            setSelectedTarget(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedEmbed,
        view,
        view?.state,
        trackedEmbedPos
    ]);
    // Resolve the portal target (the editor's scroll container)
    const portalTarget = (0, $cozmU.useMemo)(()=>{
        if (!view) return null;
        return view.dom.closest('.fabric-editor-popup-scroll-parent') || view.dom.closest('.ak-editor-content-area') || view.dom.parentElement || null;
    }, [
        view
    ]); /**
               * Given any element inside a native-embed nodeview, walks up to the
               * `extensionView-content-wrap` element which is the actual ProseMirror
               * nodeView wrapper. `view.posAtDOM(wrapper, 0)` then resolves to the
               * exact position of THIS embed in the document — which is the only
               * reliable way to disambiguate sibling embeds. Calling posAtDOM on
               * the inner `.extension-container` returns positions inside the embed
               * (or, for sibling embeds, can collapse to a neighbouring embed's
               * position depending on layout), which is what caused the bug where
               * resizing embed B resized embed C.
               *
               * Lifted to component scope so both the `mouseover` hover detector and
               * the doc-change re-resolution effect can share the same logic.
               */ 
    const resolveTargetFromAnyElement = (0, $cozmU.useCallback)((anyEl)=>{
        if (!view) return null;
        try {
            let nodeViewDom = anyEl;
            while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
            if (!nodeViewDom || nodeViewDom === view.dom) return null;
            const pos = view.posAtDOM(nodeViewDom, 0);
            const $pos = view.state.doc.resolve(pos);
            let node = null;
            let nodePos = null;
            const nodeAfter = $pos.nodeAfter;
            if (nodeAfter && (0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(nodeAfter)) {
                node = nodeAfter;
                nodePos = pos;
            }
            if (!node) for(let d = $pos.depth; d >= 0; d--){
                const candidate = $pos.node(d);
                if (candidate && (0, $e4ec95534c49ff7b$export$a990e9e9e93229aa)(candidate)) {
                    node = candidate;
                    nodePos = d === 0 ? 0 : $pos.before(d);
                    break;
                }
            }
            if (!node || nodePos == null) return null;
            const container = nodeViewDom.querySelector('.extension-container') ?? nodeViewDom;
            const innerContainer = container.querySelector('[data-testid="native-embed-extension"]') ?? null;
            return {
                pos: nodePos,
                localId: node.attrs?.localId ?? '',
                node: node,
                container: container,
                innerContainer: innerContainer
            };
        } catch  {
            return null;
        }
    }, [
        view
    ]);
    // Hover detector --------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        if (!view) return;
         // Listen on view.dom itself (the contenteditable). This is the most
        // reliable place to capture mouseover/mouseout on embeds: any other
        // container we'd pick (.ak-editor-content-area, .fabric-editor-
        // popup-scroll-parent, etc) may not be present in every editor surface.
        // Embed iframes don't bubble mouse events to the parent document, but
        // the wrapping `.extension-container` element does — that's what we're
        // tracking here.
        if (!(view.dom instanceof HTMLElement)) return;
        const root = view.dom;
        const isInsideEmbedOrOverlay = (n)=>{
            if (!n) return false;
            if (!(n instanceof Element)) return n.parentElement ? isInsideEmbedOrOverlay(n.parentElement) : false;
            return !!n.closest('.extension-container') || !!n.closest('[data-testid="native-embed-resizer"]');
        }; // Tier 1 (d): debounce hover transitions. Rapid mouseover/mouseout
        // pairs (e.g. crossing internal element boundaries inside an embed
        // wrapper) would otherwise flicker `hoveredTarget` and produce brief
        // two-overlay frames. A short debounce coalesces the burst into a
        // single transition.
        const HOVER_DEBOUNCE_MS = 75;
        let pendingHoverTimeout = null;
        const cancelPendingHover = ()=>{
            if (pendingHoverTimeout !== null) {
                clearTimeout(pendingHoverTimeout);
                pendingHoverTimeout = null;
            }
        };
        const handleOver = (event)=>{
            if (resizingLocalIdRef.current !== null) return;
            const evtTarget = event.target;
            if (!(evtTarget instanceof HTMLElement)) return;
             // Only trigger when the mouse is over an actual native-embed
            // (avoids firing for arbitrary editor content). The element we
            // look up is the inner iframe wrapper; we then resolve up to the
            // nodeView wrapper to disambiguate sibling embeds.
            const inner = evtTarget.closest('[data-testid="native-embed-extension"]');
            if (!inner) return;
            const newTarget = resolveTargetFromAnyElement(inner);
            if (!newTarget) return;
            cancelPendingHover();
            pendingHoverTimeout = setTimeout(()=>{
                pendingHoverTimeout = null;
                if (resizingLocalIdRef.current !== null) return;
                 // Dispatch the PM-world bridge OUTSIDE the setState updater. React
                // may invoke updaters more than once (StrictMode, concurrent
                // rendering); a side-effect inside would then dispatch duplicate
                // transactions. We compare against `lastDispatchedHoverPosRef` —
                // not just localId — so re-hovering the same embed after a doc
                // shift re-syncs the plugin to the embed's latest pos.
                //
                // Collab safety: this transaction has no steps and `tr.docChanged`
                // is false, so the collab plugin's `send-transaction.ts` filter
                // (which requires docChanged) will not broadcast it. Verified
                // against editor-plugin-collab-edit/.../send-transaction.ts.
                if (view && lastDispatchedHoverPosRef.current !== newTarget.pos) {
                    lastDispatchedHoverPosRef.current = newTarget.pos;
                    const tr = view.state.tr.setMeta((0, $d598f2eb7a08550e$export$18d4026d1ea86bb1), {
                        type: 'SET_HOVERED_EMBED_POS',
                        pos: newTarget.pos
                    }) // Hover dispatches must never enter the undo stack — they
                    // are pure UI state, not a user-visible doc edit.
                    .setMeta('addToHistory', false);
                    view.dispatch(tr);
                }
                setHoveredTarget((current)=>current?.localId === newTarget.localId ? current : newTarget);
            }, HOVER_DEBOUNCE_MS);
        };
        const handleOut = (event)=>{
            if (resizingLocalIdRef.current !== null) return;
            const me = event;
            const related = me.relatedTarget;
            if (related instanceof Node && isInsideEmbedOrOverlay(related)) return;
            cancelPendingHover();
            pendingHoverTimeout = setTimeout(()=>{
                pendingHoverTimeout = null;
                if (resizingLocalIdRef.current !== null) return;
                 // Clear the tracked hover position so the plugin stops mapping
                // it through transactions. Dispatch outside the setState updater
                // (see handleOver above for rationale) and only when the plugin
                // currently has a non-null pos to clear.
                if (view && lastDispatchedHoverPosRef.current !== null) {
                    lastDispatchedHoverPosRef.current = null;
                    const tr = view.state.tr.setMeta((0, $d598f2eb7a08550e$export$18d4026d1ea86bb1), {
                        type: 'SET_HOVERED_EMBED_POS',
                        pos: null
                    }).setMeta('addToHistory', false);
                    view.dispatch(tr);
                }
                setHoveredTarget(null);
            }, HOVER_DEBOUNCE_MS);
        };
        const unbind = (0, $cbY7C.bindAll)(root, [
            {
                type: 'mouseover',
                listener: handleOver
            },
            {
                type: 'mouseout',
                listener: handleOut
            }
        ]);
        return ()=>{
            cancelPendingHover();
            unbind();
        };
    }, [
        view,
        resolveTargetFromAnyElement
    ]);
    // Hover-overlay alignment with doc changes (CNS-26923 parity for hover).
    // When `hoveredEmbedPos` changes (the PM plugin mapped it through a doc
    // transaction) we re-resolve the hover Target so EmbedResizeOverlay's
    // `useLayoutEffect([target])` re-measures against the embed's current
    // rect. See commit message for the full data-flow rationale.
    //
    // `hoveredTarget` is intentionally omitted from deps: it is owned by
    // this same coordinator and only the `hoveredEmbedPos` change should
    // trigger re-resolution. The `resolveTargetFromAnyElement` dep is for
    // react-hooks/exhaustive-deps compliance only — it changes iff `view`
    // changes (already in the dep list).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $cozmU.useEffect)(()=>{
        if (!view || !hoveredTarget) return;
         // Don't disturb an in-flight resize: rebuilding Target identity
        // re-fires EmbedResizeOverlay's measurement effect mid-drag.
        if (resizingLocalIdRef.current !== null) return;
         // PM signalled that the hovered embed is gone (mapped pos resolved
        // to `null` in `resolveTrackedEmbedPos` — i.e. the node at the
        // mapped pos is no longer a native embed, or the embed was deleted
        // outright). Treat this as the authoritative signal that the hover
        // overlay should be unmounted; otherwise the resize handle bars
        // would linger over empty space until the next pointer movement
        // outside an embed (which may never come — e.g. Backspace deletion
        // fires no `mouseout`). The defensive cleanup effect below cannot
        // catch this on its own because its deps don't observe doc
        // transactions. See lingering-handles repro test.
        if (hoveredEmbedPos === null) {
            lastDispatchedHoverPosRef.current = null;
            setHoveredTarget(null);
            return;
        }
        try {
            const domNode = (0, $bjg0G.findDomRefAtPos)(hoveredEmbedPos, view.domAtPos.bind(view));
            const element = domNode instanceof HTMLElement ? domNode : domNode.parentElement;
            if (!element) return;
            const refreshed = resolveTargetFromAnyElement(element);
            if (!refreshed || refreshed.localId !== hoveredTarget.localId) // The mapped pos resolves to a different embed or nothing —
            // leave the hover target alone; the defensive cleanup handles
            // the case where the hovered embed was deleted.
            return;
             // Hand EmbedResizeOverlay a fresh Target object so its
            // `useLayoutEffect([target, ...])` re-fires and re-measures
            // the embed's current getBoundingClientRect().
            setHoveredTarget(refreshed);
        } catch  {
        // place and let the next hoveredEmbedPos change retry.
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hoveredEmbedPos,
        view,
        resolveTargetFromAnyElement
    ]);
    // Defensive: clear hovered target if its DOM is gone (e.g. collab edit
    // removed the embed) or if it's now also the selected target. We use the
    // view's owner document for the check rather than the global `document`
    // to avoid cross-iframe surprises.
    //
    // IMPORTANT: never clear the hovered target if it currently owns an
    // in-flight resize (e.g. selection just transferred to the embed the
    // hover overlay is dragging). Doing so would unmount the ResizerNext
    // subtree mid-drag and silently cancel the resize.
    (0, $cozmU.useEffect)(()=>{
        if (!hoveredTarget) return;
        if (resizingLocalIdRef.current === hoveredTarget.localId) return;
        const ownerDoc = view?.dom.ownerDocument;
        const inDom = ownerDoc ? ownerDoc.contains(hoveredTarget.container) : false;
        const sameAsSelected = !!selectedTarget && hoveredTarget.localId === selectedTarget.localId;
        if (!inDom || sameAsSelected) setHoveredTarget(null);
    }, [
        hoveredTarget,
        view,
        selectedTarget
    ]);
    if (!view || !portalTarget) return null;
     // Render gating ---------------------------------------------------------
    // Continuous-overlay architecture: we render at most ONE EmbedResizeOverlay
    // per embed, keyed by `localId` rather than by mode. This eliminates a
    // whole class of flicker bugs that previously occurred when the embed
    // transitioned hover→selected (e.g. on mouseup of a hover-driven resize):
    // the old design swapped between two `key`-distinct subtrees, forcing
    // React to unmount/remount ResizerNext, drop measurement refs, and re-run
    // layout effects against the previous frame's width.
    //
    // Now `mode` is just a prop that flips between 'hover' and 'selected'
    // — the same React fiber, ResizerNext instance, and refs survive the
    // transition. The hover-vs-selected DOM signal is preserved via the
    // `data-overlay-mode` attribute the overlay already exposes.
    //
    // Mount priority when both selectedTarget and hoveredTarget exist for the
    // SAME embed: prefer `selectedTarget` (it carries the live
    // `currentAlignment` from the alignment toolbar). When they're different
    // embeds, render both: the selected overlay for the selected embed and a
    // hover overlay for the hovered embed.
    const sameEmbedSelectedAndHovered = !!selectedTarget && !!hoveredTarget && selectedTarget.localId === hoveredTarget.localId; // Whichever overlay we render for the hovered embed (if any) only when
    // it is NOT the selected embed; otherwise we collapse to the single
    // selected-mode overlay.
    const hoverOnlyTarget = sameEmbedSelectedAndHovered ? null : hoveredTarget; // The hover overlay must reflect the *hovered* embed's own alignment,
    // not the selection-scoped `currentAlignment` (which only tracks the
    // selected embed). Without this, side-aligned embeds would show resize
    // handles on both edges while hovered (the wrong edge being draggable
    // would fight the alignment), instead of only the inner edge as in the
    // selected state. Reuses the canonical `getAlignment` helper from the
    // alignment command so the overlay's read of alignment is sourced from
    // the same place the command writes it (single source of truth).
    const hoverAlignment = hoveredTarget ? (0, $45134b38997529c5$export$f0989780f32bfcda)(hoveredTarget.node) : 'center';
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            selectedTarget && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $470ca23c824bbe28$export$a777b135e925da43 // Key by localId — never by mode — so the overlay survives
            ), {
                target: selectedTarget,
                mode: "selected",
                view: view,
                portalTarget: portalTarget,
                pluginInjectionApi: pluginInjectionApi,
                appearance: appearance,
                disabled: !!disabled,
                containerWidth: containerWidth,
                lineLength: lineLength,
                currentAlignment: currentAlignment,
                onAlignmentChange: handleAlignmentChange,
                onResizeStart: handleResizeStart,
                onResizeStop: handleResizeStop
            }, selectedTarget.localId),
            hoverOnlyTarget && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $470ca23c824bbe28$export$a777b135e925da43), {
                target: hoverOnlyTarget,
                mode: "hover",
                view: view,
                portalTarget: portalTarget,
                pluginInjectionApi: pluginInjectionApi,
                appearance: appearance,
                disabled: !!disabled,
                containerWidth: containerWidth,
                lineLength: lineLength,
                currentAlignment: hoverAlignment,
                onResizeStart: handleResizeStart,
                onResizeStop: handleResizeStop
            }, hoverOnlyTarget.localId)
        ]
    });
};


const $c34208975346e1fb$export$fe623d3106c02058 = 'nativeEmbed.resizerNext.testid';
const $c34208975346e1fb$export$e13db278c164b556 = (props)=>{
    const editorViewMode = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.pluginInjectionApi, [
        'editorViewMode'
    ], (states)=>states.editorViewModeState?.mode);
    if (props.disabled || editorViewMode === 'view') return null;
     // eslint-disable-next-line react/jsx-props-no-spreading -- forwards the editor integration props to the coordinator
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $371da16a9a10889f$export$5d91af3986d5a280), {
        ...props
    });
};


const $58b17ee35bdc2adb$var$nativeEmbedLoadingHandler = (node)=>node.extensionKey.startsWith((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)) && (0, $iDrrr.fg)('native_embeds_first_paint_placeholder') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a1ea65fa13d59a50$export$589209289a008d27), {
        node: node
    }) : null;
const $58b17ee35bdc2adb$export$d34fb9a28e944197 = ({ api: api, config: config })=>{
    // Wire up the CardClient for short-link URL resolution when provided via config.
    if (config?.cardClient) (0, $iwIwp.getNativeEmbedFacade)().setCardClient(config.cardClient);
    // Register the native embed transformers with the card plugin so that
    // embedCard nodes are automatically converted to native embed extensions
    // during URL resolution and appearance switching.
    if (api?.card?.actions?.registerEmbedCardTransformer) {
        const cardApi = api.card;
        const coreApi = api.core;
        cardApi.actions.registerEmbedCardTransformer({
            // Curry api into cardToNativeEmbedNode so it can use resolveShortLinkUrl
            // for Confluence short-link expansion without requiring a separate CardClient.
            embedCardNodeTransformer: (schema, attrs)=>(0, $ee20aa2809926709$export$f7e09b33c87279a2)(schema, attrs, {
                    card: cardApi,
                    core: coreApi
                }),
            createEmbedCardTransformCommand: (0, $ee20aa2809926709$export$182f08fa3d19e14d)
        });
    }
    // Register the native embed transformer with the AI plugin so that
    // inserted content nodes can be automatically converted to native embed
    // extensions during AI content insertion.
    api?.aiExperience?.actions?.registerInsertedContentNodeTransformer?.((0, $ee20aa2809926709$export$a3e392087da04055));
    api?.extension?.actions.registerExtensionLoadingHandler({
        extensionType: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
        handler: $58b17ee35bdc2adb$var$nativeEmbedLoadingHandler
    });
    if ((0, $iDrrr.fg)('maui_remixable_page_native_embeds')) api?.aiSelectionContext?.actions?.registerContextExtractor?.('extension', (0, $687681592c67e711$export$1e215007d7182b46));
    return {
        name: 'editorPluginNativeEmbeds',
        actions: {
            cardToNativeEmbedNode: (0, $ee20aa2809926709$export$f7e09b33c87279a2),
            createCardToNativeEmbedTransform: (0, $ee20aa2809926709$export$182f08fa3d19e14d)
        },
        pmPlugins () {
            const analyticsApi = api?.analytics?.actions;
            const undoRedoActions = api?.undoRedoPlugin?.actions;
            return [
                {
                    name: 'nativeEmbedsPluginState',
                    plugin: ()=>(0, $d598f2eb7a08550e$export$ae829ec7b2625219)(analyticsApi, undoRedoActions)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pmState = (0, $d598f2eb7a08550e$export$18d4026d1ea86bb1).getState(editorState);
            if (!pmState) return undefined;
            return {
                trackedEmbedPos: pmState.trackedEmbedPos,
                hoveredEmbedPos: pmState.hoveredEmbedPos,
                width: pmState.resizingWidth || (0, $7Y8M5.akEditorDefaultLayoutWidth),
                isResizing: pmState.isResizing,
                remixVersionTransitions: pmState.remixVersionTransitions,
                selectedEmbed: pmState.selectedEmbed
            };
        },
        contentComponent (params) {
            if (!params.editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c34208975346e1fb$export$e13db278c164b556), {
                disabled: params.disabled,
                editorView: params.editorView,
                pluginInjectionApi: api,
                appearance: params.appearance,
                containerElement: params.containerElement,
                editorActions: params.editorActions,
                eventDispatcher: params.eventDispatcher,
                popupsMountPoint: params.popupsMountPoint,
                providerFactory: params.providerFactory,
                wrapperElement: params.wrapperElement
            });
        },
        pluginsOptions: {
            floatingToolbar: (0, $31267a1dabad5140$export$86ce8f8241c20a3)({
                api: api,
                linkPickerOptions: config?.linkPickerOptions,
                lpLinkPicker: config?.lpLinkPicker,
                onCommentButtonMount: config?.onCommentButtonMount
            })
        }
    };
};
module.exports["nativeEmbedsPlugin"] = $58b17ee35bdc2adb$export$d34fb9a28e944197;

});

parcelRegister("6ClSH", function(module, exports) {

let $4d1743d6a10cc58a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4d1743d6a10cc58a$var$load("6wr18"),
    $4d1743d6a10cc58a$var$load("5YLV5"),
    $4d1743d6a10cc58a$var$load("9njOW"),
    $4d1743d6a10cc58a$var$load("4aKct"),
    $4d1743d6a10cc58a$var$load("7EorR"),
    $4d1743d6a10cc58a$var$load("ffEVr"),
    $4d1743d6a10cc58a$var$load("bY4kf")
]).then(()=>parcelRequire('htIUR'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("1Rod9", function(module, exports) {

var $3ppaK = parcelRequire("3ppaK");

function $33d6ff45ac878a78$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $3ppaK.normalizeFeatureFlags)(featureFlags);
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["createFeatureFlagsFromProps"] = $33d6ff45ac878a78$export$63102b0cbe181144;

});

parcelRegister("6xiPL", function(module, exports) {
let $5cc88dbd91b5e50b$var$prettierFormatterPromise;
let $5cc88dbd91b5e50b$var$sqlFormatterPromise;
const $5cc88dbd91b5e50b$var$stripFinalLineEnding = (content)=>{
    if (content.endsWith('\r\n')) return content.slice(0, -2);
    if (content.endsWith('\n')) return content.slice(0, -1);
    return content;
};



const $5cc88dbd91b5e50b$var$loadPrettierFormatter = ()=>{
    if (!$5cc88dbd91b5e50b$var$prettierFormatterPromise) $5cc88dbd91b5e50b$var$prettierFormatterPromise = Promise.all([
        (parcelRequire("kOKyc")),
        (parcelRequire("8jBZd")),
        (parcelRequire("c8jfa"))
    ]).then(([prettier, babelPlugin, estreePlugin])=>{
        return (content, parser)=>prettier.format(content, {
                parser: parser,
                plugins: [
                    babelPlugin.default,
                    estreePlugin.default
                ]
            }).then($5cc88dbd91b5e50b$var$stripFinalLineEnding);
    }).catch((error)=>{
        $5cc88dbd91b5e50b$var$prettierFormatterPromise = undefined;
        throw error;
    });
    return $5cc88dbd91b5e50b$var$prettierFormatterPromise;
};

const $5cc88dbd91b5e50b$var$loadSqlFormatter = ()=>{
    if (!$5cc88dbd91b5e50b$var$sqlFormatterPromise) $5cc88dbd91b5e50b$var$sqlFormatterPromise = (parcelRequire("ISVhk")).then((formatter)=>formatter.format).catch((error)=>{
        $5cc88dbd91b5e50b$var$sqlFormatterPromise = undefined;
        throw error;
    });
    return $5cc88dbd91b5e50b$var$sqlFormatterPromise;
};
const $5cc88dbd91b5e50b$var$loadPrettierLanguageFormatter = (parser)=>async ()=>{
        const format = await $5cc88dbd91b5e50b$var$loadPrettierFormatter();
        return (content)=>format(content, parser);
    };
const $5cc88dbd91b5e50b$var$loadSqlLanguageFormatter = async ()=>{
    const format = await $5cc88dbd91b5e50b$var$loadSqlFormatter();
    return (content)=>format(content, {
            language: 'sql'
        });
};
const $5cc88dbd91b5e50b$var$languageFormatters = {
    javascript: $5cc88dbd91b5e50b$var$loadPrettierLanguageFormatter('babel'),
    json: $5cc88dbd91b5e50b$var$loadPrettierLanguageFormatter('json'),
    jsx: $5cc88dbd91b5e50b$var$loadPrettierLanguageFormatter('babel'),
    sql: $5cc88dbd91b5e50b$var$loadSqlLanguageFormatter
};
const $5cc88dbd91b5e50b$export$47c66070d6d6cd6d = (language)=>typeof language === 'string' && language in $5cc88dbd91b5e50b$var$languageFormatters;
const $5cc88dbd91b5e50b$export$819465c5ba26e010 = (language)=>$5cc88dbd91b5e50b$var$languageFormatters[language]();


const $9a6bef97c36a75b2$var$preload = async (language)=>{
    if (!(0, $5cc88dbd91b5e50b$export$47c66070d6d6cd6d)(language)) return;
    await (0, $5cc88dbd91b5e50b$export$819465c5ba26e010)(language).catch(()=>undefined);
};
const $9a6bef97c36a75b2$var$formatCode = async ({ content: content, language: language })=>{
    if (!(0, $5cc88dbd91b5e50b$export$47c66070d6d6cd6d)(language)) return {
        errorType: 'formatter-execution-failed',
        language: language,
        status: 'failed'
    };
    const format = await (0, $5cc88dbd91b5e50b$export$819465c5ba26e010)(language).catch(()=>undefined);
    if (!format) return {
        errorType: 'formatter-load-failed',
        language: language,
        status: 'failed'
    };
    let formattedContent;
    try {
        formattedContent = await format(content);
    } catch  {
        return {
            errorType: 'formatter-execution-failed',
            language: language,
            status: 'failed'
        };
    }
    return {
        content: formattedContent,
        language: language,
        status: formattedContent === content ? 'unchanged' : 'formatted'
    };
};
const $9a6bef97c36a75b2$export$213065f4d8d59ac = ()=>({
        formatCode: $9a6bef97c36a75b2$var$formatCode,
        isSupportedLanguage: $5cc88dbd91b5e50b$export$47c66070d6d6cd6d,
        preload: $9a6bef97c36a75b2$var$preload
    });



var $6mKj3 = parcelRequire("6mKj3");

let $d01568efbca88c19$var$codeBlockFormatProvider;
const $d01568efbca88c19$export$8ef3c9ac982ee475 = ()=>{
    if (!(0, $6mKj3.expVal)('platform_editor_code_block_q4_lovability', 'isEnabled', false)) return undefined;
    $d01568efbca88c19$var$codeBlockFormatProvider ?? ($d01568efbca88c19$var$codeBlockFormatProvider = (0, $9a6bef97c36a75b2$export$213065f4d8d59ac)());
    return $d01568efbca88c19$var$codeBlockFormatProvider;
};
module.exports["getCodeBlockFormatProvider"] = $d01568efbca88c19$export$8ef3c9ac982ee475;

});

parcelRegister("kOKyc", function(module, exports) {

let $f27c96210168c8a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f27c96210168c8a0$var$load("8yhpo").then(()=>parcelRequire('HUkVt'));

});

parcelRegister("8jBZd", function(module, exports) {

let $60dd905dab1c4fb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $60dd905dab1c4fb8$var$load("iba7Y").then(()=>parcelRequire('eyRZU'));

});

parcelRegister("c8jfa", function(module, exports) {

let $8d5528c02931abd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d5528c02931abd8$var$load("1O2Ve").then(()=>parcelRequire('b0DMM'));

});

parcelRegister("ISVhk", function(module, exports) {

let $086eb6b56d1d9253$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $086eb6b56d1d9253$var$load("b48dU").then(()=>parcelRequire('gfpM4'));

});

parcelRegister("bcv7k", function(module, exports) {
/**
 * We shouldn't really need this file, as the editor shouldn't require us to pass in
 * a task and decision provider. But for now it does. So this whole thing is a stub.
 */ 
var $dOBRD = parcelRequire("dOBRD");

class $eaaab3ad8fc788e2$var$Provider {
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) this._toggleTaskCallback(objectKey, state);
        return Promise.resolve(state);
    }
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    constructor(toggleTask){
        this._toggleTaskCallback = void 0;
        this._toggleTaskCallback = toggleTask;
    }
}
const $eaaab3ad8fc788e2$export$5405ecb032439dfe = (0, $dOBRD.default)(async (toggleTaskCallback)=>{
    return new $eaaab3ad8fc788e2$var$Provider(toggleTaskCallback);
});
module.exports["getTaskDecisionProvider"] = $eaaab3ad8fc788e2$export$5405ecb032439dfe;

});

parcelRegister("fjhaB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $7Ryt2 = parcelRequire("7Ryt2");

function $cb89921c47be68ab$export$78c2bbd50206cc7f() {
    const [activityProvider, setActivityProvider] = (0, $cozmU.useState)(undefined);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    (0, $cozmU.useEffect)(()=>{
        setActivityProvider((0, $7Ryt2.getActivityProvider)(cloudId));
    }, [
        cloudId
    ]);
    return activityProvider;
}
module.exports["useActivityProvider"] = $cb89921c47be68ab$export$78c2bbd50206cc7f;

});

parcelRegister("9EvUR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $dJyLC = parcelRequire("dJyLC");

function $9c03756095734add$export$e412939fa65e9b05({ contentId: contentId, spaceKey: spaceKey, source: source }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useMemo)(()=>Promise.resolve((0, $dJyLC.createConfluenceAutoformattingProvider)(spaceKey, contentId, createAnalyticsEvent, source)), [
        contentId,
        createAnalyticsEvent,
        spaceKey,
        source
    ]);
}
module.exports["useAutoformattingProvider"] = $9c03756095734add$export$e412939fa65e9b05;

});

parcelRegister("e2Vf0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $kBU5m = parcelRequire("kBU5m");

const $ec33dccf9bb2dcb4$var$i18n = (0, $kSwu1.defineMessages)({
    invalidAltText: {
        id: "editor-features.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});
const $ec33dccf9bb2dcb4$export$cbb71ca960bf2b80 = (0, $dOBRD.default)(({ mediaProvider: mediaProvider, ssrMediaProvider: ssrMediaProvider, intl: intl, featureFlags: featureFlags, mediaViewerExtensions: mediaViewerExtensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
    return {
        provider: mediaProvider,
        syncProvider: ssrMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            const storageSupports = RegExp("^([\\p{L}\\p{N},'.\\s\\-_()]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage($ec33dccf9bb2dcb4$var$i18n.invalidAltText)
            ];
            return [];
        },
        featureFlags: (0, $kBU5m.getMediaFeatureFlags)(featureFlags),
        mediaViewerExtensions: mediaViewerExtensions,
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    };
});
module.exports["getMediaOptions"] = $ec33dccf9bb2dcb4$export$cbb71ca960bf2b80;

});

parcelRegister("dkDqz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $2c3fc5ab77b32b66$export$3238f1bda20b469c = (0, $dOBRD.default)(()=>({
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true
    }));
module.exports["getLayoutOptions"] = $2c3fc5ab77b32b66$export$3238f1bda20b469c;

});

parcelRegister("bY24B", function(module, exports) {
const $0e0fdc78f7a1bae2$var$DEFAULT_EXPAND_OPTIONS = {
    allowInsertion: true,
    allowInteractiveExpand: true
};
const $0e0fdc78f7a1bae2$export$98ec01862577ac69 = ()=>{
    return $0e0fdc78f7a1bae2$var$DEFAULT_EXPAND_OPTIONS;
};
module.exports["useExpandOptions"] = $0e0fdc78f7a1bae2$export$98ec01862577ac69;

});

parcelRegister("jvzGU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $68268dc60793ca56$export$4fc4c895dbb98f6b = ()=>{
    return {
        allowTableResizing: true,
        allowTableAlignment: true,
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowColumnSorting: true,
        allowDistributeColumns: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        allowNestedTables: true,
        allowControls: true,
        stickyHeaders: true,
        allowAddColumnWithCustomStep: false
    };
};


const $83b906b815f15665$export$fddc468cd8cb4db9 = ()=>{
    return (0, $cozmU.useMemo)(()=>(0, $68268dc60793ca56$export$4fc4c895dbb98f6b)(), []);
};
module.exports["useTableOptions"] = $83b906b815f15665$export$fddc468cd8cb4db9;

});

parcelRegister("jO6sX", function(module, exports) {
/**
 * @generated SignedSource<<a9b62471ce29523412c79e09bd6d074d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dcb986cc56874e48$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EditorPreferencesQueryFragment",
    "selections": [
        {
            "concreteType": "ConfluenceEditorSettings",
            "kind": "LinkedField",
            "name": "confluenceEditorSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "toolbarDockingInitialPosition"
                }
            ]
        }
    ],
    "type": "UserPreferences"
};
$dcb986cc56874e48$var$node.hash = "c14a58c792cd6196c5f117a58ba70054";
var $dcb986cc56874e48$export$2e2bcd8739ae039 = $dcb986cc56874e48$var$node;


/**
 * @generated SignedSource<<5d5b83cfc50c2c31f5f5173ccf476851>>
 * @relayHash 1b2bc31ac42719bf8add4db3a6390b58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb
const $185ebb8cafff52fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toolbarDockingInitialPosition"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "toolbarDockingInitialPosition",
                                    "variableName": "toolbarDockingInitialPosition"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "confluenceEditorSettingsInput"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b2bc31ac42719bf8add4db3a6390b58",
            "id": "127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb",
            "metadata": {},
            "name": "EditorPreferencesMutation",
            "operationKind": "mutation",
            "text": "mutation EditorPreferencesMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$185ebb8cafff52fb$var$node.hash = "37475c1d65dabe41f55ac97eba30ddfa";
var $185ebb8cafff52fb$export$2e2bcd8739ae039 = $185ebb8cafff52fb$var$node;



var $cbHql = parcelRequire("cbHql");


var $cozmU = parcelRequire("cozmU");


var $fFmJj = parcelRequire("fFmJj");


var $hp2SH = parcelRequire("hp2SH");


var $bQm3c = parcelRequire("bQm3c");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");

const $57c1a5f1d2d22984$export$6d64c804b8f53798 = (left, right)=>{
    return Object.entries(left).every(([key, value])=>{
        return value === right[key];
    });
};


const $64987b53c225184f$export$e2238e88752bfc4a = [
    'top',
    'none'
];


const $b029ab76b1eb310d$export$c583bb83c793248b = (userPreferences, defaultPreferences)=>{
    const newResolvedUserPreferences = {
        ...defaultPreferences,
        ...Object.fromEntries(Object.entries(userPreferences).filter(([key, value])=>{
            if (key === 'toolbarDockingPosition') return (0, $64987b53c225184f$export$e2238e88752bfc4a).includes(value);
            return value !== undefined && value !== null;
        }))
    };
    return newResolvedUserPreferences;
};


class $b6ee7f3696e07456$export$42096c77943a6f6f {
    /**
   * This method returns the initialized state of the user preferences provider
   * @returns true if the user preferences provider is initialized, false otherwise
   * @example userPreferencesProvider.isInitialized
   */ get isInitialized() {
        return this.initialized;
    }
    /**
   * This method fetches the latest user preferences
   * @returns a promise that resolves with the user preferences, or rejects if error occurs
   * @throws Error if there is an error loading user preferences
   * @example userPreferencesProvider.loadPreferences()
   */ async loadPreferences() {
        const userPreferences = await this.persistenceAPI.loadUserPreferences();
        this.setUserPreferences(userPreferences);
    }
    /**
   * This method updates a user preference
   * @param key
   * @param value
   * @returns a promise that resolves when the user preference is updated
   * @throws Error if there is an error updating user preferences
   * @example userPreferencesProvider.updatePreference('toolbarDockingPosition', 'top')
   */ async updatePreference(key, value) {
        const userPreferences = await this.persistenceAPI.updateUserPreference(key, value);
        this.setUserPreferences(userPreferences);
    }
    /**
   * get a user preference, Note that this function is a not async function,
   * meaning that consumers should prefetch the user preference and make it available initially
   * @param key
   * @returns the user preference
   * @example userPreferencesProvider.getPreference('toolbarDockingPosition')
   */ getPreference(key) {
        return this.resolvedUserPreferences[key];
    }
    /**
   * get all user preferences
   * @returns the user preferences
   * @example userPreferencesProvider.getPreferences()
   */ getPreferences() {
        return this.resolvedUserPreferences;
    }
    /**
   * This method fetches the latest user preferences
   * @param onUpdate
   * @returns a function to unsubscribe from the updates
   * @example
   */ onUpdate(onUpdate) {
        this.updateCallbacks.push(onUpdate);
        // Return the cleanup function to unsubscribe from the updates
        return ()=>{
            this.updateCallbacks = this.updateCallbacks.filter((callback)=>callback !== onUpdate);
        };
    }
    /**
   * This method is used to set the default user preferences,
   * setting the default user preferences will also trigger an update
   * This is useful when the default user preferences dynamically based on the context
   * @param preferences
   * @example
   */ setDefaultPreferences(preferences) {
        this.defaultPreferences = preferences;
        const hasUpdated = this.resolveUserPreferences();
        if (hasUpdated) this.notifyUserPreferencesUpdated();
    }
    setUserPreferences(userPreferences) {
        this.userPreferences = userPreferences;
        const hasUpdated = this.resolveUserPreferences();
        if (hasUpdated || !this.initialized) {
            if (!this.initialized) this.initialized = true;
            this.notifyUserPreferencesUpdated();
        }
    }
    /**
   * This method is used to notify the user preferences updated
   * @example userPreferencesProvider.notifyUserPreferencesUpdated()
   */ notifyUserPreferencesUpdated() {
        this.updateCallbacks.forEach((callback)=>{
            callback(this.resolvedUserPreferences);
        });
    }
    /**
   * This method resolves the user preferences by merging the default preferences
   * with the user preferences and filtering out any undefined or null values
   * to avoid overwriting default preferences with null values
   * @returns true if the user preferences were updated, false otherwise
   * @example userPreferencesProvider.resolveUserPreferences()
   */ resolveUserPreferences() {
        // Merge default preferences with user preferences
        // and filter out any undefined or null values
        // to avoid overwriting default preferences with null values
        const newResolvedUserPreferences = (0, $b029ab76b1eb310d$export$c583bb83c793248b)(this.userPreferences, this.defaultPreferences);
        // if the user preferences is NOT initialized, we need to update and notify
        // the user preferences
        // if the user preferences is initialized, we need to check if the new user preferences
        // is different from the old user preferences
        const isSame = (0, $57c1a5f1d2d22984$export$6d64c804b8f53798)(newResolvedUserPreferences, this.resolvedUserPreferences);
        const needUpdate = !isSame;
        if (needUpdate) this.resolvedUserPreferences = newResolvedUserPreferences;
        return needUpdate;
    }
    /**
   * This is the constructor for the UserPreferencesProvider class.
   * @param persistenceAPI - The persistence API to use for loading and updating user preferences
   * @param defaultPreferences - The default user preferences to use
   * @param initialUserPreferences - The initial user preferences to use (optional)
   * @example const userPreferencesProvider = new UserPreferencesProvider(persistenceAPI, defaultPreferences);
   */ constructor(persistenceAPI, defaultPreferences){
        this.updateCallbacks = [];
        this.userPreferences = {};
        this.defaultPreferences = void 0;
        this.resolvedUserPreferences = void 0;
        this.initialized = false;
        this.persistenceAPI = void 0;
        this.persistenceAPI = persistenceAPI;
        this.defaultPreferences = defaultPreferences;
        this.resolvedUserPreferences = defaultPreferences;
        const initialUserPreferences = this.persistenceAPI.getInitialUserPreferences?.();
        if (initialUserPreferences) this.setUserPreferences(initialUserPreferences);
        // the initial user preferences might come from the local cache,
        // so we need to always load the preferences
        this.loadPreferences();
    }
}




var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");











var $1UApO = parcelRequire("1UApO");





/**
 * @generated SignedSource<<c8150b45e41048bfba095ba618c09c83>>
 * @relayHash abbe28b997f121d37d2a6bcf9de50587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec
const $90a65d92fac4dfbd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toolbarDockingInitialPosition"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "toolbarDockingInitialPosition",
                                    "variableName": "toolbarDockingInitialPosition"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "confluenceEditorSettingsInput"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorUserPreferencesProviderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorUserPreferencesProviderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "abbe28b997f121d37d2a6bcf9de50587",
            "id": "f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec",
            "metadata": {},
            "name": "EditorUserPreferencesProviderMutation",
            "operationKind": "mutation",
            "text": "mutation EditorUserPreferencesProviderMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$90a65d92fac4dfbd$var$node.hash = "58cff6da35ff84f165c997ef5ed48166";
var $90a65d92fac4dfbd$export$2e2bcd8739ae039 = $90a65d92fac4dfbd$var$node;


/**
 * @generated SignedSource<<68f3663927156d076fc22d8e424efb71>>
 * @relayHash 63854a4c84372d699a45f9c1a07dc352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e
const $e4a48aa60613f0b2$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorUserPreferencesProviderQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorUserPreferencesProviderQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "63854a4c84372d699a45f9c1a07dc352",
            "id": "3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e",
            "metadata": {},
            "name": "EditorUserPreferencesProviderQuery",
            "operationKind": "query",
            "text": "query EditorUserPreferencesProviderQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$e4a48aa60613f0b2$var$node.hash = "22c44eb8a7e5e6240c1d402a68a09da0";
var $e4a48aa60613f0b2$export$2e2bcd8739ae039 = $e4a48aa60613f0b2$var$node;












var $7W8i8 = parcelRequire("7W8i8");







const $087f019a02b7077e$var$logger = (0, $7W8i8.getLogger)('EditorControlsPinningPreference');
const $087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED;
const $087f019a02b7077e$var$getLocalStorageItem = ()=>{
    try {
        const itemString = (0, $17wUi.confluenceLocalStorageInstance).getItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY);
        if (!itemString) return undefined;
        const item = JSON.parse(itemString);
        if (typeof item === 'object' && item !== null && !Array.isArray(item) && Object.keys(item).every((key)=>[
                'toolbar-top',
                'toolbar-inline'
            ].includes(key))) return item;
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error parsing local storage key(${$087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY}): ${error}`;
    }
    return undefined;
};
const $087f019a02b7077e$export$1f63bcf565c85af4 = (bannerType)=>{
    let item = $087f019a02b7077e$var$getLocalStorageItem();
    if (!item) item = {
        [bannerType]: {
            count: 0
        }
    };
    else {
        const existingDismissal = item[bannerType];
        item[bannerType] = {
            ...existingDismissal,
            count: 0
        };
    }
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error setting local storage key(${$087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY}): ${error}`;
    }
};



var $l1uFv = parcelRequire("l1uFv");











var $jO6sX = parcelRequire("jO6sX");

const $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery = (0, $e4a48aa60613f0b2$export$2e2bcd8739ae039);
const $fa29ff75a45929c5$var$EditorUserPreferencesProviderMutation = (0, $90a65d92fac4dfbd$export$2e2bcd8739ae039);
var $fa29ff75a45929c5$var$Status = /*#__PURE__*/ function(Status) {
    Status["Complete"] = "complete";
    Status["Error"] = "error";
    Status["Pending"] = "pending";
    return Status;
}($fa29ff75a45929c5$var$Status || {});
const $fa29ff75a45929c5$export$48d7c418edadb60c = ()=>Boolean(undefined);
class $fa29ff75a45929c5$export$7f7007b732b93d85 {
    // synchronously load preferences from cache
    loadPreferencesFromCache() {
        if (!$fa29ff75a45929c5$export$48d7c418edadb60c()) {
            const userPreferenceStorage = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES);
            if (userPreferenceStorage) this.userPreferences = JSON.parse(userPreferenceStorage);
        }
        if (!this.apolloClient) return undefined;
        try {
            const result = (0, $l1uFv.readQueryInterop)({
                query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
                __callerPackage__: "editor-presets"
            });
            if (result?.userPreferences) {
                this.userPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(result.userPreferences?.confluenceEditorSettings);
                // if we have a cached value, we can set the status to complete
                // since we are not going to make a network request
                // to fetch the preferences with loadPreferencesInternal and not skipCache
                if (this.providerStatus !== "complete") this.providerStatus = "complete";
            }
            return this.userPreferences;
        } catch  {
            return this.userPreferences;
        }
    }
    async loadPreferencesInternal(options) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
            fetchPolicy: options?.skipCache ? 'no-cache' : 'cache-first',
            __callerPackage__: "editor-presets"
        });
        this.userPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(data?.userPreferences?.confluenceEditorSettings);
        this.updateLocalStorage();
        return this.userPreferences;
    }
    async loadPreferences() {
        try {
            const userPreferences = await this.loadPreferencesInternal({
                skipCache: true
            });
            // can recover from the status previous error
            if (this.providerStatus !== "complete") this.providerStatus = "complete";
            return userPreferences;
        } catch (error) {
            // We will ignore subssequent errors if thte status was complete
            // And will use the data from previous request
            if (this.providerStatus !== "complete") this.providerStatus = "error";
            return Promise.reject(error);
        }
    }
    updateLocalStorage() {
        if (!$fa29ff75a45929c5$export$48d7c418edadb60c()) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES, JSON.stringify(this.userPreferences));
    }
    async updatePreference(key, value) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        const variables = {
            [key]: value
        };
        this.userPreferences[key] = value;
        const { data: data } = await (0, $6s78L.mutateInterop)({
            mutation: $fa29ff75a45929c5$var$EditorUserPreferencesProviderMutation,
            variables: variables,
            update: ()=>{
                // this is required to indicate toolbar changes to any useQuery for EditorPreferencesQuery, particularly progressive object header
                const getValue = ()=>value ?? null;
                (0, $fEmGS.writeQueryInterop)({
                    query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
                    data: {
                        userPreferences: {
                            __typename: 'UserPreferences',
                            confluenceEditorSettings: {
                                __typename: 'ConfluenceEditorSettings',
                                toolbarDockingInitialPosition: getValue()
                            }
                        }
                    },
                    __callerPackage__: "editor-presets"
                });
            },
            __callerPackage__: "editor-presets"
        });
        const updatedUserPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(data?.updateUserPreferences?.confluenceEditorSettings);
        this.userPreferences = {
            ...this.userPreferences,
            ...updatedUserPreferences
        };
        if (value === 'top') (0, $087f019a02b7077e$export$1f63bcf565c85af4)('toolbar-inline');
        else if (value === 'none') (0, $087f019a02b7077e$export$1f63bcf565c85af4)('toolbar-top');
        this.updateLocalStorage();
    }
    getPreference(key) {
        const fallbackUserPreferences = this.getFallbackUserPreferences?.() || {};
        return this.userPreferences[key] || fallbackUserPreferences[key];
    }
    constructor(options = {}){
        this.userPreferences = {};
        this.getFallbackUserPreferences = void 0;
        // We use getApolloClient to get the apollo client instance
        // This is to avoid adding required apollo context
        this.apolloClient = (0, $hp2SH.getApolloClient)();
        this.providerStatus = "pending";
        this.getFallbackUserPreferences = options.getFallbackUserPreferences;
        this.loadPreferencesFromCache();
        this.loadPreferencesInternal().then(()=>{
            this.providerStatus = "complete";
        }).catch(()=>{
            this.providerStatus = "error";
        });
    }
}


const $5fb34be1fffb3f33$var$parseConfluenceEditorSettings = (confluenceEditorSettings)=>{
    if (confluenceEditorSettings) {
        const result = {};
        const entries = Object.entries(confluenceEditorSettings);
        for (const [key, value] of entries){
            if (key === 'toolbarDockingInitialPosition' && value && (0, $64987b53c225184f$export$e2238e88752bfc4a).includes(value)) result.toolbarDockingPosition = value;
            else if (value !== null && value !== undefined) // Pass through other settings as-is
            result[key] = value;
        }
        return result;
    }
    return {};
};
const $5fb34be1fffb3f33$var$updateLocalStorage = (userPreferences)=>{
    // confluenceLocalStorageInstance is only available in the browser environment
    if (!(0, $fa29ff75a45929c5$export$48d7c418edadb60c)() && (0, $17wUi.confluenceLocalStorageInstance)) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES, JSON.stringify(userPreferences));
};
class $5fb34be1fffb3f33$export$acb1a00758cac9cd {
    setIsLoggedIn(isLoggedin) {
        this.isLoggedin = isLoggedin;
    }
    getInitialUserPreferences() {
        let initialUserPreferences;
        try {
            if (this.readFragmentInterop) {
                const result = this.readFragmentInterop({
                    id: `$ROOT_QUERY.userPreferences`
                });
                if (result) initialUserPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(result.confluenceEditorSettings);
            }
        } catch  {
            initialUserPreferences = undefined;
        }
        // If we don't have values from the Apollo cache, we try to fetch from local storage
        if (!initialUserPreferences && !(0, $fa29ff75a45929c5$export$48d7c418edadb60c)()) try {
            const userPreferenceStorage = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES);
            if (userPreferenceStorage) initialUserPreferences = JSON.parse(userPreferenceStorage);
        } catch  {
            // If the local storage is corrupted or not available, we ignore the error and return undefined
            initialUserPreferences = undefined;
        }
        return initialUserPreferences;
    }
    async updateUserPreference(key, value) {
        if (!this.isLoggedin) // If the user is not logged in, we return the key with updated value
        // This is to ensure that the editor can still function without flaws
        // but the value will not be persisted to the server
        return Promise.resolve({
            [key]: value
        });
        // we only support updating the toolbarDockingInitialPosition preference ATM,
        // need to update this if we add more preferences
        const variables = {
            toolbarDockingInitialPosition: value
        };
        try {
            const { data: data } = await (0, $6s78L.mutateInterop)({
                mutation: (0, $185ebb8cafff52fb$export$2e2bcd8739ae039),
                variables: variables,
                __callerPackage__: "editor-presets"
            });
            // this is required to indicate toolbar changes to any useQuery for EditorPreferencesQuery, particularly progressive object header
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $cbHql.default),
                data: {
                    userPreferences: {
                        __typename: 'UserPreferences',
                        confluenceEditorSettings: {
                            toolbarDockingInitialPosition: value ?? null
                        }
                    }
                },
                __callerPackage__: "editor-presets"
            });
            const userPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(data?.updateUserPreferences?.confluenceEditorSettings);
            $5fb34be1fffb3f33$var$updateLocalStorage(userPreferences);
            return {
                [key]: userPreferences[key]
            };
        } catch  {
            // In case of an error, we return the key with updated value
            // This is to ensure that the editor can still function without flaws
            // but the value might not be persisted to the server
            return {
                [key]: value
            };
        }
    }
    async loadUserPreferences() {
        let userPreferences = {};
        if (!this.isLoggedin) // If the user is not logged in, we return an empty object
        return Promise.resolve(userPreferences);
        try {
            // first time we load we use cache-first policy to avoid unnecessary network requests
            // after the first load we always use no-cache to ensure we have the latest preferences
            // this is particularly important when user has multiple tabs open and changes preferences in one tab
            // we want to ensure other tabs have the latest preferences
            const fetchPolicy = !this.isInitialLoad && (0, $6mKj3.expVal)('cc_editor_preferences_query_optimisation', 'isEnabled', false) ? 'cache-first' : 'no-cache';
            this.isInitialLoad = true;
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: (0, $cbHql.default),
                fetchPolicy: fetchPolicy,
                __callerPackage__: "editor-presets"
            });
            userPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(data?.userPreferences?.confluenceEditorSettings);
            $5fb34be1fffb3f33$var$updateLocalStorage(userPreferences);
            return userPreferences;
        } catch  {
            // if upload local storage fails, we will still return the user preferences
            return userPreferences;
        }
    }
    constructor(isLoggedin = true, readFragmentInterop){
        this.readFragmentInterop = void 0;
        this.isLoggedin = true;
        this.isInitialLoad = false;
        this.setIsLoggedIn(isLoggedin);
        this.readFragmentInterop = readFragmentInterop;
    }
}
const $5fb34be1fffb3f33$export$c53529b5ad54089d = (options)=>{
    const persistenceAPI = options.persistenceAPI || new $5fb34be1fffb3f33$export$acb1a00758cac9cd(undefined, options.readFragmentInterop);
    return new (0, $b6ee7f3696e07456$export$42096c77943a6f6f)(persistenceAPI, {
        toolbarDockingPosition: options.isLivePage ? 'none' : 'top'
    });
};


const $0d17c8f0adf5cf3d$var$EditorPreferencesQuery = (0, $cbHql.default);
const $0d17c8f0adf5cf3d$var$EditorPreferencesMutation = (0, $185ebb8cafff52fb$export$2e2bcd8739ae039);
const $0d17c8f0adf5cf3d$export$3ece90ca9e31f585 = (confluenceEditorSettings)=>{
    if (confluenceEditorSettings && confluenceEditorSettings) return confluenceEditorSettings;
    return {};
};
class $0d17c8f0adf5cf3d$export$accffe59bc474b30 {
    init() {
        if (!this.initialized) this.fetchPreferences().catch(()=>{
        // Do nothing
        });
    }
    // add this to implment the UserPreferensProvider interface.
    loadPreferences() {
        return Promise.reject();
    }
    async fetchPreferences() {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        try {
            if (!this.initialized) {
                const { data: data } = await (0, $c0rhi.queryInterop)({
                    query: $0d17c8f0adf5cf3d$var$EditorPreferencesQuery,
                    __callerPackage__: "editor-presets"
                });
                this.userPreferences = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585(data?.userPreferences?.confluenceEditorSettings);
                this.initialized = true;
            }
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async updatePreference(key, value) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        this.userPreferences[key] = value;
        const variables = {
            [key]: value
        };
        try {
            const response = await (0, $6s78L.mutateInterop)({
                mutation: $0d17c8f0adf5cf3d$var$EditorPreferencesMutation,
                variables: variables,
                update: ()=>{
                    // this is required to indicate toolbar changes to progressive object header
                    (0, $fEmGS.writeQueryInterop)({
                        query: $0d17c8f0adf5cf3d$var$EditorPreferencesQuery,
                        data: {
                            userPreferences: {
                                __typename: 'UserPreferences',
                                confluenceEditorSettings: {
                                    __typename: 'ConfluenceEditorSettings',
                                    toolbarDockingInitialPosition: value === 'top' ? value : null // Null is required since apollo cache uses shallow reference equality
                                }
                            }
                        },
                        __callerPackage__: "editor-presets"
                    });
                },
                __callerPackage__: "editor-presets"
            });
            const confluenceEditorSettings = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585(response.data?.updateUserPreferences?.confluenceEditorSettings);
            this.userPreferences[key] = confluenceEditorSettings[key];
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
    getPreference(key) {
        return this.userPreferences[key];
    }
    constructor(){
        this.userPreferences = {};
        // We use getApolloClient to get the apollo client instance
        // This is to avoid adding required apollo context
        this.apolloClient = (0, $hp2SH.getApolloClient)();
        this.initialized = false;
        this.init();
    }
}
const $0d17c8f0adf5cf3d$export$c88c6b9f15f77aea = (options)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const editorPreferencesProvider = (0, $cozmU.useRef)();
    const persistenceAPI = (0, $cozmU.useRef)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $dcb986cc56874e48$export$2e2bcd8739ae039),
        __callerPackage__: "editor-presets"
    });
    if (!editorPreferencesProvider.current) {
        const isLivePage = options?.getCurrentIsLivePage?.() ?? false;
        persistenceAPI.current = new (0, $5fb34be1fffb3f33$export$acb1a00758cac9cd)(isLoggedIn, readFragmentInterop);
        editorPreferencesProvider.current = (0, $5fb34be1fffb3f33$export$c53529b5ad54089d)({
            isLivePage: isLivePage,
            persistenceAPI: persistenceAPI.current,
            readFragmentInterop: readFragmentInterop
        });
    }
    (0, $cozmU.useEffect)(()=>{
        if (persistenceAPI.current) persistenceAPI.current.setIsLoggedIn(isLoggedIn);
    }, [
        isLoggedIn
    ]);
    return {
        editorPreferencesProvider: editorPreferencesProvider.current ?? undefined
    };
};
module.exports["parseConfluenceEditorSettings"] = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585;
module.exports["useEditorPreferencesProvider"] = $0d17c8f0adf5cf3d$export$c88c6b9f15f77aea;

});

parcelRegister("4oS56", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a02892cdeb8a3601$export$be6a93f320014444 = (0, $cozmU.createContext)({
    item: null,
    setItem: ()=>{},
    removeItem: ()=>{},
    editorAPI: undefined
});
module.exports["EditorContextPanelContext"] = $a02892cdeb8a3601$export$be6a93f320014444;

});


//# sourceMappingURL=FullPageEditorComponent.c9b7709e.js.map
